/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * DashBoard
 * OpenAPI spec version: v2.0.0
 */
import { useMutation, useQuery } from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';

import type {
  AddColumnsToSchemaRequest,
  AlertDto,
  AlertExecutionDto,
  AnnotationDto,
  AnnotationsDataDto,
  AssignTicketRequestDto,
  BulkVariableScadaDto,
  ChartAnnotationsDto,
  ChartQueryDto,
  ChartQueryFilterRequestDto,
  CheckTaskRequestDto,
  CheckVariableTaskRequestDto,
  ClientDto,
  ClientStatisticsResponseDto,
  CreateAlertDto,
  CreateAlertExecutionDto,
  CreateAnnotationDto,
  CreateAnnotationsDataDto,
  CreateChartAnnotationsDto,
  CreateChartQueryDto,
  CreateClientDto,
  CreateCsvRecordBatchItemRequest,
  CreateCsvRecordRequest,
  CreateCsvSchemaRequest,
  CreateDashboardDto,
  CreateDashboardGroupDto,
  CreateDataExportDto,
  CreateDeviceDto,
  CreateDiagramDto,
  CreateDiagramEdgeDto,
  CreateDiagramNodeDto,
  CreateEditRemoveResponseDto,
  CreateLayoutDto,
  CreateNotificationDto,
  CreatePlantDto,
  CreateResponseDto,
  CreateRoleDto,
  CreateRolePermissionDto,
  CreateSubscriptionSourceDto,
  CreateTableAdvanceDto,
  CreateTableDto,
  CreateTaskFormulaDto,
  CreateTaskSimpleDto,
  CreateTelegramGroupDto,
  CreateTemplateExportScheduleDto,
  CreateTicketDto,
  CreateUserDto,
  CreateVariableDto,
  CreateVariableScadaDto,
  CreateVariableTaskDto,
  CreateZoneDto,
  CsvColumnResponse,
  CsvColunmDto,
  CsvRecordFilterRequestDto,
  CsvRecordResponse,
  CsvRecordResponsePaginatedResponseDto,
  CsvSchemaResponse,
  DashboardDto,
  DashboardGroupDto,
  DataRangeExportDto,
  DeleteApiClientsIdParams,
  DeleteApiPlantsParams,
  DeleteApiSubscriptionSourcesIdParams,
  DeleteApiTablesIdParams,
  DeleteApiTasksTaskIdMetricsParams,
  DeleteApiTelegramClientRemoveGroupParams,
  DeleteApiVariablesDeviceParams,
  DeleteApiVariablesParams,
  DeleteApiZonesIdParams,
  DiagramBulkPositionUpdateRequest,
  DiagramDto,
  DiagramEdgeDto,
  DiagramNodeDto,
  EnviarAlertaRequest,
  ExecuteTasksInRangeRequestDto,
  ForgotPasswordRequestDto,
  GetApiAlertsExecutionParams,
  GetApiAlertsParams,
  GetApiAnnotationsDataByAnnotationDatesParams,
  GetApiAnnotationsDataByDatesParams,
  GetApiAnnotationsDataParams,
  GetApiAnnotationsParams,
  GetApiAuditParams,
  GetApiChartAnnotationsParams,
  GetApiClientsParams,
  GetApiCsvRecordsSchemaSchemaIdParams,
  GetApiDashboardGroupsByPlantParams,
  GetApiDashboardGroupsGetListAdminParams,
  GetApiDashboardGroupsParams,
  GetApiDashboardsParams,
  GetApiDiagramsIdParams,
  GetApiDiagramsParams,
  GetApiExportByUserUserIdParams,
  GetApiExportParams,
  GetApiExportTemplateTemplateIdDownloadParams,
  GetApiNotificationsAdminParams,
  GetApiNotificationsParams,
  GetApiPlantsParams,
  GetApiRoleParams,
  GetApiRolePermissionsByEntityParams,
  GetApiRolePermissionsByRoleRoleIdParams,
  GetApiRolePermissionsFilteredParams,
  GetApiRolePermissionsIdParams,
  GetApiRolePermissionsParams,
  GetApiSubscriptionSourcesParams,
  GetApiTablesAdvanceParams,
  GetApiTablesParams,
  GetApiTasksExecutionResultsExecutionIdParams,
  GetApiTasksFormulaParams,
  GetApiTasksParams,
  GetApiTasksSimpleParams,
  GetApiTasksTreeParams,
  GetApiTicketsAdminParams,
  GetApiTicketsParams,
  GetApiUsersParams,
  GetApiVariablesDevicesParams,
  GetApiVariablesExportDataParams,
  GetApiVariablesGetDataFromVariableIdParams,
  GetApiVariablesGetTaskFormulaVariableValuesParams,
  GetApiVariablesInputsParams,
  GetApiVariablesParams,
  GetApiVariablesScadaByPlantIdParams,
  GetApiVariablesScadaByTableIdParams,
  GetApiVariablesScadaByZoneIdParams,
  GetApiVariablesScadaParams,
  GetApiVariablesTaskByPlantIdParams,
  GetApiVariablesTaskByZoneIdParams,
  GetApiVariablesTaskTreeParams,
  GetApiVariablesTasksCheckExecutionsInRangeParams,
  GetApiVariablesTasksExecutionResultsExecutionIdParams,
  GetApiVariablesTasksParams,
  GetApiZonesParams,
  LayoutDto,
  LoginRequestDto,
  Metric,
  PlantDto,
  PostApiCsvRecordsFilterParams,
  PostApiExportTemplateBody,
  PostApiInstallerUploadBody,
  PostApiTasksSaveExecutionResultsExecutionIdParams,
  PostApiUsersSuperadminCheckParams,
  PostApiVariablesScadaParams,
  ProblemDetails,
  PutApiExportTemplateIdFileBody,
  PutApiPlantStatusDockerUpdateAllParams,
  PutApiPlantStatusPlantIdDockerUpdateParams,
  PutApiPlantStatusPlantIdScadaChangedParams,
  PutApiPlantsParams,
  PutApiVariablesTaskParams,
  RefreshTokenRequestDto,
  ResetPasswordRequestDto,
  RoleDto,
  RolePermissionDto,
  SendMailRequestDto,
  SendTemplateExportRequestDto,
  SendTemplatedMailRequestDto,
  StatisticsResponseDto,
  TableAdvanceDto,
  TableDto,
  TestTaskRequestDto,
  TestVariableTaskRequestDto,
  UpdateCsvColumnRequestDto,
  UpdateCsvSchemaRequestDto,
  UpdateDataExportRequestDto,
  UpdateDataRangeRequestDto,
  UpdateDiagramRequestDto,
  UpdateExportTemplateRequest,
  UpdateSubscriptionSourceDto,
  UpdateTaskFormulaRequestDto,
  UpdateTaskSimpleRequestDto,
  UpdateTemplateExportScheduleRequestDto,
  UpdateTicketStatusRequestDto,
  VariableDto,
  VariableScadaDto,
  VariableTaskDto,
  ZoneDto,
} from './model';

import { axiosInstance } from '../../config2/axiosConfig';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const postApiAlerts = (
  createAlertDto: CreateAlertDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Alerts`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createAlertDto,
      signal,
    },
    options
  );
};

export const getPostApiAlertsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAlerts>>,
    TError,
    { data: CreateAlertDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAlerts>>,
  TError,
  { data: CreateAlertDto },
  TContext
> => {
  const mutationKey = ['postApiAlerts'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiAlerts>>,
    { data: CreateAlertDto }
  > = props => {
    const { data } = props ?? {};

    return postApiAlerts(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiAlertsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiAlerts>>
>;
export type PostApiAlertsMutationBody = CreateAlertDto;
export type PostApiAlertsMutationError = unknown;

export const usePostApiAlerts = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAlerts>>,
    TError,
    { data: CreateAlertDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiAlerts>>,
  TError,
  { data: CreateAlertDto },
  TContext
> => {
  const mutationOptions = getPostApiAlertsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiAlerts = (
  alertDto: AlertDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/Alerts`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: alertDto,
    },
    options
  );
};

export const getPutApiAlertsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiAlerts>>,
    TError,
    { data: AlertDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiAlerts>>,
  TError,
  { data: AlertDto },
  TContext
> => {
  const mutationKey = ['putApiAlerts'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiAlerts>>,
    { data: AlertDto }
  > = props => {
    const { data } = props ?? {};

    return putApiAlerts(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiAlertsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiAlerts>>
>;
export type PutApiAlertsMutationBody = AlertDto;
export type PutApiAlertsMutationError = unknown;

export const usePutApiAlerts = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiAlerts>>,
    TError,
    { data: AlertDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiAlerts>>,
  TError,
  { data: AlertDto },
  TContext
> => {
  const mutationOptions = getPutApiAlertsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiAlerts = (
  params?: GetApiAlertsParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Alerts`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiAlertsQueryKey = (params?: GetApiAlertsParams) => {
  return [`/api/Alerts`, ...(params ? [params] : [])] as const;
};

export const getGetApiAlertsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAlerts>>,
  TError = unknown,
>(
  params?: GetApiAlertsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAlerts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiAlertsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAlerts>>> = ({
    signal,
  }) => getApiAlerts(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAlerts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiAlertsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAlerts>>
>;
export type GetApiAlertsQueryError = unknown;

export function useGetApiAlerts<
  TData = Awaited<ReturnType<typeof getApiAlerts>>,
  TError = unknown,
>(
  params?: GetApiAlertsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAlerts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiAlertsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiAlertsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Alerts/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiAlertsIdQueryKey = (id?: number) => {
  return [`/api/Alerts/${id}`] as const;
};

export const getGetApiAlertsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAlertsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAlertsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiAlertsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAlertsId>>> = ({
    signal,
  }) => getApiAlertsId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAlertsId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiAlertsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAlertsId>>
>;
export type GetApiAlertsIdQueryError = unknown;

export function useGetApiAlertsId<
  TData = Awaited<ReturnType<typeof getApiAlertsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAlertsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiAlertsIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteApiAlertsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/Alerts/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiAlertsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiAlertsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiAlertsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiAlertsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiAlertsId>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiAlertsId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiAlertsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiAlertsId>>
>;

export type DeleteApiAlertsIdMutationError = unknown;

export const useDeleteApiAlertsId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiAlertsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiAlertsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteApiAlertsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiAlertsByPlantPlantId = (
  plantId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Alerts/byPlant/${plantId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiAlertsByPlantPlantIdQueryKey = (plantId?: number) => {
  return [`/api/Alerts/byPlant/${plantId}`] as const;
};

export const getGetApiAlertsByPlantPlantIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAlertsByPlantPlantId>>,
  TError = unknown,
>(
  plantId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAlertsByPlantPlantId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiAlertsByPlantPlantIdQueryKey(plantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiAlertsByPlantPlantId>>
  > = ({ signal }) =>
    getApiAlertsByPlantPlantId(plantId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!plantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAlertsByPlantPlantId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiAlertsByPlantPlantIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAlertsByPlantPlantId>>
>;
export type GetApiAlertsByPlantPlantIdQueryError = unknown;

export function useGetApiAlertsByPlantPlantId<
  TData = Awaited<ReturnType<typeof getApiAlertsByPlantPlantId>>,
  TError = unknown,
>(
  plantId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAlertsByPlantPlantId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiAlertsByPlantPlantIdQueryOptions(
    plantId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiAlertsByVariableVariableId = (
  variableId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Alerts/byVariable/${variableId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiAlertsByVariableVariableIdQueryKey = (
  variableId?: number
) => {
  return [`/api/Alerts/byVariable/${variableId}`] as const;
};

export const getGetApiAlertsByVariableVariableIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAlertsByVariableVariableId>>,
  TError = unknown,
>(
  variableId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAlertsByVariableVariableId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiAlertsByVariableVariableIdQueryKey(variableId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiAlertsByVariableVariableId>>
  > = ({ signal }) =>
    getApiAlertsByVariableVariableId(variableId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!variableId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAlertsByVariableVariableId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiAlertsByVariableVariableIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAlertsByVariableVariableId>>
>;
export type GetApiAlertsByVariableVariableIdQueryError = unknown;

export function useGetApiAlertsByVariableVariableId<
  TData = Awaited<ReturnType<typeof getApiAlertsByVariableVariableId>>,
  TError = unknown,
>(
  variableId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAlertsByVariableVariableId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiAlertsByVariableVariableIdQueryOptions(
    variableId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiAlertsByZoneZoneId = (
  zoneId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Alerts/byZone/${zoneId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiAlertsByZoneZoneIdQueryKey = (zoneId?: number) => {
  return [`/api/Alerts/byZone/${zoneId}`] as const;
};

export const getGetApiAlertsByZoneZoneIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAlertsByZoneZoneId>>,
  TError = unknown,
>(
  zoneId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAlertsByZoneZoneId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiAlertsByZoneZoneIdQueryKey(zoneId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiAlertsByZoneZoneId>>
  > = ({ signal }) => getApiAlertsByZoneZoneId(zoneId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!zoneId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAlertsByZoneZoneId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiAlertsByZoneZoneIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAlertsByZoneZoneId>>
>;
export type GetApiAlertsByZoneZoneIdQueryError = unknown;

export function useGetApiAlertsByZoneZoneId<
  TData = Awaited<ReturnType<typeof getApiAlertsByZoneZoneId>>,
  TError = unknown,
>(
  zoneId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAlertsByZoneZoneId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiAlertsByZoneZoneIdQueryOptions(zoneId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiAlertsExecution = (
  createAlertExecutionDto: CreateAlertExecutionDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Alerts/execution`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createAlertExecutionDto,
      signal,
    },
    options
  );
};

export const getPostApiAlertsExecutionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAlertsExecution>>,
    TError,
    { data: CreateAlertExecutionDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAlertsExecution>>,
  TError,
  { data: CreateAlertExecutionDto },
  TContext
> => {
  const mutationKey = ['postApiAlertsExecution'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiAlertsExecution>>,
    { data: CreateAlertExecutionDto }
  > = props => {
    const { data } = props ?? {};

    return postApiAlertsExecution(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiAlertsExecutionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiAlertsExecution>>
>;
export type PostApiAlertsExecutionMutationBody = CreateAlertExecutionDto;
export type PostApiAlertsExecutionMutationError = unknown;

export const usePostApiAlertsExecution = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAlertsExecution>>,
    TError,
    { data: CreateAlertExecutionDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiAlertsExecution>>,
  TError,
  { data: CreateAlertExecutionDto },
  TContext
> => {
  const mutationOptions = getPostApiAlertsExecutionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiAlertsExecution = (
  alertExecutionDto: AlertExecutionDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/Alerts/execution`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: alertExecutionDto,
    },
    options
  );
};

export const getPutApiAlertsExecutionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiAlertsExecution>>,
    TError,
    { data: AlertExecutionDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiAlertsExecution>>,
  TError,
  { data: AlertExecutionDto },
  TContext
> => {
  const mutationKey = ['putApiAlertsExecution'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiAlertsExecution>>,
    { data: AlertExecutionDto }
  > = props => {
    const { data } = props ?? {};

    return putApiAlertsExecution(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiAlertsExecutionMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiAlertsExecution>>
>;
export type PutApiAlertsExecutionMutationBody = AlertExecutionDto;
export type PutApiAlertsExecutionMutationError = unknown;

export const usePutApiAlertsExecution = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiAlertsExecution>>,
    TError,
    { data: AlertExecutionDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiAlertsExecution>>,
  TError,
  { data: AlertExecutionDto },
  TContext
> => {
  const mutationOptions = getPutApiAlertsExecutionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiAlertsExecution = (
  params?: GetApiAlertsExecutionParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Alerts/execution`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiAlertsExecutionQueryKey = (
  params?: GetApiAlertsExecutionParams
) => {
  return [`/api/Alerts/execution`, ...(params ? [params] : [])] as const;
};

export const getGetApiAlertsExecutionQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAlertsExecution>>,
  TError = unknown,
>(
  params?: GetApiAlertsExecutionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAlertsExecution>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiAlertsExecutionQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiAlertsExecution>>
  > = ({ signal }) => getApiAlertsExecution(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAlertsExecution>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiAlertsExecutionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAlertsExecution>>
>;
export type GetApiAlertsExecutionQueryError = unknown;

export function useGetApiAlertsExecution<
  TData = Awaited<ReturnType<typeof getApiAlertsExecution>>,
  TError = unknown,
>(
  params?: GetApiAlertsExecutionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAlertsExecution>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiAlertsExecutionQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiAlertsExecutionId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Alerts/execution/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiAlertsExecutionIdQueryKey = (id?: number) => {
  return [`/api/Alerts/execution/${id}`] as const;
};

export const getGetApiAlertsExecutionIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAlertsExecutionId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAlertsExecutionId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiAlertsExecutionIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiAlertsExecutionId>>
  > = ({ signal }) => getApiAlertsExecutionId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAlertsExecutionId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiAlertsExecutionIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAlertsExecutionId>>
>;
export type GetApiAlertsExecutionIdQueryError = unknown;

export function useGetApiAlertsExecutionId<
  TData = Awaited<ReturnType<typeof getApiAlertsExecutionId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAlertsExecutionId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiAlertsExecutionIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiAlertsExecutionByAlertAlertId = (
  alertId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Alerts/execution/byAlert/${alertId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiAlertsExecutionByAlertAlertIdQueryKey = (
  alertId?: number
) => {
  return [`/api/Alerts/execution/byAlert/${alertId}`] as const;
};

export const getGetApiAlertsExecutionByAlertAlertIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAlertsExecutionByAlertAlertId>>,
  TError = unknown,
>(
  alertId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAlertsExecutionByAlertAlertId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiAlertsExecutionByAlertAlertIdQueryKey(alertId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiAlertsExecutionByAlertAlertId>>
  > = ({ signal }) =>
    getApiAlertsExecutionByAlertAlertId(alertId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!alertId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAlertsExecutionByAlertAlertId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiAlertsExecutionByAlertAlertIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAlertsExecutionByAlertAlertId>>
>;
export type GetApiAlertsExecutionByAlertAlertIdQueryError = unknown;

export function useGetApiAlertsExecutionByAlertAlertId<
  TData = Awaited<ReturnType<typeof getApiAlertsExecutionByAlertAlertId>>,
  TError = unknown,
>(
  alertId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAlertsExecutionByAlertAlertId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiAlertsExecutionByAlertAlertIdQueryOptions(
    alertId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiAlertsExecutionLastAlertId = (
  alertId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Alerts/execution/last/${alertId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiAlertsExecutionLastAlertIdQueryKey = (
  alertId?: number
) => {
  return [`/api/Alerts/execution/last/${alertId}`] as const;
};

export const getGetApiAlertsExecutionLastAlertIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAlertsExecutionLastAlertId>>,
  TError = unknown,
>(
  alertId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAlertsExecutionLastAlertId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiAlertsExecutionLastAlertIdQueryKey(alertId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiAlertsExecutionLastAlertId>>
  > = ({ signal }) =>
    getApiAlertsExecutionLastAlertId(alertId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!alertId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAlertsExecutionLastAlertId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiAlertsExecutionLastAlertIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAlertsExecutionLastAlertId>>
>;
export type GetApiAlertsExecutionLastAlertIdQueryError = unknown;

export function useGetApiAlertsExecutionLastAlertId<
  TData = Awaited<ReturnType<typeof getApiAlertsExecutionLastAlertId>>,
  TError = unknown,
>(
  alertId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAlertsExecutionLastAlertId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiAlertsExecutionLastAlertIdQueryOptions(
    alertId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiAnnotations = (
  params?: GetApiAnnotationsParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Annotations`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiAnnotationsQueryKey = (
  params?: GetApiAnnotationsParams
) => {
  return [`/api/Annotations`, ...(params ? [params] : [])] as const;
};

export const getGetApiAnnotationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAnnotations>>,
  TError = unknown,
>(
  params?: GetApiAnnotationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAnnotations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiAnnotationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiAnnotations>>
  > = ({ signal }) => getApiAnnotations(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAnnotations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiAnnotationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAnnotations>>
>;
export type GetApiAnnotationsQueryError = unknown;

export function useGetApiAnnotations<
  TData = Awaited<ReturnType<typeof getApiAnnotations>>,
  TError = unknown,
>(
  params?: GetApiAnnotationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAnnotations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiAnnotationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiAnnotations = (
  createAnnotationDto: CreateAnnotationDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Annotations`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createAnnotationDto,
      signal,
    },
    options
  );
};

export const getPostApiAnnotationsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAnnotations>>,
    TError,
    { data: CreateAnnotationDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAnnotations>>,
  TError,
  { data: CreateAnnotationDto },
  TContext
> => {
  const mutationKey = ['postApiAnnotations'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiAnnotations>>,
    { data: CreateAnnotationDto }
  > = props => {
    const { data } = props ?? {};

    return postApiAnnotations(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiAnnotationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiAnnotations>>
>;
export type PostApiAnnotationsMutationBody = CreateAnnotationDto;
export type PostApiAnnotationsMutationError = unknown;

export const usePostApiAnnotations = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAnnotations>>,
    TError,
    { data: CreateAnnotationDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiAnnotations>>,
  TError,
  { data: CreateAnnotationDto },
  TContext
> => {
  const mutationOptions = getPostApiAnnotationsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiAnnotationsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Annotations/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiAnnotationsIdQueryKey = (id?: number) => {
  return [`/api/Annotations/${id}`] as const;
};

export const getGetApiAnnotationsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAnnotationsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAnnotationsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiAnnotationsIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiAnnotationsId>>
  > = ({ signal }) => getApiAnnotationsId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAnnotationsId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiAnnotationsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAnnotationsId>>
>;
export type GetApiAnnotationsIdQueryError = unknown;

export function useGetApiAnnotationsId<
  TData = Awaited<ReturnType<typeof getApiAnnotationsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAnnotationsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiAnnotationsIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiAnnotationsId = (
  id: number,
  annotationDto: AnnotationDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/Annotations/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: annotationDto,
    },
    options
  );
};

export const getPutApiAnnotationsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiAnnotationsId>>,
    TError,
    { id: number; data: AnnotationDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiAnnotationsId>>,
  TError,
  { id: number; data: AnnotationDto },
  TContext
> => {
  const mutationKey = ['putApiAnnotationsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiAnnotationsId>>,
    { id: number; data: AnnotationDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiAnnotationsId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiAnnotationsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiAnnotationsId>>
>;
export type PutApiAnnotationsIdMutationBody = AnnotationDto;
export type PutApiAnnotationsIdMutationError = unknown;

export const usePutApiAnnotationsId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiAnnotationsId>>,
    TError,
    { id: number; data: AnnotationDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiAnnotationsId>>,
  TError,
  { id: number; data: AnnotationDto },
  TContext
> => {
  const mutationOptions = getPutApiAnnotationsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiAnnotationsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/Annotations/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiAnnotationsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiAnnotationsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiAnnotationsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiAnnotationsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiAnnotationsId>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiAnnotationsId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiAnnotationsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiAnnotationsId>>
>;

export type DeleteApiAnnotationsIdMutationError = unknown;

export const useDeleteApiAnnotationsId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiAnnotationsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiAnnotationsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteApiAnnotationsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiAnnotationsByZoneZoneId = (
  zoneId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Annotations/by-zone/${zoneId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiAnnotationsByZoneZoneIdQueryKey = (zoneId?: number) => {
  return [`/api/Annotations/by-zone/${zoneId}`] as const;
};

export const getGetApiAnnotationsByZoneZoneIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAnnotationsByZoneZoneId>>,
  TError = unknown,
>(
  zoneId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAnnotationsByZoneZoneId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiAnnotationsByZoneZoneIdQueryKey(zoneId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiAnnotationsByZoneZoneId>>
  > = ({ signal }) =>
    getApiAnnotationsByZoneZoneId(zoneId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!zoneId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAnnotationsByZoneZoneId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiAnnotationsByZoneZoneIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAnnotationsByZoneZoneId>>
>;
export type GetApiAnnotationsByZoneZoneIdQueryError = unknown;

export function useGetApiAnnotationsByZoneZoneId<
  TData = Awaited<ReturnType<typeof getApiAnnotationsByZoneZoneId>>,
  TError = unknown,
>(
  zoneId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAnnotationsByZoneZoneId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiAnnotationsByZoneZoneIdQueryOptions(
    zoneId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiAnnotationsData = (
  params?: GetApiAnnotationsDataParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/AnnotationsData`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiAnnotationsDataQueryKey = (
  params?: GetApiAnnotationsDataParams
) => {
  return [`/api/AnnotationsData`, ...(params ? [params] : [])] as const;
};

export const getGetApiAnnotationsDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAnnotationsData>>,
  TError = unknown,
>(
  params?: GetApiAnnotationsDataParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAnnotationsData>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiAnnotationsDataQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiAnnotationsData>>
  > = ({ signal }) => getApiAnnotationsData(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAnnotationsData>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiAnnotationsDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAnnotationsData>>
>;
export type GetApiAnnotationsDataQueryError = unknown;

export function useGetApiAnnotationsData<
  TData = Awaited<ReturnType<typeof getApiAnnotationsData>>,
  TError = unknown,
>(
  params?: GetApiAnnotationsDataParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAnnotationsData>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiAnnotationsDataQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiAnnotationsData = (
  createAnnotationsDataDto: CreateAnnotationsDataDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/AnnotationsData`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createAnnotationsDataDto,
      signal,
    },
    options
  );
};

export const getPostApiAnnotationsDataMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAnnotationsData>>,
    TError,
    { data: CreateAnnotationsDataDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAnnotationsData>>,
  TError,
  { data: CreateAnnotationsDataDto },
  TContext
> => {
  const mutationKey = ['postApiAnnotationsData'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiAnnotationsData>>,
    { data: CreateAnnotationsDataDto }
  > = props => {
    const { data } = props ?? {};

    return postApiAnnotationsData(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiAnnotationsDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiAnnotationsData>>
>;
export type PostApiAnnotationsDataMutationBody = CreateAnnotationsDataDto;
export type PostApiAnnotationsDataMutationError = unknown;

export const usePostApiAnnotationsData = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAnnotationsData>>,
    TError,
    { data: CreateAnnotationsDataDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiAnnotationsData>>,
  TError,
  { data: CreateAnnotationsDataDto },
  TContext
> => {
  const mutationOptions = getPostApiAnnotationsDataMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiAnnotationsDataId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/AnnotationsData/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiAnnotationsDataIdQueryKey = (id?: number) => {
  return [`/api/AnnotationsData/${id}`] as const;
};

export const getGetApiAnnotationsDataIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAnnotationsDataId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAnnotationsDataId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiAnnotationsDataIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiAnnotationsDataId>>
  > = ({ signal }) => getApiAnnotationsDataId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAnnotationsDataId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiAnnotationsDataIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAnnotationsDataId>>
>;
export type GetApiAnnotationsDataIdQueryError = unknown;

export function useGetApiAnnotationsDataId<
  TData = Awaited<ReturnType<typeof getApiAnnotationsDataId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAnnotationsDataId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiAnnotationsDataIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiAnnotationsDataId = (
  id: number,
  annotationsDataDto: AnnotationsDataDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/AnnotationsData/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: annotationsDataDto,
    },
    options
  );
};

export const getPutApiAnnotationsDataIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiAnnotationsDataId>>,
    TError,
    { id: number; data: AnnotationsDataDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiAnnotationsDataId>>,
  TError,
  { id: number; data: AnnotationsDataDto },
  TContext
> => {
  const mutationKey = ['putApiAnnotationsDataId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiAnnotationsDataId>>,
    { id: number; data: AnnotationsDataDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiAnnotationsDataId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiAnnotationsDataIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiAnnotationsDataId>>
>;
export type PutApiAnnotationsDataIdMutationBody = AnnotationsDataDto;
export type PutApiAnnotationsDataIdMutationError = unknown;

export const usePutApiAnnotationsDataId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiAnnotationsDataId>>,
    TError,
    { id: number; data: AnnotationsDataDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiAnnotationsDataId>>,
  TError,
  { id: number; data: AnnotationsDataDto },
  TContext
> => {
  const mutationOptions = getPutApiAnnotationsDataIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiAnnotationsDataId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/AnnotationsData/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiAnnotationsDataIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiAnnotationsDataId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiAnnotationsDataId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiAnnotationsDataId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiAnnotationsDataId>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiAnnotationsDataId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiAnnotationsDataIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiAnnotationsDataId>>
>;

export type DeleteApiAnnotationsDataIdMutationError = unknown;

export const useDeleteApiAnnotationsDataId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiAnnotationsDataId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiAnnotationsDataId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteApiAnnotationsDataIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiAnnotationsDataByAnnotationAnnotationId = (
  annotationId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/AnnotationsData/by-annotation/${annotationId}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetApiAnnotationsDataByAnnotationAnnotationIdQueryKey = (
  annotationId?: number
) => {
  return [`/api/AnnotationsData/by-annotation/${annotationId}`] as const;
};

export const getGetApiAnnotationsDataByAnnotationAnnotationIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiAnnotationsDataByAnnotationAnnotationId>
  >,
  TError = unknown,
>(
  annotationId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAnnotationsDataByAnnotationAnnotationId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiAnnotationsDataByAnnotationAnnotationIdQueryKey(annotationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiAnnotationsDataByAnnotationAnnotationId>>
  > = ({ signal }) =>
    getApiAnnotationsDataByAnnotationAnnotationId(
      annotationId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!annotationId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAnnotationsDataByAnnotationAnnotationId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiAnnotationsDataByAnnotationAnnotationIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiAnnotationsDataByAnnotationAnnotationId>>
  >;
export type GetApiAnnotationsDataByAnnotationAnnotationIdQueryError = unknown;

export function useGetApiAnnotationsDataByAnnotationAnnotationId<
  TData = Awaited<
    ReturnType<typeof getApiAnnotationsDataByAnnotationAnnotationId>
  >,
  TError = unknown,
>(
  annotationId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAnnotationsDataByAnnotationAnnotationId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getGetApiAnnotationsDataByAnnotationAnnotationIdQueryOptions(
      annotationId,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiAnnotationsDataByDates = (
  params?: GetApiAnnotationsDataByDatesParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/AnnotationsData/by-dates`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiAnnotationsDataByDatesQueryKey = (
  params?: GetApiAnnotationsDataByDatesParams
) => {
  return [
    `/api/AnnotationsData/by-dates`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiAnnotationsDataByDatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAnnotationsDataByDates>>,
  TError = unknown,
>(
  params?: GetApiAnnotationsDataByDatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAnnotationsDataByDates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiAnnotationsDataByDatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiAnnotationsDataByDates>>
  > = ({ signal }) =>
    getApiAnnotationsDataByDates(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAnnotationsDataByDates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiAnnotationsDataByDatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAnnotationsDataByDates>>
>;
export type GetApiAnnotationsDataByDatesQueryError = unknown;

export function useGetApiAnnotationsDataByDates<
  TData = Awaited<ReturnType<typeof getApiAnnotationsDataByDates>>,
  TError = unknown,
>(
  params?: GetApiAnnotationsDataByDatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAnnotationsDataByDates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiAnnotationsDataByDatesQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiAnnotationsDataByAnnotationDates = (
  params?: GetApiAnnotationsDataByAnnotationDatesParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/AnnotationsData/by-annotation-dates`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetApiAnnotationsDataByAnnotationDatesQueryKey = (
  params?: GetApiAnnotationsDataByAnnotationDatesParams
) => {
  return [
    `/api/AnnotationsData/by-annotation-dates`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiAnnotationsDataByAnnotationDatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAnnotationsDataByAnnotationDates>>,
  TError = unknown,
>(
  params?: GetApiAnnotationsDataByAnnotationDatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAnnotationsDataByAnnotationDates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiAnnotationsDataByAnnotationDatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiAnnotationsDataByAnnotationDates>>
  > = ({ signal }) =>
    getApiAnnotationsDataByAnnotationDates(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAnnotationsDataByAnnotationDates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiAnnotationsDataByAnnotationDatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAnnotationsDataByAnnotationDates>>
>;
export type GetApiAnnotationsDataByAnnotationDatesQueryError = unknown;

export function useGetApiAnnotationsDataByAnnotationDates<
  TData = Awaited<ReturnType<typeof getApiAnnotationsDataByAnnotationDates>>,
  TError = unknown,
>(
  params?: GetApiAnnotationsDataByAnnotationDatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAnnotationsDataByAnnotationDates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiAnnotationsDataByAnnotationDatesQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiAudit = (
  params?: GetApiAuditParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Audit`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiAuditQueryKey = (params?: GetApiAuditParams) => {
  return [`/api/Audit`, ...(params ? [params] : [])] as const;
};

export const getGetApiAuditQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAudit>>,
  TError = unknown,
>(
  params?: GetApiAuditParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAudit>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiAuditQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAudit>>> = ({
    signal,
  }) => getApiAudit(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAudit>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiAuditQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAudit>>
>;
export type GetApiAuditQueryError = unknown;

export function useGetApiAudit<
  TData = Awaited<ReturnType<typeof getApiAudit>>,
  TError = unknown,
>(
  params?: GetApiAuditParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiAudit>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiAuditQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiChartAnnotations = (
  params?: GetApiChartAnnotationsParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/ChartAnnotations`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiChartAnnotationsQueryKey = (
  params?: GetApiChartAnnotationsParams
) => {
  return [`/api/ChartAnnotations`, ...(params ? [params] : [])] as const;
};

export const getGetApiChartAnnotationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiChartAnnotations>>,
  TError = unknown,
>(
  params?: GetApiChartAnnotationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiChartAnnotations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiChartAnnotationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiChartAnnotations>>
  > = ({ signal }) => getApiChartAnnotations(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiChartAnnotations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiChartAnnotationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiChartAnnotations>>
>;
export type GetApiChartAnnotationsQueryError = unknown;

export function useGetApiChartAnnotations<
  TData = Awaited<ReturnType<typeof getApiChartAnnotations>>,
  TError = unknown,
>(
  params?: GetApiChartAnnotationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiChartAnnotations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiChartAnnotationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiChartAnnotations = (
  createChartAnnotationsDto: CreateChartAnnotationsDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/ChartAnnotations`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createChartAnnotationsDto,
      signal,
    },
    options
  );
};

export const getPostApiChartAnnotationsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiChartAnnotations>>,
    TError,
    { data: CreateChartAnnotationsDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiChartAnnotations>>,
  TError,
  { data: CreateChartAnnotationsDto },
  TContext
> => {
  const mutationKey = ['postApiChartAnnotations'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiChartAnnotations>>,
    { data: CreateChartAnnotationsDto }
  > = props => {
    const { data } = props ?? {};

    return postApiChartAnnotations(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiChartAnnotationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiChartAnnotations>>
>;
export type PostApiChartAnnotationsMutationBody = CreateChartAnnotationsDto;
export type PostApiChartAnnotationsMutationError = unknown;

export const usePostApiChartAnnotations = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiChartAnnotations>>,
    TError,
    { data: CreateChartAnnotationsDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiChartAnnotations>>,
  TError,
  { data: CreateChartAnnotationsDto },
  TContext
> => {
  const mutationOptions = getPostApiChartAnnotationsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiChartAnnotations = (
  chartAnnotationsDto: ChartAnnotationsDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/ChartAnnotations`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: chartAnnotationsDto,
    },
    options
  );
};

export const getPutApiChartAnnotationsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiChartAnnotations>>,
    TError,
    { data: ChartAnnotationsDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiChartAnnotations>>,
  TError,
  { data: ChartAnnotationsDto },
  TContext
> => {
  const mutationKey = ['putApiChartAnnotations'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiChartAnnotations>>,
    { data: ChartAnnotationsDto }
  > = props => {
    const { data } = props ?? {};

    return putApiChartAnnotations(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiChartAnnotationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiChartAnnotations>>
>;
export type PutApiChartAnnotationsMutationBody = ChartAnnotationsDto;
export type PutApiChartAnnotationsMutationError = unknown;

export const usePutApiChartAnnotations = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiChartAnnotations>>,
    TError,
    { data: ChartAnnotationsDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiChartAnnotations>>,
  TError,
  { data: ChartAnnotationsDto },
  TContext
> => {
  const mutationOptions = getPutApiChartAnnotationsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiChartAnnotationsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/ChartAnnotations/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiChartAnnotationsIdQueryKey = (id?: number) => {
  return [`/api/ChartAnnotations/${id}`] as const;
};

export const getGetApiChartAnnotationsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiChartAnnotationsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiChartAnnotationsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiChartAnnotationsIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiChartAnnotationsId>>
  > = ({ signal }) => getApiChartAnnotationsId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiChartAnnotationsId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiChartAnnotationsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiChartAnnotationsId>>
>;
export type GetApiChartAnnotationsIdQueryError = unknown;

export function useGetApiChartAnnotationsId<
  TData = Awaited<ReturnType<typeof getApiChartAnnotationsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiChartAnnotationsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiChartAnnotationsIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteApiChartAnnotationsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/ChartAnnotations/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiChartAnnotationsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiChartAnnotationsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiChartAnnotationsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiChartAnnotationsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiChartAnnotationsId>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiChartAnnotationsId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiChartAnnotationsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiChartAnnotationsId>>
>;

export type DeleteApiChartAnnotationsIdMutationError = unknown;

export const useDeleteApiChartAnnotationsId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiChartAnnotationsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiChartAnnotationsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getDeleteApiChartAnnotationsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiChartAnnotationsByChartqueryChartQueryId = (
  chartQueryId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/ChartAnnotations/by-chartquery/${chartQueryId}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetApiChartAnnotationsByChartqueryChartQueryIdQueryKey = (
  chartQueryId?: number
) => {
  return [`/api/ChartAnnotations/by-chartquery/${chartQueryId}`] as const;
};

export const getGetApiChartAnnotationsByChartqueryChartQueryIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiChartAnnotationsByChartqueryChartQueryId>
  >,
  TError = unknown,
>(
  chartQueryId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiChartAnnotationsByChartqueryChartQueryId>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiChartAnnotationsByChartqueryChartQueryIdQueryKey(chartQueryId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiChartAnnotationsByChartqueryChartQueryId>>
  > = ({ signal }) =>
    getApiChartAnnotationsByChartqueryChartQueryId(
      chartQueryId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!chartQueryId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiChartAnnotationsByChartqueryChartQueryId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiChartAnnotationsByChartqueryChartQueryIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiChartAnnotationsByChartqueryChartQueryId>>
  >;
export type GetApiChartAnnotationsByChartqueryChartQueryIdQueryError = unknown;

export function useGetApiChartAnnotationsByChartqueryChartQueryId<
  TData = Awaited<
    ReturnType<typeof getApiChartAnnotationsByChartqueryChartQueryId>
  >,
  TError = unknown,
>(
  chartQueryId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiChartAnnotationsByChartqueryChartQueryId>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getGetApiChartAnnotationsByChartqueryChartQueryIdQueryOptions(
      chartQueryId,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiChartQueries = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/ChartQueries`, method: 'GET', signal },
    options
  );
};

export const getGetApiChartQueriesQueryKey = () => {
  return [`/api/ChartQueries`] as const;
};

export const getGetApiChartQueriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiChartQueries>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiChartQueries>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiChartQueriesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiChartQueries>>
  > = ({ signal }) => getApiChartQueries(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiChartQueries>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiChartQueriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiChartQueries>>
>;
export type GetApiChartQueriesQueryError = unknown;

export function useGetApiChartQueries<
  TData = Awaited<ReturnType<typeof getApiChartQueries>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiChartQueries>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiChartQueriesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiChartQueries = (
  createChartQueryDto: CreateChartQueryDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CreateResponseDto>(
    {
      url: `/api/ChartQueries`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createChartQueryDto,
      signal,
    },
    options
  );
};

export const getPostApiChartQueriesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiChartQueries>>,
    TError,
    { data: CreateChartQueryDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiChartQueries>>,
  TError,
  { data: CreateChartQueryDto },
  TContext
> => {
  const mutationKey = ['postApiChartQueries'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiChartQueries>>,
    { data: CreateChartQueryDto }
  > = props => {
    const { data } = props ?? {};

    return postApiChartQueries(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiChartQueriesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiChartQueries>>
>;
export type PostApiChartQueriesMutationBody = CreateChartQueryDto;
export type PostApiChartQueriesMutationError = unknown;

export const usePostApiChartQueries = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiChartQueries>>,
    TError,
    { data: CreateChartQueryDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiChartQueries>>,
  TError,
  { data: CreateChartQueryDto },
  TContext
> => {
  const mutationOptions = getPostApiChartQueriesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiChartQueriesId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/ChartQueries/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiChartQueriesIdQueryKey = (id?: number) => {
  return [`/api/ChartQueries/${id}`] as const;
};

export const getGetApiChartQueriesIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiChartQueriesId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiChartQueriesId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiChartQueriesIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiChartQueriesId>>
  > = ({ signal }) => getApiChartQueriesId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiChartQueriesId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiChartQueriesIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiChartQueriesId>>
>;
export type GetApiChartQueriesIdQueryError = unknown;

export function useGetApiChartQueriesId<
  TData = Awaited<ReturnType<typeof getApiChartQueriesId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiChartQueriesId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiChartQueriesIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiChartQueriesId = (
  id: number,
  chartQueryDto: ChartQueryDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    {
      url: `/api/ChartQueries/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: chartQueryDto,
    },
    options
  );
};

export const getPutApiChartQueriesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiChartQueriesId>>,
    TError,
    { id: number; data: ChartQueryDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiChartQueriesId>>,
  TError,
  { id: number; data: ChartQueryDto },
  TContext
> => {
  const mutationKey = ['putApiChartQueriesId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiChartQueriesId>>,
    { id: number; data: ChartQueryDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiChartQueriesId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiChartQueriesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiChartQueriesId>>
>;
export type PutApiChartQueriesIdMutationBody = ChartQueryDto;
export type PutApiChartQueriesIdMutationError = unknown;

export const usePutApiChartQueriesId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiChartQueriesId>>,
    TError,
    { id: number; data: ChartQueryDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiChartQueriesId>>,
  TError,
  { id: number; data: ChartQueryDto },
  TContext
> => {
  const mutationOptions = getPutApiChartQueriesIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiChartQueriesId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    { url: `/api/ChartQueries/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiChartQueriesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiChartQueriesId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiChartQueriesId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiChartQueriesId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiChartQueriesId>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiChartQueriesId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiChartQueriesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiChartQueriesId>>
>;

export type DeleteApiChartQueriesIdMutationError = unknown;

export const useDeleteApiChartQueriesId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiChartQueriesId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiChartQueriesId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteApiChartQueriesIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiChartQueriesByLayoutLayoutId = (
  layoutId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/ChartQueries/ByLayout/${layoutId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiChartQueriesByLayoutLayoutIdQueryKey = (
  layoutId?: number
) => {
  return [`/api/ChartQueries/ByLayout/${layoutId}`] as const;
};

export const getGetApiChartQueriesByLayoutLayoutIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiChartQueriesByLayoutLayoutId>>,
  TError = unknown,
>(
  layoutId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiChartQueriesByLayoutLayoutId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiChartQueriesByLayoutLayoutIdQueryKey(layoutId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiChartQueriesByLayoutLayoutId>>
  > = ({ signal }) =>
    getApiChartQueriesByLayoutLayoutId(layoutId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!layoutId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiChartQueriesByLayoutLayoutId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiChartQueriesByLayoutLayoutIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiChartQueriesByLayoutLayoutId>>
>;
export type GetApiChartQueriesByLayoutLayoutIdQueryError = unknown;

export function useGetApiChartQueriesByLayoutLayoutId<
  TData = Awaited<ReturnType<typeof getApiChartQueriesByLayoutLayoutId>>,
  TError = unknown,
>(
  layoutId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiChartQueriesByLayoutLayoutId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiChartQueriesByLayoutLayoutIdQueryOptions(
    layoutId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiChartQueriesByDashboardDashboardId = (
  dashboardId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/ChartQueries/ByDashboard/${dashboardId}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetApiChartQueriesByDashboardDashboardIdQueryKey = (
  dashboardId?: number
) => {
  return [`/api/ChartQueries/ByDashboard/${dashboardId}`] as const;
};

export const getGetApiChartQueriesByDashboardDashboardIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiChartQueriesByDashboardDashboardId>>,
  TError = unknown,
>(
  dashboardId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiChartQueriesByDashboardDashboardId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiChartQueriesByDashboardDashboardIdQueryKey(dashboardId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiChartQueriesByDashboardDashboardId>>
  > = ({ signal }) =>
    getApiChartQueriesByDashboardDashboardId(
      dashboardId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!dashboardId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiChartQueriesByDashboardDashboardId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiChartQueriesByDashboardDashboardIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiChartQueriesByDashboardDashboardId>>
>;
export type GetApiChartQueriesByDashboardDashboardIdQueryError = unknown;

export function useGetApiChartQueriesByDashboardDashboardId<
  TData = Awaited<ReturnType<typeof getApiChartQueriesByDashboardDashboardId>>,
  TError = unknown,
>(
  dashboardId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiChartQueriesByDashboardDashboardId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiChartQueriesByDashboardDashboardIdQueryOptions(
    dashboardId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiChartQueriesByValueNodeNodeId = (
  nodeId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/ChartQueries/ByValueNode/${nodeId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiChartQueriesByValueNodeNodeIdQueryKey = (
  nodeId?: number
) => {
  return [`/api/ChartQueries/ByValueNode/${nodeId}`] as const;
};

export const getGetApiChartQueriesByValueNodeNodeIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiChartQueriesByValueNodeNodeId>>,
  TError = unknown,
>(
  nodeId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiChartQueriesByValueNodeNodeId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiChartQueriesByValueNodeNodeIdQueryKey(nodeId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiChartQueriesByValueNodeNodeId>>
  > = ({ signal }) =>
    getApiChartQueriesByValueNodeNodeId(nodeId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!nodeId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiChartQueriesByValueNodeNodeId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiChartQueriesByValueNodeNodeIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiChartQueriesByValueNodeNodeId>>
>;
export type GetApiChartQueriesByValueNodeNodeIdQueryError = unknown;

export function useGetApiChartQueriesByValueNodeNodeId<
  TData = Awaited<ReturnType<typeof getApiChartQueriesByValueNodeNodeId>>,
  TError = unknown,
>(
  nodeId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiChartQueriesByValueNodeNodeId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiChartQueriesByValueNodeNodeIdQueryOptions(
    nodeId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiChartQueriesBatch = (
  chartQueryDto: ChartQueryDto[],
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    {
      url: `/api/ChartQueries/batch`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: chartQueryDto,
    },
    options
  );
};

export const getPutApiChartQueriesBatchMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiChartQueriesBatch>>,
    TError,
    { data: ChartQueryDto[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiChartQueriesBatch>>,
  TError,
  { data: ChartQueryDto[] },
  TContext
> => {
  const mutationKey = ['putApiChartQueriesBatch'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiChartQueriesBatch>>,
    { data: ChartQueryDto[] }
  > = props => {
    const { data } = props ?? {};

    return putApiChartQueriesBatch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiChartQueriesBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiChartQueriesBatch>>
>;
export type PutApiChartQueriesBatchMutationBody = ChartQueryDto[];
export type PutApiChartQueriesBatchMutationError = unknown;

export const usePutApiChartQueriesBatch = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiChartQueriesBatch>>,
    TError,
    { data: ChartQueryDto[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiChartQueriesBatch>>,
  TError,
  { data: ChartQueryDto[] },
  TContext
> => {
  const mutationOptions = getPutApiChartQueriesBatchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiChartQueriesBatch = (
  deleteApiChartQueriesBatchBody: number[],
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    {
      url: `/api/ChartQueries/Batch`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      data: deleteApiChartQueriesBatchBody,
    },
    options
  );
};

export const getDeleteApiChartQueriesBatchMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiChartQueriesBatch>>,
    TError,
    { data: number[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiChartQueriesBatch>>,
  TError,
  { data: number[] },
  TContext
> => {
  const mutationKey = ['deleteApiChartQueriesBatch'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiChartQueriesBatch>>,
    { data: number[] }
  > = props => {
    const { data } = props ?? {};

    return deleteApiChartQueriesBatch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiChartQueriesBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiChartQueriesBatch>>
>;
export type DeleteApiChartQueriesBatchMutationBody = number[];
export type DeleteApiChartQueriesBatchMutationError = unknown;

export const useDeleteApiChartQueriesBatch = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiChartQueriesBatch>>,
    TError,
    { data: number[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiChartQueriesBatch>>,
  TError,
  { data: number[] },
  TContext
> => {
  const mutationOptions = getDeleteApiChartQueriesBatchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiChartQueriesApplyFiltersByDashboardIdFilterRequestDashboardId =
  (
    chartQueryFilterRequestDto: ChartQueryFilterRequestDto,
    options?: SecondParameter<typeof axiosInstance>
  ) => {
    return axiosInstance<void>(
      {
        url: `/api/ChartQueries/ApplyFiltersByDashboardId/filterRequest.DashboardId}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: chartQueryFilterRequestDto,
      },
      options
    );
  };

export const getPutApiChartQueriesApplyFiltersByDashboardIdFilterRequestDashboardIdMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof putApiChartQueriesApplyFiltersByDashboardIdFilterRequestDashboardId
        >
      >,
      TError,
      { data: ChartQueryFilterRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof putApiChartQueriesApplyFiltersByDashboardIdFilterRequestDashboardId
      >
    >,
    TError,
    { data: ChartQueryFilterRequestDto },
    TContext
  > => {
    const mutationKey = [
      'putApiChartQueriesApplyFiltersByDashboardIdFilterRequestDashboardId',
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof putApiChartQueriesApplyFiltersByDashboardIdFilterRequestDashboardId
        >
      >,
      { data: ChartQueryFilterRequestDto }
    > = props => {
      const { data } = props ?? {};

      return putApiChartQueriesApplyFiltersByDashboardIdFilterRequestDashboardId(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PutApiChartQueriesApplyFiltersByDashboardIdFilterRequestDashboardIdMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof putApiChartQueriesApplyFiltersByDashboardIdFilterRequestDashboardId
      >
    >
  >;
export type PutApiChartQueriesApplyFiltersByDashboardIdFilterRequestDashboardIdMutationBody =
  ChartQueryFilterRequestDto;
export type PutApiChartQueriesApplyFiltersByDashboardIdFilterRequestDashboardIdMutationError =
  unknown;

export const usePutApiChartQueriesApplyFiltersByDashboardIdFilterRequestDashboardId =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof putApiChartQueriesApplyFiltersByDashboardIdFilterRequestDashboardId
        >
      >,
      TError,
      { data: ChartQueryFilterRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof putApiChartQueriesApplyFiltersByDashboardIdFilterRequestDashboardId
      >
    >,
    TError,
    { data: ChartQueryFilterRequestDto },
    TContext
  > => {
    const mutationOptions =
      getPutApiChartQueriesApplyFiltersByDashboardIdFilterRequestDashboardIdMutationOptions(
        options
      );

    return useMutation(mutationOptions);
  };

export const getApiClients = (
  params?: GetApiClientsParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Clients`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiClientsQueryKey = (params?: GetApiClientsParams) => {
  return [`/api/Clients`, ...(params ? [params] : [])] as const;
};

export const getGetApiClientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiClients>>,
  TError = unknown,
>(
  params?: GetApiClientsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiClients>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiClientsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiClients>>> = ({
    signal,
  }) => getApiClients(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiClients>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiClientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiClients>>
>;
export type GetApiClientsQueryError = unknown;

export function useGetApiClients<
  TData = Awaited<ReturnType<typeof getApiClients>>,
  TError = unknown,
>(
  params?: GetApiClientsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiClients>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiClientsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiClients = (
  createClientDto: CreateClientDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CreateResponseDto>(
    {
      url: `/api/Clients`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createClientDto,
      signal,
    },
    options
  );
};

export const getPostApiClientsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiClients>>,
    TError,
    { data: CreateClientDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiClients>>,
  TError,
  { data: CreateClientDto },
  TContext
> => {
  const mutationKey = ['postApiClients'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiClients>>,
    { data: CreateClientDto }
  > = props => {
    const { data } = props ?? {};

    return postApiClients(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiClientsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiClients>>
>;
export type PostApiClientsMutationBody = CreateClientDto;
export type PostApiClientsMutationError = unknown;

export const usePostApiClients = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiClients>>,
    TError,
    { data: CreateClientDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiClients>>,
  TError,
  { data: CreateClientDto },
  TContext
> => {
  const mutationOptions = getPostApiClientsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiClientsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Clients/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiClientsIdQueryKey = (id?: number) => {
  return [`/api/Clients/${id}`] as const;
};

export const getGetApiClientsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiClientsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiClientsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiClientsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiClientsId>>> = ({
    signal,
  }) => getApiClientsId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiClientsId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiClientsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiClientsId>>
>;
export type GetApiClientsIdQueryError = unknown;

export function useGetApiClientsId<
  TData = Awaited<ReturnType<typeof getApiClientsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiClientsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiClientsIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiClientsId = (
  id: number,
  clientDto: ClientDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    {
      url: `/api/Clients/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: clientDto,
    },
    options
  );
};

export const getPutApiClientsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiClientsId>>,
    TError,
    { id: number; data: ClientDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiClientsId>>,
  TError,
  { id: number; data: ClientDto },
  TContext
> => {
  const mutationKey = ['putApiClientsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiClientsId>>,
    { id: number; data: ClientDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiClientsId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiClientsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiClientsId>>
>;
export type PutApiClientsIdMutationBody = ClientDto;
export type PutApiClientsIdMutationError = unknown;

export const usePutApiClientsId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiClientsId>>,
    TError,
    { id: number; data: ClientDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiClientsId>>,
  TError,
  { id: number; data: ClientDto },
  TContext
> => {
  const mutationOptions = getPutApiClientsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiClientsId = (
  id: number,
  params?: DeleteApiClientsIdParams,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    { url: `/api/Clients/${id}`, method: 'DELETE', params },
    options
  );
};

export const getDeleteApiClientsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiClientsId>>,
    TError,
    { id: number; params?: DeleteApiClientsIdParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiClientsId>>,
  TError,
  { id: number; params?: DeleteApiClientsIdParams },
  TContext
> => {
  const mutationKey = ['deleteApiClientsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiClientsId>>,
    { id: number; params?: DeleteApiClientsIdParams }
  > = props => {
    const { id, params } = props ?? {};

    return deleteApiClientsId(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiClientsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiClientsId>>
>;

export type DeleteApiClientsIdMutationError = unknown;

export const useDeleteApiClientsId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiClientsId>>,
    TError,
    { id: number; params?: DeleteApiClientsIdParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiClientsId>>,
  TError,
  { id: number; params?: DeleteApiClientsIdParams },
  TContext
> => {
  const mutationOptions = getDeleteApiClientsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiClientsPlantDashboardTree = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Clients/plant-dashboard-tree`, method: 'GET', signal },
    options
  );
};

export const getGetApiClientsPlantDashboardTreeQueryKey = () => {
  return [`/api/Clients/plant-dashboard-tree`] as const;
};

export const getGetApiClientsPlantDashboardTreeQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiClientsPlantDashboardTree>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiClientsPlantDashboardTree>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiClientsPlantDashboardTreeQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiClientsPlantDashboardTree>>
  > = ({ signal }) => getApiClientsPlantDashboardTree(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiClientsPlantDashboardTree>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiClientsPlantDashboardTreeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiClientsPlantDashboardTree>>
>;
export type GetApiClientsPlantDashboardTreeQueryError = unknown;

export function useGetApiClientsPlantDashboardTree<
  TData = Awaited<ReturnType<typeof getApiClientsPlantDashboardTree>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiClientsPlantDashboardTree>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiClientsPlantDashboardTreeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiCsvSchemas = (
  createCsvSchemaRequest: CreateCsvSchemaRequest,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CsvSchemaResponse>(
    {
      url: `/api/csv/schemas`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createCsvSchemaRequest,
      signal,
    },
    options
  );
};

export const getPostApiCsvSchemasMutationOptions = <
  TError = ProblemDetails | ProblemDetails | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCsvSchemas>>,
    TError,
    { data: CreateCsvSchemaRequest },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCsvSchemas>>,
  TError,
  { data: CreateCsvSchemaRequest },
  TContext
> => {
  const mutationKey = ['postApiCsvSchemas'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCsvSchemas>>,
    { data: CreateCsvSchemaRequest }
  > = props => {
    const { data } = props ?? {};

    return postApiCsvSchemas(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCsvSchemasMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCsvSchemas>>
>;
export type PostApiCsvSchemasMutationBody = CreateCsvSchemaRequest;
export type PostApiCsvSchemasMutationError =
  | ProblemDetails
  | ProblemDetails
  | void;

export const usePostApiCsvSchemas = <
  TError = ProblemDetails | ProblemDetails | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCsvSchemas>>,
    TError,
    { data: CreateCsvSchemaRequest },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiCsvSchemas>>,
  TError,
  { data: CreateCsvSchemaRequest },
  TContext
> => {
  const mutationOptions = getPostApiCsvSchemasMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiCsvSchemas = (
  updateCsvSchemaRequestDto: UpdateCsvSchemaRequestDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CsvSchemaResponse>(
    {
      url: `/api/csv/schemas`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateCsvSchemaRequestDto,
    },
    options
  );
};

export const getPutApiCsvSchemasMutationOptions = <
  TError = ProblemDetails | ProblemDetails | ProblemDetails | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiCsvSchemas>>,
    TError,
    { data: UpdateCsvSchemaRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiCsvSchemas>>,
  TError,
  { data: UpdateCsvSchemaRequestDto },
  TContext
> => {
  const mutationKey = ['putApiCsvSchemas'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiCsvSchemas>>,
    { data: UpdateCsvSchemaRequestDto }
  > = props => {
    const { data } = props ?? {};

    return putApiCsvSchemas(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiCsvSchemasMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiCsvSchemas>>
>;
export type PutApiCsvSchemasMutationBody = UpdateCsvSchemaRequestDto;
export type PutApiCsvSchemasMutationError =
  | ProblemDetails
  | ProblemDetails
  | ProblemDetails
  | void;

export const usePutApiCsvSchemas = <
  TError = ProblemDetails | ProblemDetails | ProblemDetails | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiCsvSchemas>>,
    TError,
    { data: UpdateCsvSchemaRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiCsvSchemas>>,
  TError,
  { data: UpdateCsvSchemaRequestDto },
  TContext
> => {
  const mutationOptions = getPutApiCsvSchemasMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiCsvColunmsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CsvColunmDto>(
    { url: `/api/csv/colunms/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiCsvColunmsIdQueryKey = (id?: number) => {
  return [`/api/csv/colunms/${id}`] as const;
};

export const getGetApiCsvColunmsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCsvColunmsId>>,
  TError = ProblemDetails | ProblemDetails | ProblemDetails | void,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiCsvColunmsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiCsvColunmsIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCsvColunmsId>>
  > = ({ signal }) => getApiCsvColunmsId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCsvColunmsId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiCsvColunmsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCsvColunmsId>>
>;
export type GetApiCsvColunmsIdQueryError =
  | ProblemDetails
  | ProblemDetails
  | ProblemDetails
  | void;

export function useGetApiCsvColunmsId<
  TData = Awaited<ReturnType<typeof getApiCsvColunmsId>>,
  TError = ProblemDetails | ProblemDetails | ProblemDetails | void,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiCsvColunmsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiCsvColunmsIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiCsvSchemasColumns = (
  addColumnsToSchemaRequest: AddColumnsToSchemaRequest,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CsvColumnResponse[]>(
    {
      url: `/api/csv/schemas/columns`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: addColumnsToSchemaRequest,
      signal,
    },
    options
  );
};

export const getPostApiCsvSchemasColumnsMutationOptions = <
  TError = ProblemDetails | ProblemDetails | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCsvSchemasColumns>>,
    TError,
    { data: AddColumnsToSchemaRequest },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCsvSchemasColumns>>,
  TError,
  { data: AddColumnsToSchemaRequest },
  TContext
> => {
  const mutationKey = ['postApiCsvSchemasColumns'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCsvSchemasColumns>>,
    { data: AddColumnsToSchemaRequest }
  > = props => {
    const { data } = props ?? {};

    return postApiCsvSchemasColumns(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCsvSchemasColumnsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCsvSchemasColumns>>
>;
export type PostApiCsvSchemasColumnsMutationBody = AddColumnsToSchemaRequest;
export type PostApiCsvSchemasColumnsMutationError =
  | ProblemDetails
  | ProblemDetails
  | void;

export const usePostApiCsvSchemasColumns = <
  TError = ProblemDetails | ProblemDetails | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCsvSchemasColumns>>,
    TError,
    { data: AddColumnsToSchemaRequest },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiCsvSchemasColumns>>,
  TError,
  { data: AddColumnsToSchemaRequest },
  TContext
> => {
  const mutationOptions = getPostApiCsvSchemasColumnsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiCsvSchemasColumns = (
  updateCsvColumnRequestDto: UpdateCsvColumnRequestDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CsvColumnResponse>(
    {
      url: `/api/csv/schemas/columns`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateCsvColumnRequestDto,
    },
    options
  );
};

export const getPutApiCsvSchemasColumnsMutationOptions = <
  TError = ProblemDetails | ProblemDetails | ProblemDetails | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiCsvSchemasColumns>>,
    TError,
    { data: UpdateCsvColumnRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiCsvSchemasColumns>>,
  TError,
  { data: UpdateCsvColumnRequestDto },
  TContext
> => {
  const mutationKey = ['putApiCsvSchemasColumns'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiCsvSchemasColumns>>,
    { data: UpdateCsvColumnRequestDto }
  > = props => {
    const { data } = props ?? {};

    return putApiCsvSchemasColumns(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiCsvSchemasColumnsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiCsvSchemasColumns>>
>;
export type PutApiCsvSchemasColumnsMutationBody = UpdateCsvColumnRequestDto;
export type PutApiCsvSchemasColumnsMutationError =
  | ProblemDetails
  | ProblemDetails
  | ProblemDetails
  | void;

export const usePutApiCsvSchemasColumns = <
  TError = ProblemDetails | ProblemDetails | ProblemDetails | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiCsvSchemasColumns>>,
    TError,
    { data: UpdateCsvColumnRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiCsvSchemasColumns>>,
  TError,
  { data: UpdateCsvColumnRequestDto },
  TContext
> => {
  const mutationOptions = getPutApiCsvSchemasColumnsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiCsvSchemasId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CsvSchemaResponse>(
    { url: `/api/csv/schemas/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiCsvSchemasIdQueryKey = (id?: number) => {
  return [`/api/csv/schemas/${id}`] as const;
};

export const getGetApiCsvSchemasIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCsvSchemasId>>,
  TError = ProblemDetails | ProblemDetails | void,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiCsvSchemasId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiCsvSchemasIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCsvSchemasId>>
  > = ({ signal }) => getApiCsvSchemasId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCsvSchemasId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiCsvSchemasIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCsvSchemasId>>
>;
export type GetApiCsvSchemasIdQueryError =
  | ProblemDetails
  | ProblemDetails
  | void;

export function useGetApiCsvSchemasId<
  TData = Awaited<ReturnType<typeof getApiCsvSchemasId>>,
  TError = ProblemDetails | ProblemDetails | void,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiCsvSchemasId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiCsvSchemasIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteApiCsvSchemasId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/csv/schemas/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiCsvSchemasIdMutationOptions = <
  TError = ProblemDetails | ProblemDetails | ProblemDetails | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiCsvSchemasId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiCsvSchemasId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiCsvSchemasId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiCsvSchemasId>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiCsvSchemasId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiCsvSchemasIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiCsvSchemasId>>
>;

export type DeleteApiCsvSchemasIdMutationError =
  | ProblemDetails
  | ProblemDetails
  | ProblemDetails
  | void;

export const useDeleteApiCsvSchemasId = <
  TError = ProblemDetails | ProblemDetails | ProblemDetails | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiCsvSchemasId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiCsvSchemasId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteApiCsvSchemasIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiCsvSchemasPlantPlantId = (
  plantId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CsvSchemaResponse[]>(
    { url: `/api/csv/schemas/plant/${plantId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiCsvSchemasPlantPlantIdQueryKey = (plantId?: number) => {
  return [`/api/csv/schemas/plant/${plantId}`] as const;
};

export const getGetApiCsvSchemasPlantPlantIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCsvSchemasPlantPlantId>>,
  TError = ProblemDetails | void,
>(
  plantId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiCsvSchemasPlantPlantId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCsvSchemasPlantPlantIdQueryKey(plantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCsvSchemasPlantPlantId>>
  > = ({ signal }) =>
    getApiCsvSchemasPlantPlantId(plantId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!plantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCsvSchemasPlantPlantId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiCsvSchemasPlantPlantIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCsvSchemasPlantPlantId>>
>;
export type GetApiCsvSchemasPlantPlantIdQueryError = ProblemDetails | void;

export function useGetApiCsvSchemasPlantPlantId<
  TData = Awaited<ReturnType<typeof getApiCsvSchemasPlantPlantId>>,
  TError = ProblemDetails | void,
>(
  plantId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiCsvSchemasPlantPlantId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiCsvSchemasPlantPlantIdQueryOptions(
    plantId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiCsvRecords = (
  createCsvRecordRequest: CreateCsvRecordRequest,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CsvRecordResponse>(
    {
      url: `/api/csv/records`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createCsvRecordRequest,
      signal,
    },
    options
  );
};

export const getPostApiCsvRecordsMutationOptions = <
  TError = ProblemDetails | ProblemDetails | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCsvRecords>>,
    TError,
    { data: CreateCsvRecordRequest },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCsvRecords>>,
  TError,
  { data: CreateCsvRecordRequest },
  TContext
> => {
  const mutationKey = ['postApiCsvRecords'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCsvRecords>>,
    { data: CreateCsvRecordRequest }
  > = props => {
    const { data } = props ?? {};

    return postApiCsvRecords(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCsvRecordsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCsvRecords>>
>;
export type PostApiCsvRecordsMutationBody = CreateCsvRecordRequest;
export type PostApiCsvRecordsMutationError =
  | ProblemDetails
  | ProblemDetails
  | void;

export const usePostApiCsvRecords = <
  TError = ProblemDetails | ProblemDetails | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCsvRecords>>,
    TError,
    { data: CreateCsvRecordRequest },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiCsvRecords>>,
  TError,
  { data: CreateCsvRecordRequest },
  TContext
> => {
  const mutationOptions = getPostApiCsvRecordsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiCsvRecordsBatch = (
  createCsvRecordRequest: CreateCsvRecordRequest[],
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CsvRecordResponse[]>(
    {
      url: `/api/csv/records/batch`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createCsvRecordRequest,
      signal,
    },
    options
  );
};

export const getPostApiCsvRecordsBatchMutationOptions = <
  TError = ProblemDetails | ProblemDetails | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCsvRecordsBatch>>,
    TError,
    { data: CreateCsvRecordRequest[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCsvRecordsBatch>>,
  TError,
  { data: CreateCsvRecordRequest[] },
  TContext
> => {
  const mutationKey = ['postApiCsvRecordsBatch'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCsvRecordsBatch>>,
    { data: CreateCsvRecordRequest[] }
  > = props => {
    const { data } = props ?? {};

    return postApiCsvRecordsBatch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCsvRecordsBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCsvRecordsBatch>>
>;
export type PostApiCsvRecordsBatchMutationBody = CreateCsvRecordRequest[];
export type PostApiCsvRecordsBatchMutationError =
  | ProblemDetails
  | ProblemDetails
  | void;

export const usePostApiCsvRecordsBatch = <
  TError = ProblemDetails | ProblemDetails | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCsvRecordsBatch>>,
    TError,
    { data: CreateCsvRecordRequest[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiCsvRecordsBatch>>,
  TError,
  { data: CreateCsvRecordRequest[] },
  TContext
> => {
  const mutationOptions = getPostApiCsvRecordsBatchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiCsvRecordsBatchCsvSchemaId = (
  csvSchemaId: number,
  createCsvRecordBatchItemRequest: CreateCsvRecordBatchItemRequest[],
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CsvRecordResponse[]>(
    {
      url: `/api/csv/records/batch/${csvSchemaId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createCsvRecordBatchItemRequest,
      signal,
    },
    options
  );
};

export const getPostApiCsvRecordsBatchCsvSchemaIdMutationOptions = <
  TError = ProblemDetails | ProblemDetails | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCsvRecordsBatchCsvSchemaId>>,
    TError,
    { csvSchemaId: number; data: CreateCsvRecordBatchItemRequest[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCsvRecordsBatchCsvSchemaId>>,
  TError,
  { csvSchemaId: number; data: CreateCsvRecordBatchItemRequest[] },
  TContext
> => {
  const mutationKey = ['postApiCsvRecordsBatchCsvSchemaId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCsvRecordsBatchCsvSchemaId>>,
    { csvSchemaId: number; data: CreateCsvRecordBatchItemRequest[] }
  > = props => {
    const { csvSchemaId, data } = props ?? {};

    return postApiCsvRecordsBatchCsvSchemaId(csvSchemaId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCsvRecordsBatchCsvSchemaIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCsvRecordsBatchCsvSchemaId>>
>;
export type PostApiCsvRecordsBatchCsvSchemaIdMutationBody =
  CreateCsvRecordBatchItemRequest[];
export type PostApiCsvRecordsBatchCsvSchemaIdMutationError =
  | ProblemDetails
  | ProblemDetails
  | void;

export const usePostApiCsvRecordsBatchCsvSchemaId = <
  TError = ProblemDetails | ProblemDetails | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCsvRecordsBatchCsvSchemaId>>,
    TError,
    { csvSchemaId: number; data: CreateCsvRecordBatchItemRequest[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiCsvRecordsBatchCsvSchemaId>>,
  TError,
  { csvSchemaId: number; data: CreateCsvRecordBatchItemRequest[] },
  TContext
> => {
  const mutationOptions =
    getPostApiCsvRecordsBatchCsvSchemaIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiCsvRecordsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CsvRecordResponse>(
    { url: `/api/csv/records/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiCsvRecordsIdQueryKey = (id?: number) => {
  return [`/api/csv/records/${id}`] as const;
};

export const getGetApiCsvRecordsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCsvRecordsId>>,
  TError = ProblemDetails | ProblemDetails | void,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiCsvRecordsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiCsvRecordsIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCsvRecordsId>>
  > = ({ signal }) => getApiCsvRecordsId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCsvRecordsId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiCsvRecordsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCsvRecordsId>>
>;
export type GetApiCsvRecordsIdQueryError =
  | ProblemDetails
  | ProblemDetails
  | void;

export function useGetApiCsvRecordsId<
  TData = Awaited<ReturnType<typeof getApiCsvRecordsId>>,
  TError = ProblemDetails | ProblemDetails | void,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiCsvRecordsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiCsvRecordsIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiCsvRecordsSchemaSchemaId = (
  schemaId: number,
  params?: GetApiCsvRecordsSchemaSchemaIdParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CsvRecordResponsePaginatedResponseDto>(
    {
      url: `/api/csv/records/schema/${schemaId}`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetApiCsvRecordsSchemaSchemaIdQueryKey = (
  schemaId?: number,
  params?: GetApiCsvRecordsSchemaSchemaIdParams
) => {
  return [
    `/api/csv/records/schema/${schemaId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCsvRecordsSchemaSchemaIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCsvRecordsSchemaSchemaId>>,
  TError = ProblemDetails | void,
>(
  schemaId: number,
  params?: GetApiCsvRecordsSchemaSchemaIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiCsvRecordsSchemaSchemaId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCsvRecordsSchemaSchemaIdQueryKey(schemaId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCsvRecordsSchemaSchemaId>>
  > = ({ signal }) =>
    getApiCsvRecordsSchemaSchemaId(schemaId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!schemaId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCsvRecordsSchemaSchemaId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiCsvRecordsSchemaSchemaIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCsvRecordsSchemaSchemaId>>
>;
export type GetApiCsvRecordsSchemaSchemaIdQueryError = ProblemDetails | void;

export function useGetApiCsvRecordsSchemaSchemaId<
  TData = Awaited<ReturnType<typeof getApiCsvRecordsSchemaSchemaId>>,
  TError = ProblemDetails | void,
>(
  schemaId: number,
  params?: GetApiCsvRecordsSchemaSchemaIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiCsvRecordsSchemaSchemaId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiCsvRecordsSchemaSchemaIdQueryOptions(
    schemaId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiCsvRecordsFilter = (
  csvRecordFilterRequestDto: CsvRecordFilterRequestDto,
  params?: PostApiCsvRecordsFilterParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CsvRecordResponsePaginatedResponseDto>(
    {
      url: `/api/csv/records/filter`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: csvRecordFilterRequestDto,
      params,
      signal,
    },
    options
  );
};

export const getPostApiCsvRecordsFilterMutationOptions = <
  TError = ProblemDetails | ProblemDetails | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCsvRecordsFilter>>,
    TError,
    { data: CsvRecordFilterRequestDto; params?: PostApiCsvRecordsFilterParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCsvRecordsFilter>>,
  TError,
  { data: CsvRecordFilterRequestDto; params?: PostApiCsvRecordsFilterParams },
  TContext
> => {
  const mutationKey = ['postApiCsvRecordsFilter'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCsvRecordsFilter>>,
    { data: CsvRecordFilterRequestDto; params?: PostApiCsvRecordsFilterParams }
  > = props => {
    const { data, params } = props ?? {};

    return postApiCsvRecordsFilter(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCsvRecordsFilterMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCsvRecordsFilter>>
>;
export type PostApiCsvRecordsFilterMutationBody = CsvRecordFilterRequestDto;
export type PostApiCsvRecordsFilterMutationError =
  | ProblemDetails
  | ProblemDetails
  | void;

export const usePostApiCsvRecordsFilter = <
  TError = ProblemDetails | ProblemDetails | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCsvRecordsFilter>>,
    TError,
    { data: CsvRecordFilterRequestDto; params?: PostApiCsvRecordsFilterParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiCsvRecordsFilter>>,
  TError,
  { data: CsvRecordFilterRequestDto; params?: PostApiCsvRecordsFilterParams },
  TContext
> => {
  const mutationOptions = getPostApiCsvRecordsFilterMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiDashboardGroups = (
  params?: GetApiDashboardGroupsParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/DashboardGroups`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiDashboardGroupsQueryKey = (
  params?: GetApiDashboardGroupsParams
) => {
  return [`/api/DashboardGroups`, ...(params ? [params] : [])] as const;
};

export const getGetApiDashboardGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDashboardGroups>>,
  TError = unknown,
>(
  params?: GetApiDashboardGroupsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDashboardGroups>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiDashboardGroupsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiDashboardGroups>>
  > = ({ signal }) => getApiDashboardGroups(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDashboardGroups>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiDashboardGroupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDashboardGroups>>
>;
export type GetApiDashboardGroupsQueryError = unknown;

export function useGetApiDashboardGroups<
  TData = Awaited<ReturnType<typeof getApiDashboardGroups>>,
  TError = unknown,
>(
  params?: GetApiDashboardGroupsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDashboardGroups>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiDashboardGroupsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiDashboardGroups = (
  createDashboardGroupDto: CreateDashboardGroupDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CreateResponseDto>(
    {
      url: `/api/DashboardGroups`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createDashboardGroupDto,
      signal,
    },
    options
  );
};

export const getPostApiDashboardGroupsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDashboardGroups>>,
    TError,
    { data: CreateDashboardGroupDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiDashboardGroups>>,
  TError,
  { data: CreateDashboardGroupDto },
  TContext
> => {
  const mutationKey = ['postApiDashboardGroups'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiDashboardGroups>>,
    { data: CreateDashboardGroupDto }
  > = props => {
    const { data } = props ?? {};

    return postApiDashboardGroups(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiDashboardGroupsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiDashboardGroups>>
>;
export type PostApiDashboardGroupsMutationBody = CreateDashboardGroupDto;
export type PostApiDashboardGroupsMutationError = unknown;

export const usePostApiDashboardGroups = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDashboardGroups>>,
    TError,
    { data: CreateDashboardGroupDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiDashboardGroups>>,
  TError,
  { data: CreateDashboardGroupDto },
  TContext
> => {
  const mutationOptions = getPostApiDashboardGroupsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiDashboardGroupsByPlant = (
  params?: GetApiDashboardGroupsByPlantParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/DashboardGroups/ByPlant`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiDashboardGroupsByPlantQueryKey = (
  params?: GetApiDashboardGroupsByPlantParams
) => {
  return [`/api/DashboardGroups/ByPlant`, ...(params ? [params] : [])] as const;
};

export const getGetApiDashboardGroupsByPlantQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDashboardGroupsByPlant>>,
  TError = unknown,
>(
  params?: GetApiDashboardGroupsByPlantParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDashboardGroupsByPlant>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiDashboardGroupsByPlantQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiDashboardGroupsByPlant>>
  > = ({ signal }) =>
    getApiDashboardGroupsByPlant(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDashboardGroupsByPlant>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiDashboardGroupsByPlantQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDashboardGroupsByPlant>>
>;
export type GetApiDashboardGroupsByPlantQueryError = unknown;

export function useGetApiDashboardGroupsByPlant<
  TData = Awaited<ReturnType<typeof getApiDashboardGroupsByPlant>>,
  TError = unknown,
>(
  params?: GetApiDashboardGroupsByPlantParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDashboardGroupsByPlant>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiDashboardGroupsByPlantQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiDashboardGroupsGetListAdmin = (
  params?: GetApiDashboardGroupsGetListAdminParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/DashboardGroups/GetListAdmin`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiDashboardGroupsGetListAdminQueryKey = (
  params?: GetApiDashboardGroupsGetListAdminParams
) => {
  return [
    `/api/DashboardGroups/GetListAdmin`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiDashboardGroupsGetListAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDashboardGroupsGetListAdmin>>,
  TError = unknown,
>(
  params?: GetApiDashboardGroupsGetListAdminParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDashboardGroupsGetListAdmin>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiDashboardGroupsGetListAdminQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiDashboardGroupsGetListAdmin>>
  > = ({ signal }) =>
    getApiDashboardGroupsGetListAdmin(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDashboardGroupsGetListAdmin>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiDashboardGroupsGetListAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDashboardGroupsGetListAdmin>>
>;
export type GetApiDashboardGroupsGetListAdminQueryError = unknown;

export function useGetApiDashboardGroupsGetListAdmin<
  TData = Awaited<ReturnType<typeof getApiDashboardGroupsGetListAdmin>>,
  TError = unknown,
>(
  params?: GetApiDashboardGroupsGetListAdminParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDashboardGroupsGetListAdmin>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiDashboardGroupsGetListAdminQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiDashboardGroupsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/DashboardGroups/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiDashboardGroupsIdQueryKey = (id?: number) => {
  return [`/api/DashboardGroups/${id}`] as const;
};

export const getGetApiDashboardGroupsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDashboardGroupsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDashboardGroupsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiDashboardGroupsIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiDashboardGroupsId>>
  > = ({ signal }) => getApiDashboardGroupsId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDashboardGroupsId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiDashboardGroupsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDashboardGroupsId>>
>;
export type GetApiDashboardGroupsIdQueryError = unknown;

export function useGetApiDashboardGroupsId<
  TData = Awaited<ReturnType<typeof getApiDashboardGroupsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDashboardGroupsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiDashboardGroupsIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiDashboardGroupsId = (
  id: number,
  dashboardGroupDto: DashboardGroupDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    {
      url: `/api/DashboardGroups/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: dashboardGroupDto,
    },
    options
  );
};

export const getPutApiDashboardGroupsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiDashboardGroupsId>>,
    TError,
    { id: number; data: DashboardGroupDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiDashboardGroupsId>>,
  TError,
  { id: number; data: DashboardGroupDto },
  TContext
> => {
  const mutationKey = ['putApiDashboardGroupsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiDashboardGroupsId>>,
    { id: number; data: DashboardGroupDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiDashboardGroupsId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiDashboardGroupsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiDashboardGroupsId>>
>;
export type PutApiDashboardGroupsIdMutationBody = DashboardGroupDto;
export type PutApiDashboardGroupsIdMutationError = unknown;

export const usePutApiDashboardGroupsId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiDashboardGroupsId>>,
    TError,
    { id: number; data: DashboardGroupDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiDashboardGroupsId>>,
  TError,
  { id: number; data: DashboardGroupDto },
  TContext
> => {
  const mutationOptions = getPutApiDashboardGroupsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiDashboardGroupsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    { url: `/api/DashboardGroups/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiDashboardGroupsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiDashboardGroupsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiDashboardGroupsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiDashboardGroupsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiDashboardGroupsId>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiDashboardGroupsId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiDashboardGroupsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiDashboardGroupsId>>
>;

export type DeleteApiDashboardGroupsIdMutationError = unknown;

export const useDeleteApiDashboardGroupsId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiDashboardGroupsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiDashboardGroupsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteApiDashboardGroupsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiDashboardGroupsRange = (
  dashboardGroupDto: DashboardGroupDto[],
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    {
      url: `/api/DashboardGroups/range`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: dashboardGroupDto,
    },
    options
  );
};

export const getPutApiDashboardGroupsRangeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiDashboardGroupsRange>>,
    TError,
    { data: DashboardGroupDto[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiDashboardGroupsRange>>,
  TError,
  { data: DashboardGroupDto[] },
  TContext
> => {
  const mutationKey = ['putApiDashboardGroupsRange'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiDashboardGroupsRange>>,
    { data: DashboardGroupDto[] }
  > = props => {
    const { data } = props ?? {};

    return putApiDashboardGroupsRange(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiDashboardGroupsRangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiDashboardGroupsRange>>
>;
export type PutApiDashboardGroupsRangeMutationBody = DashboardGroupDto[];
export type PutApiDashboardGroupsRangeMutationError = unknown;

export const usePutApiDashboardGroupsRange = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiDashboardGroupsRange>>,
    TError,
    { data: DashboardGroupDto[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiDashboardGroupsRange>>,
  TError,
  { data: DashboardGroupDto[] },
  TContext
> => {
  const mutationOptions = getPutApiDashboardGroupsRangeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiDashboards = (
  params?: GetApiDashboardsParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Dashboards`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiDashboardsQueryKey = (
  params?: GetApiDashboardsParams
) => {
  return [`/api/Dashboards`, ...(params ? [params] : [])] as const;
};

export const getGetApiDashboardsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDashboards>>,
  TError = unknown,
>(
  params?: GetApiDashboardsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDashboards>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiDashboardsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiDashboards>>
  > = ({ signal }) => getApiDashboards(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDashboards>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiDashboardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDashboards>>
>;
export type GetApiDashboardsQueryError = unknown;

export function useGetApiDashboards<
  TData = Awaited<ReturnType<typeof getApiDashboards>>,
  TError = unknown,
>(
  params?: GetApiDashboardsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDashboards>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiDashboardsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiDashboards = (
  createDashboardDto: CreateDashboardDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CreateResponseDto>(
    {
      url: `/api/Dashboards`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createDashboardDto,
      signal,
    },
    options
  );
};

export const getPostApiDashboardsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDashboards>>,
    TError,
    { data: CreateDashboardDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiDashboards>>,
  TError,
  { data: CreateDashboardDto },
  TContext
> => {
  const mutationKey = ['postApiDashboards'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiDashboards>>,
    { data: CreateDashboardDto }
  > = props => {
    const { data } = props ?? {};

    return postApiDashboards(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiDashboardsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiDashboards>>
>;
export type PostApiDashboardsMutationBody = CreateDashboardDto;
export type PostApiDashboardsMutationError = unknown;

export const usePostApiDashboards = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDashboards>>,
    TError,
    { data: CreateDashboardDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiDashboards>>,
  TError,
  { data: CreateDashboardDto },
  TContext
> => {
  const mutationOptions = getPostApiDashboardsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiDashboardsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Dashboards/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiDashboardsIdQueryKey = (id?: number) => {
  return [`/api/Dashboards/${id}`] as const;
};

export const getGetApiDashboardsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDashboardsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDashboardsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiDashboardsIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiDashboardsId>>
  > = ({ signal }) => getApiDashboardsId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDashboardsId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiDashboardsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDashboardsId>>
>;
export type GetApiDashboardsIdQueryError = unknown;

export function useGetApiDashboardsId<
  TData = Awaited<ReturnType<typeof getApiDashboardsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDashboardsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiDashboardsIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiDashboardsId = (
  id: number,
  dashboardDto: DashboardDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    {
      url: `/api/Dashboards/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: dashboardDto,
    },
    options
  );
};

export const getPutApiDashboardsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiDashboardsId>>,
    TError,
    { id: number; data: DashboardDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiDashboardsId>>,
  TError,
  { id: number; data: DashboardDto },
  TContext
> => {
  const mutationKey = ['putApiDashboardsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiDashboardsId>>,
    { id: number; data: DashboardDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiDashboardsId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiDashboardsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiDashboardsId>>
>;
export type PutApiDashboardsIdMutationBody = DashboardDto;
export type PutApiDashboardsIdMutationError = unknown;

export const usePutApiDashboardsId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiDashboardsId>>,
    TError,
    { id: number; data: DashboardDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiDashboardsId>>,
  TError,
  { id: number; data: DashboardDto },
  TContext
> => {
  const mutationOptions = getPutApiDashboardsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiDashboardsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    { url: `/api/Dashboards/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiDashboardsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiDashboardsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiDashboardsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiDashboardsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiDashboardsId>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiDashboardsId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiDashboardsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiDashboardsId>>
>;

export type DeleteApiDashboardsIdMutationError = unknown;

export const useDeleteApiDashboardsId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiDashboardsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiDashboardsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteApiDashboardsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiDashboardsByDashboardGroupDashboardGroupId = (
  dashboardGroupId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Dashboards/ByDashboardGroup/${dashboardGroupId}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetApiDashboardsByDashboardGroupDashboardGroupIdQueryKey = (
  dashboardGroupId?: number
) => {
  return [`/api/Dashboards/ByDashboardGroup/${dashboardGroupId}`] as const;
};

export const getGetApiDashboardsByDashboardGroupDashboardGroupIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiDashboardsByDashboardGroupDashboardGroupId>
  >,
  TError = unknown,
>(
  dashboardGroupId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiDashboardsByDashboardGroupDashboardGroupId>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiDashboardsByDashboardGroupDashboardGroupIdQueryKey(
      dashboardGroupId
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiDashboardsByDashboardGroupDashboardGroupId>>
  > = ({ signal }) =>
    getApiDashboardsByDashboardGroupDashboardGroupId(
      dashboardGroupId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!dashboardGroupId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getApiDashboardsByDashboardGroupDashboardGroupId>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiDashboardsByDashboardGroupDashboardGroupIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiDashboardsByDashboardGroupDashboardGroupId>>
  >;
export type GetApiDashboardsByDashboardGroupDashboardGroupIdQueryError =
  unknown;

export function useGetApiDashboardsByDashboardGroupDashboardGroupId<
  TData = Awaited<
    ReturnType<typeof getApiDashboardsByDashboardGroupDashboardGroupId>
  >,
  TError = unknown,
>(
  dashboardGroupId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiDashboardsByDashboardGroupDashboardGroupId>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getGetApiDashboardsByDashboardGroupDashboardGroupIdQueryOptions(
      dashboardGroupId,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiDashboardsRange = (
  dashboardDto: DashboardDto[],
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    {
      url: `/api/Dashboards/range`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: dashboardDto,
    },
    options
  );
};

export const getPutApiDashboardsRangeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiDashboardsRange>>,
    TError,
    { data: DashboardDto[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiDashboardsRange>>,
  TError,
  { data: DashboardDto[] },
  TContext
> => {
  const mutationKey = ['putApiDashboardsRange'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiDashboardsRange>>,
    { data: DashboardDto[] }
  > = props => {
    const { data } = props ?? {};

    return putApiDashboardsRange(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiDashboardsRangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiDashboardsRange>>
>;
export type PutApiDashboardsRangeMutationBody = DashboardDto[];
export type PutApiDashboardsRangeMutationError = unknown;

export const usePutApiDashboardsRange = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiDashboardsRange>>,
    TError,
    { data: DashboardDto[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiDashboardsRange>>,
  TError,
  { data: DashboardDto[] },
  TContext
> => {
  const mutationOptions = getPutApiDashboardsRangeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiDiagramEdgesId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/DiagramEdges/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiDiagramEdgesIdQueryKey = (id?: number) => {
  return [`/api/DiagramEdges/${id}`] as const;
};

export const getGetApiDiagramEdgesIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDiagramEdgesId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDiagramEdgesId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiDiagramEdgesIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiDiagramEdgesId>>
  > = ({ signal }) => getApiDiagramEdgesId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDiagramEdgesId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiDiagramEdgesIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDiagramEdgesId>>
>;
export type GetApiDiagramEdgesIdQueryError = unknown;

export function useGetApiDiagramEdgesId<
  TData = Awaited<ReturnType<typeof getApiDiagramEdgesId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDiagramEdgesId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiDiagramEdgesIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiDiagramEdgesId = (
  id: number,
  diagramEdgeDto: DiagramEdgeDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    {
      url: `/api/DiagramEdges/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: diagramEdgeDto,
    },
    options
  );
};

export const getPutApiDiagramEdgesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiDiagramEdgesId>>,
    TError,
    { id: number; data: DiagramEdgeDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiDiagramEdgesId>>,
  TError,
  { id: number; data: DiagramEdgeDto },
  TContext
> => {
  const mutationKey = ['putApiDiagramEdgesId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiDiagramEdgesId>>,
    { id: number; data: DiagramEdgeDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiDiagramEdgesId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiDiagramEdgesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiDiagramEdgesId>>
>;
export type PutApiDiagramEdgesIdMutationBody = DiagramEdgeDto;
export type PutApiDiagramEdgesIdMutationError = unknown;

export const usePutApiDiagramEdgesId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiDiagramEdgesId>>,
    TError,
    { id: number; data: DiagramEdgeDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiDiagramEdgesId>>,
  TError,
  { id: number; data: DiagramEdgeDto },
  TContext
> => {
  const mutationOptions = getPutApiDiagramEdgesIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiDiagramEdgesId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    { url: `/api/DiagramEdges/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiDiagramEdgesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiDiagramEdgesId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiDiagramEdgesId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiDiagramEdgesId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiDiagramEdgesId>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiDiagramEdgesId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiDiagramEdgesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiDiagramEdgesId>>
>;

export type DeleteApiDiagramEdgesIdMutationError = unknown;

export const useDeleteApiDiagramEdgesId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiDiagramEdgesId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiDiagramEdgesId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteApiDiagramEdgesIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiDiagramEdgesByDiagramDiagramId = (
  diagramId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/DiagramEdges/ByDiagram/${diagramId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiDiagramEdgesByDiagramDiagramIdQueryKey = (
  diagramId?: number
) => {
  return [`/api/DiagramEdges/ByDiagram/${diagramId}`] as const;
};

export const getGetApiDiagramEdgesByDiagramDiagramIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDiagramEdgesByDiagramDiagramId>>,
  TError = unknown,
>(
  diagramId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDiagramEdgesByDiagramDiagramId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiDiagramEdgesByDiagramDiagramIdQueryKey(diagramId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiDiagramEdgesByDiagramDiagramId>>
  > = ({ signal }) =>
    getApiDiagramEdgesByDiagramDiagramId(diagramId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!diagramId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDiagramEdgesByDiagramDiagramId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiDiagramEdgesByDiagramDiagramIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDiagramEdgesByDiagramDiagramId>>
>;
export type GetApiDiagramEdgesByDiagramDiagramIdQueryError = unknown;

export function useGetApiDiagramEdgesByDiagramDiagramId<
  TData = Awaited<ReturnType<typeof getApiDiagramEdgesByDiagramDiagramId>>,
  TError = unknown,
>(
  diagramId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDiagramEdgesByDiagramDiagramId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiDiagramEdgesByDiagramDiagramIdQueryOptions(
    diagramId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiDiagramEdges = (
  createDiagramEdgeDto: CreateDiagramEdgeDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/DiagramEdges`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createDiagramEdgeDto,
      signal,
    },
    options
  );
};

export const getPostApiDiagramEdgesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDiagramEdges>>,
    TError,
    { data: CreateDiagramEdgeDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiDiagramEdges>>,
  TError,
  { data: CreateDiagramEdgeDto },
  TContext
> => {
  const mutationKey = ['postApiDiagramEdges'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiDiagramEdges>>,
    { data: CreateDiagramEdgeDto }
  > = props => {
    const { data } = props ?? {};

    return postApiDiagramEdges(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiDiagramEdgesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiDiagramEdges>>
>;
export type PostApiDiagramEdgesMutationBody = CreateDiagramEdgeDto;
export type PostApiDiagramEdgesMutationError = unknown;

export const usePostApiDiagramEdges = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDiagramEdges>>,
    TError,
    { data: CreateDiagramEdgeDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiDiagramEdges>>,
  TError,
  { data: CreateDiagramEdgeDto },
  TContext
> => {
  const mutationOptions = getPostApiDiagramEdgesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiDiagramNodeBulk = (
  diagramBulkPositionUpdateRequest: DiagramBulkPositionUpdateRequest,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/DiagramNode/bulk`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: diagramBulkPositionUpdateRequest,
    },
    options
  );
};

export const getPutApiDiagramNodeBulkMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiDiagramNodeBulk>>,
    TError,
    { data: DiagramBulkPositionUpdateRequest },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiDiagramNodeBulk>>,
  TError,
  { data: DiagramBulkPositionUpdateRequest },
  TContext
> => {
  const mutationKey = ['putApiDiagramNodeBulk'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiDiagramNodeBulk>>,
    { data: DiagramBulkPositionUpdateRequest }
  > = props => {
    const { data } = props ?? {};

    return putApiDiagramNodeBulk(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiDiagramNodeBulkMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiDiagramNodeBulk>>
>;
export type PutApiDiagramNodeBulkMutationBody =
  DiagramBulkPositionUpdateRequest;
export type PutApiDiagramNodeBulkMutationError = unknown;

export const usePutApiDiagramNodeBulk = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiDiagramNodeBulk>>,
    TError,
    { data: DiagramBulkPositionUpdateRequest },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiDiagramNodeBulk>>,
  TError,
  { data: DiagramBulkPositionUpdateRequest },
  TContext
> => {
  const mutationOptions = getPutApiDiagramNodeBulkMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiDiagramNodeId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/DiagramNode/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiDiagramNodeIdQueryKey = (id?: number) => {
  return [`/api/DiagramNode/${id}`] as const;
};

export const getGetApiDiagramNodeIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDiagramNodeId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDiagramNodeId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiDiagramNodeIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiDiagramNodeId>>
  > = ({ signal }) => getApiDiagramNodeId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDiagramNodeId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiDiagramNodeIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDiagramNodeId>>
>;
export type GetApiDiagramNodeIdQueryError = unknown;

export function useGetApiDiagramNodeId<
  TData = Awaited<ReturnType<typeof getApiDiagramNodeId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDiagramNodeId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiDiagramNodeIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiDiagramNodeId = (
  id: number,
  diagramNodeDto: DiagramNodeDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    {
      url: `/api/DiagramNode/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: diagramNodeDto,
    },
    options
  );
};

export const getPutApiDiagramNodeIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiDiagramNodeId>>,
    TError,
    { id: number; data: DiagramNodeDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiDiagramNodeId>>,
  TError,
  { id: number; data: DiagramNodeDto },
  TContext
> => {
  const mutationKey = ['putApiDiagramNodeId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiDiagramNodeId>>,
    { id: number; data: DiagramNodeDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiDiagramNodeId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiDiagramNodeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiDiagramNodeId>>
>;
export type PutApiDiagramNodeIdMutationBody = DiagramNodeDto;
export type PutApiDiagramNodeIdMutationError = unknown;

export const usePutApiDiagramNodeId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiDiagramNodeId>>,
    TError,
    { id: number; data: DiagramNodeDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiDiagramNodeId>>,
  TError,
  { id: number; data: DiagramNodeDto },
  TContext
> => {
  const mutationOptions = getPutApiDiagramNodeIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiDiagramNodeId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    { url: `/api/DiagramNode/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiDiagramNodeIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiDiagramNodeId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiDiagramNodeId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiDiagramNodeId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiDiagramNodeId>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiDiagramNodeId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiDiagramNodeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiDiagramNodeId>>
>;

export type DeleteApiDiagramNodeIdMutationError = unknown;

export const useDeleteApiDiagramNodeId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiDiagramNodeId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiDiagramNodeId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteApiDiagramNodeIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiDiagramNodeByDiagramDiagramId = (
  diagramId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/DiagramNode/ByDiagram/${diagramId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiDiagramNodeByDiagramDiagramIdQueryKey = (
  diagramId?: number
) => {
  return [`/api/DiagramNode/ByDiagram/${diagramId}`] as const;
};

export const getGetApiDiagramNodeByDiagramDiagramIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDiagramNodeByDiagramDiagramId>>,
  TError = unknown,
>(
  diagramId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDiagramNodeByDiagramDiagramId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiDiagramNodeByDiagramDiagramIdQueryKey(diagramId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiDiagramNodeByDiagramDiagramId>>
  > = ({ signal }) =>
    getApiDiagramNodeByDiagramDiagramId(diagramId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!diagramId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDiagramNodeByDiagramDiagramId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiDiagramNodeByDiagramDiagramIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDiagramNodeByDiagramDiagramId>>
>;
export type GetApiDiagramNodeByDiagramDiagramIdQueryError = unknown;

export function useGetApiDiagramNodeByDiagramDiagramId<
  TData = Awaited<ReturnType<typeof getApiDiagramNodeByDiagramDiagramId>>,
  TError = unknown,
>(
  diagramId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDiagramNodeByDiagramDiagramId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiDiagramNodeByDiagramDiagramIdQueryOptions(
    diagramId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiDiagramNode = (
  createDiagramNodeDto: CreateDiagramNodeDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/DiagramNode`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createDiagramNodeDto,
      signal,
    },
    options
  );
};

export const getPostApiDiagramNodeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDiagramNode>>,
    TError,
    { data: CreateDiagramNodeDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiDiagramNode>>,
  TError,
  { data: CreateDiagramNodeDto },
  TContext
> => {
  const mutationKey = ['postApiDiagramNode'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiDiagramNode>>,
    { data: CreateDiagramNodeDto }
  > = props => {
    const { data } = props ?? {};

    return postApiDiagramNode(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiDiagramNodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiDiagramNode>>
>;
export type PostApiDiagramNodeMutationBody = CreateDiagramNodeDto;
export type PostApiDiagramNodeMutationError = unknown;

export const usePostApiDiagramNode = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDiagramNode>>,
    TError,
    { data: CreateDiagramNodeDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiDiagramNode>>,
  TError,
  { data: CreateDiagramNodeDto },
  TContext
> => {
  const mutationOptions = getPostApiDiagramNodeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiDiagrams = (
  params?: GetApiDiagramsParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Diagrams`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiDiagramsQueryKey = (params?: GetApiDiagramsParams) => {
  return [`/api/Diagrams`, ...(params ? [params] : [])] as const;
};

export const getGetApiDiagramsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDiagrams>>,
  TError = unknown,
>(
  params?: GetApiDiagramsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDiagrams>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiDiagramsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDiagrams>>> = ({
    signal,
  }) => getApiDiagrams(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDiagrams>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiDiagramsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDiagrams>>
>;
export type GetApiDiagramsQueryError = unknown;

export function useGetApiDiagrams<
  TData = Awaited<ReturnType<typeof getApiDiagrams>>,
  TError = unknown,
>(
  params?: GetApiDiagramsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDiagrams>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiDiagramsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiDiagrams = (
  createDiagramDto: CreateDiagramDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Diagrams`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createDiagramDto,
      signal,
    },
    options
  );
};

export const getPostApiDiagramsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDiagrams>>,
    TError,
    { data: CreateDiagramDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiDiagrams>>,
  TError,
  { data: CreateDiagramDto },
  TContext
> => {
  const mutationKey = ['postApiDiagrams'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiDiagrams>>,
    { data: CreateDiagramDto }
  > = props => {
    const { data } = props ?? {};

    return postApiDiagrams(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiDiagramsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiDiagrams>>
>;
export type PostApiDiagramsMutationBody = CreateDiagramDto;
export type PostApiDiagramsMutationError = unknown;

export const usePostApiDiagrams = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDiagrams>>,
    TError,
    { data: CreateDiagramDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiDiagrams>>,
  TError,
  { data: CreateDiagramDto },
  TContext
> => {
  const mutationOptions = getPostApiDiagramsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiDiagrams = (
  diagramDto: DiagramDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    {
      url: `/api/Diagrams`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: diagramDto,
    },
    options
  );
};

export const getPutApiDiagramsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiDiagrams>>,
    TError,
    { data: DiagramDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiDiagrams>>,
  TError,
  { data: DiagramDto },
  TContext
> => {
  const mutationKey = ['putApiDiagrams'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiDiagrams>>,
    { data: DiagramDto }
  > = props => {
    const { data } = props ?? {};

    return putApiDiagrams(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiDiagramsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiDiagrams>>
>;
export type PutApiDiagramsMutationBody = DiagramDto;
export type PutApiDiagramsMutationError = unknown;

export const usePutApiDiagrams = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiDiagrams>>,
    TError,
    { data: DiagramDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiDiagrams>>,
  TError,
  { data: DiagramDto },
  TContext
> => {
  const mutationOptions = getPutApiDiagramsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiDiagramsId = (
  id: number,
  params?: GetApiDiagramsIdParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Diagrams/${id}`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiDiagramsIdQueryKey = (
  id?: number,
  params?: GetApiDiagramsIdParams
) => {
  return [`/api/Diagrams/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetApiDiagramsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDiagramsId>>,
  TError = unknown,
>(
  id: number,
  params?: GetApiDiagramsIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDiagramsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiDiagramsIdQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiDiagramsId>>
  > = ({ signal }) => getApiDiagramsId(id, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDiagramsId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiDiagramsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDiagramsId>>
>;
export type GetApiDiagramsIdQueryError = unknown;

export function useGetApiDiagramsId<
  TData = Awaited<ReturnType<typeof getApiDiagramsId>>,
  TError = unknown,
>(
  id: number,
  params?: GetApiDiagramsIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDiagramsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiDiagramsIdQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiDiagramsId = (
  id: number,
  updateDiagramRequestDto: UpdateDiagramRequestDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    {
      url: `/api/Diagrams/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateDiagramRequestDto,
    },
    options
  );
};

export const getPutApiDiagramsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiDiagramsId>>,
    TError,
    { id: number; data: UpdateDiagramRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiDiagramsId>>,
  TError,
  { id: number; data: UpdateDiagramRequestDto },
  TContext
> => {
  const mutationKey = ['putApiDiagramsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiDiagramsId>>,
    { id: number; data: UpdateDiagramRequestDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiDiagramsId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiDiagramsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiDiagramsId>>
>;
export type PutApiDiagramsIdMutationBody = UpdateDiagramRequestDto;
export type PutApiDiagramsIdMutationError = unknown;

export const usePutApiDiagramsId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiDiagramsId>>,
    TError,
    { id: number; data: UpdateDiagramRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiDiagramsId>>,
  TError,
  { id: number; data: UpdateDiagramRequestDto },
  TContext
> => {
  const mutationOptions = getPutApiDiagramsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiDiagramsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    { url: `/api/Diagrams/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiDiagramsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiDiagramsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiDiagramsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiDiagramsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiDiagramsId>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiDiagramsId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiDiagramsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiDiagramsId>>
>;

export type DeleteApiDiagramsIdMutationError = unknown;

export const useDeleteApiDiagramsId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiDiagramsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiDiagramsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteApiDiagramsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiDiagramsByPlantPlantId = (
  plantId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Diagrams/ByPlant/${plantId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiDiagramsByPlantPlantIdQueryKey = (plantId?: number) => {
  return [`/api/Diagrams/ByPlant/${plantId}`] as const;
};

export const getGetApiDiagramsByPlantPlantIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDiagramsByPlantPlantId>>,
  TError = unknown,
>(
  plantId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDiagramsByPlantPlantId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiDiagramsByPlantPlantIdQueryKey(plantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiDiagramsByPlantPlantId>>
  > = ({ signal }) =>
    getApiDiagramsByPlantPlantId(plantId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!plantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDiagramsByPlantPlantId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiDiagramsByPlantPlantIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDiagramsByPlantPlantId>>
>;
export type GetApiDiagramsByPlantPlantIdQueryError = unknown;

export function useGetApiDiagramsByPlantPlantId<
  TData = Awaited<ReturnType<typeof getApiDiagramsByPlantPlantId>>,
  TError = unknown,
>(
  plantId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiDiagramsByPlantPlantId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiDiagramsByPlantPlantIdQueryOptions(
    plantId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiExport = (
  createDataExportDto: CreateDataExportDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Export`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createDataExportDto,
      signal,
    },
    options
  );
};

export const getPostApiExportMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiExport>>,
    TError,
    { data: CreateDataExportDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiExport>>,
  TError,
  { data: CreateDataExportDto },
  TContext
> => {
  const mutationKey = ['postApiExport'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiExport>>,
    { data: CreateDataExportDto }
  > = props => {
    const { data } = props ?? {};

    return postApiExport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiExportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiExport>>
>;
export type PostApiExportMutationBody = CreateDataExportDto;
export type PostApiExportMutationError = unknown;

export const usePostApiExport = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiExport>>,
    TError,
    { data: CreateDataExportDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiExport>>,
  TError,
  { data: CreateDataExportDto },
  TContext
> => {
  const mutationOptions = getPostApiExportMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiExport = (
  params?: GetApiExportParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Export`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiExportQueryKey = (params?: GetApiExportParams) => {
  return [`/api/Export`, ...(params ? [params] : [])] as const;
};

export const getGetApiExportQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiExport>>,
  TError = unknown,
>(
  params?: GetApiExportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiExport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiExportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiExport>>> = ({
    signal,
  }) => getApiExport(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiExport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiExport>>
>;
export type GetApiExportQueryError = unknown;

export function useGetApiExport<
  TData = Awaited<ReturnType<typeof getApiExport>>,
  TError = unknown,
>(
  params?: GetApiExportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiExport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiExportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiExport = (
  updateDataExportRequestDto: UpdateDataExportRequestDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/Export`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateDataExportRequestDto,
    },
    options
  );
};

export const getPutApiExportMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiExport>>,
    TError,
    { data: UpdateDataExportRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiExport>>,
  TError,
  { data: UpdateDataExportRequestDto },
  TContext
> => {
  const mutationKey = ['putApiExport'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiExport>>,
    { data: UpdateDataExportRequestDto }
  > = props => {
    const { data } = props ?? {};

    return putApiExport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiExportMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiExport>>
>;
export type PutApiExportMutationBody = UpdateDataExportRequestDto;
export type PutApiExportMutationError = unknown;

export const usePutApiExport = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiExport>>,
    TError,
    { data: UpdateDataExportRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiExport>>,
  TError,
  { data: UpdateDataExportRequestDto },
  TContext
> => {
  const mutationOptions = getPutApiExportMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiExportId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Export/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiExportIdQueryKey = (id?: number) => {
  return [`/api/Export/${id}`] as const;
};

export const getGetApiExportIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiExportId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiExportId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiExportIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiExportId>>> = ({
    signal,
  }) => getApiExportId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiExportId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiExportIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiExportId>>
>;
export type GetApiExportIdQueryError = unknown;

export function useGetApiExportId<
  TData = Awaited<ReturnType<typeof getApiExportId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiExportId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiExportIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteApiExportId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/Export/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiExportIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiExportId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiExportId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiExportId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiExportId>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiExportId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiExportIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiExportId>>
>;

export type DeleteApiExportIdMutationError = unknown;

export const useDeleteApiExportId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiExportId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiExportId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteApiExportIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiExportByUserUserId = (
  userId: string,
  params?: GetApiExportByUserUserIdParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Export/byUser/${userId}`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiExportByUserUserIdQueryKey = (
  userId?: string,
  params?: GetApiExportByUserUserIdParams
) => {
  return [`/api/Export/byUser/${userId}`, ...(params ? [params] : [])] as const;
};

export const getGetApiExportByUserUserIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiExportByUserUserId>>,
  TError = unknown,
>(
  userId: string,
  params?: GetApiExportByUserUserIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiExportByUserUserId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiExportByUserUserIdQueryKey(userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiExportByUserUserId>>
  > = ({ signal }) =>
    getApiExportByUserUserId(userId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiExportByUserUserId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiExportByUserUserIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiExportByUserUserId>>
>;
export type GetApiExportByUserUserIdQueryError = unknown;

export function useGetApiExportByUserUserId<
  TData = Awaited<ReturnType<typeof getApiExportByUserUserId>>,
  TError = unknown,
>(
  userId: string,
  params?: GetApiExportByUserUserIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiExportByUserUserId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiExportByUserUserIdQueryOptions(
    userId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiExportTemplateTemplateIdDownload = (
  templateId: number,
  params?: GetApiExportTemplateTemplateIdDownloadParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Export/template/${templateId}/download`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetApiExportTemplateTemplateIdDownloadQueryKey = (
  templateId?: number,
  params?: GetApiExportTemplateTemplateIdDownloadParams
) => {
  return [
    `/api/Export/template/${templateId}/download`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiExportTemplateTemplateIdDownloadQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiExportTemplateTemplateIdDownload>>,
  TError = unknown,
>(
  templateId: number,
  params?: GetApiExportTemplateTemplateIdDownloadParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiExportTemplateTemplateIdDownload>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiExportTemplateTemplateIdDownloadQueryKey(templateId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiExportTemplateTemplateIdDownload>>
  > = ({ signal }) =>
    getApiExportTemplateTemplateIdDownload(
      templateId,
      params,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!templateId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiExportTemplateTemplateIdDownload>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiExportTemplateTemplateIdDownloadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiExportTemplateTemplateIdDownload>>
>;
export type GetApiExportTemplateTemplateIdDownloadQueryError = unknown;

export function useGetApiExportTemplateTemplateIdDownload<
  TData = Awaited<ReturnType<typeof getApiExportTemplateTemplateIdDownload>>,
  TError = unknown,
>(
  templateId: number,
  params?: GetApiExportTemplateTemplateIdDownloadParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiExportTemplateTemplateIdDownload>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiExportTemplateTemplateIdDownloadQueryOptions(
    templateId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiExportIntervalDownload = (
  dataRangeExportDto: DataRangeExportDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Export/interval/download`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dataRangeExportDto,
      signal,
    },
    options
  );
};

export const getPostApiExportIntervalDownloadMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiExportIntervalDownload>>,
    TError,
    { data: DataRangeExportDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiExportIntervalDownload>>,
  TError,
  { data: DataRangeExportDto },
  TContext
> => {
  const mutationKey = ['postApiExportIntervalDownload'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiExportIntervalDownload>>,
    { data: DataRangeExportDto }
  > = props => {
    const { data } = props ?? {};

    return postApiExportIntervalDownload(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiExportIntervalDownloadMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiExportIntervalDownload>>
>;
export type PostApiExportIntervalDownloadMutationBody = DataRangeExportDto;
export type PostApiExportIntervalDownloadMutationError = unknown;

export const usePostApiExportIntervalDownload = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiExportIntervalDownload>>,
    TError,
    { data: DataRangeExportDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiExportIntervalDownload>>,
  TError,
  { data: DataRangeExportDto },
  TContext
> => {
  const mutationOptions =
    getPostApiExportIntervalDownloadMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiExportTemplate = (
  postApiExportTemplateBody: PostApiExportTemplateBody,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  if (postApiExportTemplateBody.Name !== undefined) {
    formData.append(`Name`, postApiExportTemplateBody.Name);
  }
  if (postApiExportTemplateBody.Description !== undefined) {
    formData.append(`Description`, postApiExportTemplateBody.Description);
  }
  if (postApiExportTemplateBody.PlantId !== undefined) {
    formData.append(`PlantId`, postApiExportTemplateBody.PlantId.toString());
  }
  if (postApiExportTemplateBody.File !== undefined) {
    formData.append(`File`, postApiExportTemplateBody.File);
  }

  return axiosInstance<void>(
    {
      url: `/api/ExportTemplate`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options
  );
};

export const getPostApiExportTemplateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiExportTemplate>>,
    TError,
    { data: PostApiExportTemplateBody },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiExportTemplate>>,
  TError,
  { data: PostApiExportTemplateBody },
  TContext
> => {
  const mutationKey = ['postApiExportTemplate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiExportTemplate>>,
    { data: PostApiExportTemplateBody }
  > = props => {
    const { data } = props ?? {};

    return postApiExportTemplate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiExportTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiExportTemplate>>
>;
export type PostApiExportTemplateMutationBody = PostApiExportTemplateBody;
export type PostApiExportTemplateMutationError = unknown;

export const usePostApiExportTemplate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiExportTemplate>>,
    TError,
    { data: PostApiExportTemplateBody },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiExportTemplate>>,
  TError,
  { data: PostApiExportTemplateBody },
  TContext
> => {
  const mutationOptions = getPostApiExportTemplateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiExportTemplate = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/ExportTemplate`, method: 'GET', signal },
    options
  );
};

export const getGetApiExportTemplateQueryKey = () => {
  return [`/api/ExportTemplate`] as const;
};

export const getGetApiExportTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiExportTemplate>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiExportTemplate>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiExportTemplateQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiExportTemplate>>
  > = ({ signal }) => getApiExportTemplate(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiExportTemplate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiExportTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiExportTemplate>>
>;
export type GetApiExportTemplateQueryError = unknown;

export function useGetApiExportTemplate<
  TData = Awaited<ReturnType<typeof getApiExportTemplate>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiExportTemplate>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiExportTemplateQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiExportTemplateId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/ExportTemplate/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiExportTemplateIdQueryKey = (id?: number) => {
  return [`/api/ExportTemplate/${id}`] as const;
};

export const getGetApiExportTemplateIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiExportTemplateId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiExportTemplateId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiExportTemplateIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiExportTemplateId>>
  > = ({ signal }) => getApiExportTemplateId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiExportTemplateId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiExportTemplateIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiExportTemplateId>>
>;
export type GetApiExportTemplateIdQueryError = unknown;

export function useGetApiExportTemplateId<
  TData = Awaited<ReturnType<typeof getApiExportTemplateId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiExportTemplateId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiExportTemplateIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiExportTemplateId = (
  id: number,
  updateExportTemplateRequest: UpdateExportTemplateRequest,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/ExportTemplate/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateExportTemplateRequest,
    },
    options
  );
};

export const getPutApiExportTemplateIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiExportTemplateId>>,
    TError,
    { id: number; data: UpdateExportTemplateRequest },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiExportTemplateId>>,
  TError,
  { id: number; data: UpdateExportTemplateRequest },
  TContext
> => {
  const mutationKey = ['putApiExportTemplateId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiExportTemplateId>>,
    { id: number; data: UpdateExportTemplateRequest }
  > = props => {
    const { id, data } = props ?? {};

    return putApiExportTemplateId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiExportTemplateIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiExportTemplateId>>
>;
export type PutApiExportTemplateIdMutationBody = UpdateExportTemplateRequest;
export type PutApiExportTemplateIdMutationError = unknown;

export const usePutApiExportTemplateId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiExportTemplateId>>,
    TError,
    { id: number; data: UpdateExportTemplateRequest },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiExportTemplateId>>,
  TError,
  { id: number; data: UpdateExportTemplateRequest },
  TContext
> => {
  const mutationOptions = getPutApiExportTemplateIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiExportTemplateId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/ExportTemplate/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiExportTemplateIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiExportTemplateId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiExportTemplateId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiExportTemplateId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiExportTemplateId>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiExportTemplateId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiExportTemplateIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiExportTemplateId>>
>;

export type DeleteApiExportTemplateIdMutationError = unknown;

export const useDeleteApiExportTemplateId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiExportTemplateId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiExportTemplateId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteApiExportTemplateIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiExportTemplatePlantPlantId = (
  plantId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/ExportTemplate/plant/${plantId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiExportTemplatePlantPlantIdQueryKey = (
  plantId?: number
) => {
  return [`/api/ExportTemplate/plant/${plantId}`] as const;
};

export const getGetApiExportTemplatePlantPlantIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiExportTemplatePlantPlantId>>,
  TError = unknown,
>(
  plantId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiExportTemplatePlantPlantId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiExportTemplatePlantPlantIdQueryKey(plantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiExportTemplatePlantPlantId>>
  > = ({ signal }) =>
    getApiExportTemplatePlantPlantId(plantId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!plantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiExportTemplatePlantPlantId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiExportTemplatePlantPlantIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiExportTemplatePlantPlantId>>
>;
export type GetApiExportTemplatePlantPlantIdQueryError = unknown;

export function useGetApiExportTemplatePlantPlantId<
  TData = Awaited<ReturnType<typeof getApiExportTemplatePlantPlantId>>,
  TError = unknown,
>(
  plantId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiExportTemplatePlantPlantId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiExportTemplatePlantPlantIdQueryOptions(
    plantId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiExportTemplatePlantPlantIdWithslots = (
  plantId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/ExportTemplate/plant/${plantId}/withslots`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetApiExportTemplatePlantPlantIdWithslotsQueryKey = (
  plantId?: number
) => {
  return [`/api/ExportTemplate/plant/${plantId}/withslots`] as const;
};

export const getGetApiExportTemplatePlantPlantIdWithslotsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiExportTemplatePlantPlantIdWithslots>>,
  TError = unknown,
>(
  plantId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiExportTemplatePlantPlantIdWithslots>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiExportTemplatePlantPlantIdWithslotsQueryKey(plantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiExportTemplatePlantPlantIdWithslots>>
  > = ({ signal }) =>
    getApiExportTemplatePlantPlantIdWithslots(plantId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!plantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiExportTemplatePlantPlantIdWithslots>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiExportTemplatePlantPlantIdWithslotsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiExportTemplatePlantPlantIdWithslots>>
>;
export type GetApiExportTemplatePlantPlantIdWithslotsQueryError = unknown;

export function useGetApiExportTemplatePlantPlantIdWithslots<
  TData = Awaited<ReturnType<typeof getApiExportTemplatePlantPlantIdWithslots>>,
  TError = unknown,
>(
  plantId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiExportTemplatePlantPlantIdWithslots>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiExportTemplatePlantPlantIdWithslotsQueryOptions(
    plantId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiExportTemplateIdFile = (
  id: number,
  putApiExportTemplateIdFileBody: PutApiExportTemplateIdFileBody,
  options?: SecondParameter<typeof axiosInstance>
) => {
  const formData = new FormData();
  if (putApiExportTemplateIdFileBody.File !== undefined) {
    formData.append(`File`, putApiExportTemplateIdFileBody.File);
  }

  return axiosInstance<void>(
    {
      url: `/api/ExportTemplate/${id}/file`,
      method: 'PUT',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    },
    options
  );
};

export const getPutApiExportTemplateIdFileMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiExportTemplateIdFile>>,
    TError,
    { id: number; data: PutApiExportTemplateIdFileBody },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiExportTemplateIdFile>>,
  TError,
  { id: number; data: PutApiExportTemplateIdFileBody },
  TContext
> => {
  const mutationKey = ['putApiExportTemplateIdFile'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiExportTemplateIdFile>>,
    { id: number; data: PutApiExportTemplateIdFileBody }
  > = props => {
    const { id, data } = props ?? {};

    return putApiExportTemplateIdFile(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiExportTemplateIdFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiExportTemplateIdFile>>
>;
export type PutApiExportTemplateIdFileMutationBody =
  PutApiExportTemplateIdFileBody;
export type PutApiExportTemplateIdFileMutationError = unknown;

export const usePutApiExportTemplateIdFile = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiExportTemplateIdFile>>,
    TError,
    { id: number; data: PutApiExportTemplateIdFileBody },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiExportTemplateIdFile>>,
  TError,
  { id: number; data: PutApiExportTemplateIdFileBody },
  TContext
> => {
  const mutationOptions = getPutApiExportTemplateIdFileMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiExportTemplateIdDownload = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/ExportTemplate/${id}/download`, method: 'GET', signal },
    options
  );
};

export const getGetApiExportTemplateIdDownloadQueryKey = (id?: number) => {
  return [`/api/ExportTemplate/${id}/download`] as const;
};

export const getGetApiExportTemplateIdDownloadQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiExportTemplateIdDownload>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiExportTemplateIdDownload>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiExportTemplateIdDownloadQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiExportTemplateIdDownload>>
  > = ({ signal }) =>
    getApiExportTemplateIdDownload(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiExportTemplateIdDownload>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiExportTemplateIdDownloadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiExportTemplateIdDownload>>
>;
export type GetApiExportTemplateIdDownloadQueryError = unknown;

export function useGetApiExportTemplateIdDownload<
  TData = Awaited<ReturnType<typeof getApiExportTemplateIdDownload>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiExportTemplateIdDownload>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiExportTemplateIdDownloadQueryOptions(
    id,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiInstallerDownload = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Installer/download`, method: 'GET', signal },
    options
  );
};

export const getGetApiInstallerDownloadQueryKey = () => {
  return [`/api/Installer/download`] as const;
};

export const getGetApiInstallerDownloadQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiInstallerDownload>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiInstallerDownload>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiInstallerDownloadQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiInstallerDownload>>
  > = ({ signal }) => getApiInstallerDownload(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiInstallerDownload>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiInstallerDownloadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiInstallerDownload>>
>;
export type GetApiInstallerDownloadQueryError = unknown;

export function useGetApiInstallerDownload<
  TData = Awaited<ReturnType<typeof getApiInstallerDownload>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiInstallerDownload>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiInstallerDownloadQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiInstallerInfo = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Installer/info`, method: 'GET', signal },
    options
  );
};

export const getGetApiInstallerInfoQueryKey = () => {
  return [`/api/Installer/info`] as const;
};

export const getGetApiInstallerInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiInstallerInfo>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiInstallerInfo>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiInstallerInfoQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiInstallerInfo>>
  > = ({ signal }) => getApiInstallerInfo(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiInstallerInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiInstallerInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiInstallerInfo>>
>;
export type GetApiInstallerInfoQueryError = unknown;

export function useGetApiInstallerInfo<
  TData = Awaited<ReturnType<typeof getApiInstallerInfo>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiInstallerInfo>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiInstallerInfoQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiInstallerUpload = (
  postApiInstallerUploadBody: PostApiInstallerUploadBody,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  if (postApiInstallerUploadBody.File !== undefined) {
    formData.append(`File`, postApiInstallerUploadBody.File);
  }

  return axiosInstance<void>(
    {
      url: `/api/Installer/upload`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options
  );
};

export const getPostApiInstallerUploadMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiInstallerUpload>>,
    TError,
    { data: PostApiInstallerUploadBody },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiInstallerUpload>>,
  TError,
  { data: PostApiInstallerUploadBody },
  TContext
> => {
  const mutationKey = ['postApiInstallerUpload'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiInstallerUpload>>,
    { data: PostApiInstallerUploadBody }
  > = props => {
    const { data } = props ?? {};

    return postApiInstallerUpload(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiInstallerUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiInstallerUpload>>
>;
export type PostApiInstallerUploadMutationBody = PostApiInstallerUploadBody;
export type PostApiInstallerUploadMutationError = unknown;

export const usePostApiInstallerUpload = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiInstallerUpload>>,
    TError,
    { data: PostApiInstallerUploadBody },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiInstallerUpload>>,
  TError,
  { data: PostApiInstallerUploadBody },
  TContext
> => {
  const mutationOptions = getPostApiInstallerUploadMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiLayouts = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Layouts`, method: 'GET', signal },
    options
  );
};

export const getGetApiLayoutsQueryKey = () => {
  return [`/api/Layouts`] as const;
};

export const getGetApiLayoutsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLayouts>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiLayouts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiLayoutsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiLayouts>>> = ({
    signal,
  }) => getApiLayouts(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLayouts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiLayoutsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLayouts>>
>;
export type GetApiLayoutsQueryError = unknown;

export function useGetApiLayouts<
  TData = Awaited<ReturnType<typeof getApiLayouts>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiLayouts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiLayoutsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiLayouts = (
  createLayoutDto: CreateLayoutDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Layouts`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createLayoutDto,
      signal,
    },
    options
  );
};

export const getPostApiLayoutsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLayouts>>,
    TError,
    { data: CreateLayoutDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLayouts>>,
  TError,
  { data: CreateLayoutDto },
  TContext
> => {
  const mutationKey = ['postApiLayouts'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLayouts>>,
    { data: CreateLayoutDto }
  > = props => {
    const { data } = props ?? {};

    return postApiLayouts(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLayoutsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLayouts>>
>;
export type PostApiLayoutsMutationBody = CreateLayoutDto;
export type PostApiLayoutsMutationError = unknown;

export const usePostApiLayouts = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLayouts>>,
    TError,
    { data: CreateLayoutDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiLayouts>>,
  TError,
  { data: CreateLayoutDto },
  TContext
> => {
  const mutationOptions = getPostApiLayoutsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiLayoutsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Layouts/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiLayoutsIdQueryKey = (id?: number) => {
  return [`/api/Layouts/${id}`] as const;
};

export const getGetApiLayoutsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLayoutsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiLayoutsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiLayoutsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiLayoutsId>>> = ({
    signal,
  }) => getApiLayoutsId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLayoutsId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiLayoutsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLayoutsId>>
>;
export type GetApiLayoutsIdQueryError = unknown;

export function useGetApiLayoutsId<
  TData = Awaited<ReturnType<typeof getApiLayoutsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiLayoutsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiLayoutsIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiLayoutsId = (
  id: number,
  layoutDto: LayoutDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    {
      url: `/api/Layouts/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: layoutDto,
    },
    options
  );
};

export const getPutApiLayoutsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiLayoutsId>>,
    TError,
    { id: number; data: LayoutDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiLayoutsId>>,
  TError,
  { id: number; data: LayoutDto },
  TContext
> => {
  const mutationKey = ['putApiLayoutsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiLayoutsId>>,
    { id: number; data: LayoutDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiLayoutsId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiLayoutsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiLayoutsId>>
>;
export type PutApiLayoutsIdMutationBody = LayoutDto;
export type PutApiLayoutsIdMutationError = unknown;

export const usePutApiLayoutsId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiLayoutsId>>,
    TError,
    { id: number; data: LayoutDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiLayoutsId>>,
  TError,
  { id: number; data: LayoutDto },
  TContext
> => {
  const mutationOptions = getPutApiLayoutsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiLayoutsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    { url: `/api/Layouts/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiLayoutsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiLayoutsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiLayoutsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiLayoutsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiLayoutsId>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiLayoutsId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiLayoutsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiLayoutsId>>
>;

export type DeleteApiLayoutsIdMutationError = unknown;

export const useDeleteApiLayoutsId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiLayoutsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiLayoutsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteApiLayoutsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiLayoutsByDashboardDashboardId = (
  dashboardId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Layouts/ByDashboard/${dashboardId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiLayoutsByDashboardDashboardIdQueryKey = (
  dashboardId?: number
) => {
  return [`/api/Layouts/ByDashboard/${dashboardId}`] as const;
};

export const getGetApiLayoutsByDashboardDashboardIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLayoutsByDashboardDashboardId>>,
  TError = unknown,
>(
  dashboardId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiLayoutsByDashboardDashboardId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLayoutsByDashboardDashboardIdQueryKey(dashboardId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLayoutsByDashboardDashboardId>>
  > = ({ signal }) =>
    getApiLayoutsByDashboardDashboardId(dashboardId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!dashboardId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLayoutsByDashboardDashboardId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiLayoutsByDashboardDashboardIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLayoutsByDashboardDashboardId>>
>;
export type GetApiLayoutsByDashboardDashboardIdQueryError = unknown;

export function useGetApiLayoutsByDashboardDashboardId<
  TData = Awaited<ReturnType<typeof getApiLayoutsByDashboardDashboardId>>,
  TError = unknown,
>(
  dashboardId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiLayoutsByDashboardDashboardId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiLayoutsByDashboardDashboardIdQueryOptions(
    dashboardId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiLayoutsBulk = (
  layoutDto: LayoutDto[],
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/Layouts/bulk`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: layoutDto,
    },
    options
  );
};

export const getPutApiLayoutsBulkMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiLayoutsBulk>>,
    TError,
    { data: LayoutDto[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiLayoutsBulk>>,
  TError,
  { data: LayoutDto[] },
  TContext
> => {
  const mutationKey = ['putApiLayoutsBulk'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiLayoutsBulk>>,
    { data: LayoutDto[] }
  > = props => {
    const { data } = props ?? {};

    return putApiLayoutsBulk(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiLayoutsBulkMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiLayoutsBulk>>
>;
export type PutApiLayoutsBulkMutationBody = LayoutDto[];
export type PutApiLayoutsBulkMutationError = unknown;

export const usePutApiLayoutsBulk = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiLayoutsBulk>>,
    TError,
    { data: LayoutDto[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiLayoutsBulk>>,
  TError,
  { data: LayoutDto[] },
  TContext
> => {
  const mutationOptions = getPutApiLayoutsBulkMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiLayoutsMoveLayoutIdToTargetDashboardId = (
  layoutId: number,
  targetDashboardId: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    {
      url: `/api/Layouts/move/${layoutId}/to/${targetDashboardId}`,
      method: 'PUT',
    },
    options
  );
};

export const getPutApiLayoutsMoveLayoutIdToTargetDashboardIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiLayoutsMoveLayoutIdToTargetDashboardId>>,
    TError,
    { layoutId: number; targetDashboardId: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiLayoutsMoveLayoutIdToTargetDashboardId>>,
  TError,
  { layoutId: number; targetDashboardId: number },
  TContext
> => {
  const mutationKey = ['putApiLayoutsMoveLayoutIdToTargetDashboardId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiLayoutsMoveLayoutIdToTargetDashboardId>>,
    { layoutId: number; targetDashboardId: number }
  > = props => {
    const { layoutId, targetDashboardId } = props ?? {};

    return putApiLayoutsMoveLayoutIdToTargetDashboardId(
      layoutId,
      targetDashboardId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiLayoutsMoveLayoutIdToTargetDashboardIdMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof putApiLayoutsMoveLayoutIdToTargetDashboardId>>
  >;

export type PutApiLayoutsMoveLayoutIdToTargetDashboardIdMutationError = unknown;

export const usePutApiLayoutsMoveLayoutIdToTargetDashboardId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiLayoutsMoveLayoutIdToTargetDashboardId>>,
    TError,
    { layoutId: number; targetDashboardId: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiLayoutsMoveLayoutIdToTargetDashboardId>>,
  TError,
  { layoutId: number; targetDashboardId: number },
  TContext
> => {
  const mutationOptions =
    getPutApiLayoutsMoveLayoutIdToTargetDashboardIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiNotifications = (
  params?: GetApiNotificationsParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Notifications`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiNotificationsQueryKey = (
  params?: GetApiNotificationsParams
) => {
  return [`/api/Notifications`, ...(params ? [params] : [])] as const;
};

export const getGetApiNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiNotifications>>,
  TError = unknown,
>(
  params?: GetApiNotificationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiNotifications>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiNotificationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiNotifications>>
  > = ({ signal }) => getApiNotifications(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiNotifications>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiNotifications>>
>;
export type GetApiNotificationsQueryError = unknown;

export function useGetApiNotifications<
  TData = Awaited<ReturnType<typeof getApiNotifications>>,
  TError = unknown,
>(
  params?: GetApiNotificationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiNotifications>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiNotificationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiNotifications = (
  createNotificationDto: CreateNotificationDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Notifications`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createNotificationDto,
      signal,
    },
    options
  );
};

export const getPostApiNotificationsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiNotifications>>,
    TError,
    { data: CreateNotificationDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiNotifications>>,
  TError,
  { data: CreateNotificationDto },
  TContext
> => {
  const mutationKey = ['postApiNotifications'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiNotifications>>,
    { data: CreateNotificationDto }
  > = props => {
    const { data } = props ?? {};

    return postApiNotifications(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiNotificationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiNotifications>>
>;
export type PostApiNotificationsMutationBody = CreateNotificationDto;
export type PostApiNotificationsMutationError = unknown;

export const usePostApiNotifications = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiNotifications>>,
    TError,
    { data: CreateNotificationDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiNotifications>>,
  TError,
  { data: CreateNotificationDto },
  TContext
> => {
  const mutationOptions = getPostApiNotificationsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiNotificationsIdMarkRead = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Notifications/${id}/mark-read`, method: 'POST', signal },
    options
  );
};

export const getPostApiNotificationsIdMarkReadMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiNotificationsIdMarkRead>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiNotificationsIdMarkRead>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['postApiNotificationsIdMarkRead'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiNotificationsIdMarkRead>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return postApiNotificationsIdMarkRead(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiNotificationsIdMarkReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiNotificationsIdMarkRead>>
>;

export type PostApiNotificationsIdMarkReadMutationError = unknown;

export const usePostApiNotificationsIdMarkRead = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiNotificationsIdMarkRead>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiNotificationsIdMarkRead>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getPostApiNotificationsIdMarkReadMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiNotificationsUnreadCount = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Notifications/unread-count`, method: 'GET', signal },
    options
  );
};

export const getGetApiNotificationsUnreadCountQueryKey = () => {
  return [`/api/Notifications/unread-count`] as const;
};

export const getGetApiNotificationsUnreadCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiNotificationsUnreadCount>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiNotificationsUnreadCount>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiNotificationsUnreadCountQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiNotificationsUnreadCount>>
  > = ({ signal }) => getApiNotificationsUnreadCount(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiNotificationsUnreadCount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiNotificationsUnreadCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiNotificationsUnreadCount>>
>;
export type GetApiNotificationsUnreadCountQueryError = unknown;

export function useGetApiNotificationsUnreadCount<
  TData = Awaited<ReturnType<typeof getApiNotificationsUnreadCount>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiNotificationsUnreadCount>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiNotificationsUnreadCountQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiNotificationsAdmin = (
  params?: GetApiNotificationsAdminParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Notifications/admin`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiNotificationsAdminQueryKey = (
  params?: GetApiNotificationsAdminParams
) => {
  return [`/api/Notifications/admin`, ...(params ? [params] : [])] as const;
};

export const getGetApiNotificationsAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiNotificationsAdmin>>,
  TError = unknown,
>(
  params?: GetApiNotificationsAdminParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiNotificationsAdmin>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiNotificationsAdminQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiNotificationsAdmin>>
  > = ({ signal }) => getApiNotificationsAdmin(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiNotificationsAdmin>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiNotificationsAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiNotificationsAdmin>>
>;
export type GetApiNotificationsAdminQueryError = unknown;

export function useGetApiNotificationsAdmin<
  TData = Awaited<ReturnType<typeof getApiNotificationsAdmin>>,
  TError = unknown,
>(
  params?: GetApiNotificationsAdminParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiNotificationsAdmin>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiNotificationsAdminQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteApiNotificationsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/Notifications/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiNotificationsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiNotificationsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiNotificationsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiNotificationsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiNotificationsId>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiNotificationsId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiNotificationsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiNotificationsId>>
>;

export type DeleteApiNotificationsIdMutationError = unknown;

export const useDeleteApiNotificationsId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiNotificationsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiNotificationsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteApiNotificationsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiNotificationsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Notifications/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiNotificationsIdQueryKey = (id?: number) => {
  return [`/api/Notifications/${id}`] as const;
};

export const getGetApiNotificationsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiNotificationsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiNotificationsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiNotificationsIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiNotificationsId>>
  > = ({ signal }) => getApiNotificationsId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiNotificationsId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiNotificationsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiNotificationsId>>
>;
export type GetApiNotificationsIdQueryError = unknown;

export function useGetApiNotificationsId<
  TData = Awaited<ReturnType<typeof getApiNotificationsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiNotificationsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiNotificationsIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiNotificationsId = (
  id: number,
  createNotificationDto: CreateNotificationDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/Notifications/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: createNotificationDto,
    },
    options
  );
};

export const getPutApiNotificationsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiNotificationsId>>,
    TError,
    { id: number; data: CreateNotificationDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiNotificationsId>>,
  TError,
  { id: number; data: CreateNotificationDto },
  TContext
> => {
  const mutationKey = ['putApiNotificationsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiNotificationsId>>,
    { id: number; data: CreateNotificationDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiNotificationsId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiNotificationsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiNotificationsId>>
>;
export type PutApiNotificationsIdMutationBody = CreateNotificationDto;
export type PutApiNotificationsIdMutationError = unknown;

export const usePutApiNotificationsId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiNotificationsId>>,
    TError,
    { id: number; data: CreateNotificationDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiNotificationsId>>,
  TError,
  { id: number; data: CreateNotificationDto },
  TContext
> => {
  const mutationOptions = getPutApiNotificationsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiNotificationsIdPermanent = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/Notifications/${id}/permanent`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiNotificationsIdPermanentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiNotificationsIdPermanent>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiNotificationsIdPermanent>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiNotificationsIdPermanent'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiNotificationsIdPermanent>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiNotificationsIdPermanent(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiNotificationsIdPermanentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiNotificationsIdPermanent>>
>;

export type DeleteApiNotificationsIdPermanentMutationError = unknown;

export const useDeleteApiNotificationsIdPermanent = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiNotificationsIdPermanent>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiNotificationsIdPermanent>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getDeleteApiNotificationsIdPermanentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiPlants = (
  params?: GetApiPlantsParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Plants`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiPlantsQueryKey = (params?: GetApiPlantsParams) => {
  return [`/api/Plants`, ...(params ? [params] : [])] as const;
};

export const getGetApiPlantsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiPlants>>,
  TError = unknown,
>(
  params?: GetApiPlantsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiPlants>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiPlantsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPlants>>> = ({
    signal,
  }) => getApiPlants(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiPlants>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiPlantsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiPlants>>
>;
export type GetApiPlantsQueryError = unknown;

export function useGetApiPlants<
  TData = Awaited<ReturnType<typeof getApiPlants>>,
  TError = unknown,
>(
  params?: GetApiPlantsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiPlants>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiPlantsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiPlants = (
  createPlantDto: CreatePlantDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CreateResponseDto>(
    {
      url: `/api/Plants`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createPlantDto,
      signal,
    },
    options
  );
};

export const getPostApiPlantsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiPlants>>,
    TError,
    { data: CreatePlantDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiPlants>>,
  TError,
  { data: CreatePlantDto },
  TContext
> => {
  const mutationKey = ['postApiPlants'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiPlants>>,
    { data: CreatePlantDto }
  > = props => {
    const { data } = props ?? {};

    return postApiPlants(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiPlantsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiPlants>>
>;
export type PostApiPlantsMutationBody = CreatePlantDto;
export type PostApiPlantsMutationError = unknown;

export const usePostApiPlants = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiPlants>>,
    TError,
    { data: CreatePlantDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiPlants>>,
  TError,
  { data: CreatePlantDto },
  TContext
> => {
  const mutationOptions = getPostApiPlantsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiPlants = (
  plantDto: PlantDto,
  params?: PutApiPlantsParams,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    {
      url: `/api/Plants`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: plantDto,
      params,
    },
    options
  );
};

export const getPutApiPlantsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiPlants>>,
    TError,
    { data: PlantDto; params?: PutApiPlantsParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiPlants>>,
  TError,
  { data: PlantDto; params?: PutApiPlantsParams },
  TContext
> => {
  const mutationKey = ['putApiPlants'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiPlants>>,
    { data: PlantDto; params?: PutApiPlantsParams }
  > = props => {
    const { data, params } = props ?? {};

    return putApiPlants(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiPlantsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiPlants>>
>;
export type PutApiPlantsMutationBody = PlantDto;
export type PutApiPlantsMutationError = unknown;

export const usePutApiPlants = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiPlants>>,
    TError,
    { data: PlantDto; params?: PutApiPlantsParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiPlants>>,
  TError,
  { data: PlantDto; params?: PutApiPlantsParams },
  TContext
> => {
  const mutationOptions = getPutApiPlantsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiPlants = (
  params?: DeleteApiPlantsParams,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    { url: `/api/Plants`, method: 'DELETE', params },
    options
  );
};

export const getDeleteApiPlantsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiPlants>>,
    TError,
    { params?: DeleteApiPlantsParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiPlants>>,
  TError,
  { params?: DeleteApiPlantsParams },
  TContext
> => {
  const mutationKey = ['deleteApiPlants'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiPlants>>,
    { params?: DeleteApiPlantsParams }
  > = props => {
    const { params } = props ?? {};

    return deleteApiPlants(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiPlantsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiPlants>>
>;

export type DeleteApiPlantsMutationError = unknown;

export const useDeleteApiPlants = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiPlants>>,
    TError,
    { params?: DeleteApiPlantsParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiPlants>>,
  TError,
  { params?: DeleteApiPlantsParams },
  TContext
> => {
  const mutationOptions = getDeleteApiPlantsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiPlantsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Plants/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiPlantsIdQueryKey = (id?: number) => {
  return [`/api/Plants/${id}`] as const;
};

export const getGetApiPlantsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiPlantsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiPlantsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiPlantsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPlantsId>>> = ({
    signal,
  }) => getApiPlantsId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiPlantsId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiPlantsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiPlantsId>>
>;
export type GetApiPlantsIdQueryError = unknown;

export function useGetApiPlantsId<
  TData = Awaited<ReturnType<typeof getApiPlantsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiPlantsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiPlantsIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiPlantStatusPlantId = (
  plantId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/PlantStatus/${plantId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiPlantStatusPlantIdQueryKey = (plantId?: number) => {
  return [`/api/PlantStatus/${plantId}`] as const;
};

export const getGetApiPlantStatusPlantIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiPlantStatusPlantId>>,
  TError = unknown,
>(
  plantId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiPlantStatusPlantId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiPlantStatusPlantIdQueryKey(plantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiPlantStatusPlantId>>
  > = ({ signal }) => getApiPlantStatusPlantId(plantId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!plantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiPlantStatusPlantId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiPlantStatusPlantIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiPlantStatusPlantId>>
>;
export type GetApiPlantStatusPlantIdQueryError = unknown;

export function useGetApiPlantStatusPlantId<
  TData = Awaited<ReturnType<typeof getApiPlantStatusPlantId>>,
  TError = unknown,
>(
  plantId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiPlantStatusPlantId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiPlantStatusPlantIdQueryOptions(
    plantId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiPlantStatusPlantIdScadaChanged = (
  plantId: number,
  params?: PutApiPlantStatusPlantIdScadaChangedParams,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/PlantStatus/${plantId}/scada-changed`, method: 'PUT', params },
    options
  );
};

export const getPutApiPlantStatusPlantIdScadaChangedMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiPlantStatusPlantIdScadaChanged>>,
    TError,
    { plantId: number; params?: PutApiPlantStatusPlantIdScadaChangedParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiPlantStatusPlantIdScadaChanged>>,
  TError,
  { plantId: number; params?: PutApiPlantStatusPlantIdScadaChangedParams },
  TContext
> => {
  const mutationKey = ['putApiPlantStatusPlantIdScadaChanged'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiPlantStatusPlantIdScadaChanged>>,
    { plantId: number; params?: PutApiPlantStatusPlantIdScadaChangedParams }
  > = props => {
    const { plantId, params } = props ?? {};

    return putApiPlantStatusPlantIdScadaChanged(
      plantId,
      params,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiPlantStatusPlantIdScadaChangedMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiPlantStatusPlantIdScadaChanged>>
>;

export type PutApiPlantStatusPlantIdScadaChangedMutationError = unknown;

export const usePutApiPlantStatusPlantIdScadaChanged = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiPlantStatusPlantIdScadaChanged>>,
    TError,
    { plantId: number; params?: PutApiPlantStatusPlantIdScadaChangedParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiPlantStatusPlantIdScadaChanged>>,
  TError,
  { plantId: number; params?: PutApiPlantStatusPlantIdScadaChangedParams },
  TContext
> => {
  const mutationOptions =
    getPutApiPlantStatusPlantIdScadaChangedMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiPlantStatusPlantIdDockerUpdate = (
  plantId: number,
  params?: PutApiPlantStatusPlantIdDockerUpdateParams,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/PlantStatus/${plantId}/docker-update`, method: 'PUT', params },
    options
  );
};

export const getPutApiPlantStatusPlantIdDockerUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiPlantStatusPlantIdDockerUpdate>>,
    TError,
    { plantId: number; params?: PutApiPlantStatusPlantIdDockerUpdateParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiPlantStatusPlantIdDockerUpdate>>,
  TError,
  { plantId: number; params?: PutApiPlantStatusPlantIdDockerUpdateParams },
  TContext
> => {
  const mutationKey = ['putApiPlantStatusPlantIdDockerUpdate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiPlantStatusPlantIdDockerUpdate>>,
    { plantId: number; params?: PutApiPlantStatusPlantIdDockerUpdateParams }
  > = props => {
    const { plantId, params } = props ?? {};

    return putApiPlantStatusPlantIdDockerUpdate(
      plantId,
      params,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiPlantStatusPlantIdDockerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiPlantStatusPlantIdDockerUpdate>>
>;

export type PutApiPlantStatusPlantIdDockerUpdateMutationError = unknown;

export const usePutApiPlantStatusPlantIdDockerUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiPlantStatusPlantIdDockerUpdate>>,
    TError,
    { plantId: number; params?: PutApiPlantStatusPlantIdDockerUpdateParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiPlantStatusPlantIdDockerUpdate>>,
  TError,
  { plantId: number; params?: PutApiPlantStatusPlantIdDockerUpdateParams },
  TContext
> => {
  const mutationOptions =
    getPutApiPlantStatusPlantIdDockerUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiPlantStatusDockerUpdateAll = (
  params?: PutApiPlantStatusDockerUpdateAllParams,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/PlantStatus/docker-update-all`, method: 'PUT', params },
    options
  );
};

export const getPutApiPlantStatusDockerUpdateAllMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiPlantStatusDockerUpdateAll>>,
    TError,
    { params?: PutApiPlantStatusDockerUpdateAllParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiPlantStatusDockerUpdateAll>>,
  TError,
  { params?: PutApiPlantStatusDockerUpdateAllParams },
  TContext
> => {
  const mutationKey = ['putApiPlantStatusDockerUpdateAll'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiPlantStatusDockerUpdateAll>>,
    { params?: PutApiPlantStatusDockerUpdateAllParams }
  > = props => {
    const { params } = props ?? {};

    return putApiPlantStatusDockerUpdateAll(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiPlantStatusDockerUpdateAllMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiPlantStatusDockerUpdateAll>>
>;

export type PutApiPlantStatusDockerUpdateAllMutationError = unknown;

export const usePutApiPlantStatusDockerUpdateAll = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiPlantStatusDockerUpdateAll>>,
    TError,
    { params?: PutApiPlantStatusDockerUpdateAllParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiPlantStatusDockerUpdateAll>>,
  TError,
  { params?: PutApiPlantStatusDockerUpdateAllParams },
  TContext
> => {
  const mutationOptions =
    getPutApiPlantStatusDockerUpdateAllMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiPlantStatusPlantIdDataRange = (
  plantId: number,
  updateDataRangeRequestDto: UpdateDataRangeRequestDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/PlantStatus/${plantId}/data-range`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateDataRangeRequestDto,
    },
    options
  );
};

export const getPutApiPlantStatusPlantIdDataRangeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiPlantStatusPlantIdDataRange>>,
    TError,
    { plantId: number; data: UpdateDataRangeRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiPlantStatusPlantIdDataRange>>,
  TError,
  { plantId: number; data: UpdateDataRangeRequestDto },
  TContext
> => {
  const mutationKey = ['putApiPlantStatusPlantIdDataRange'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiPlantStatusPlantIdDataRange>>,
    { plantId: number; data: UpdateDataRangeRequestDto }
  > = props => {
    const { plantId, data } = props ?? {};

    return putApiPlantStatusPlantIdDataRange(plantId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiPlantStatusPlantIdDataRangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiPlantStatusPlantIdDataRange>>
>;
export type PutApiPlantStatusPlantIdDataRangeMutationBody =
  UpdateDataRangeRequestDto;
export type PutApiPlantStatusPlantIdDataRangeMutationError = unknown;

export const usePutApiPlantStatusPlantIdDataRange = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiPlantStatusPlantIdDataRange>>,
    TError,
    { plantId: number; data: UpdateDataRangeRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiPlantStatusPlantIdDataRange>>,
  TError,
  { plantId: number; data: UpdateDataRangeRequestDto },
  TContext
> => {
  const mutationOptions =
    getPutApiPlantStatusPlantIdDataRangeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiPlantStatusDataRangeAll = (
  updateDataRangeRequestDto: UpdateDataRangeRequestDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/PlantStatus/data-range-all`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateDataRangeRequestDto,
    },
    options
  );
};

export const getPutApiPlantStatusDataRangeAllMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiPlantStatusDataRangeAll>>,
    TError,
    { data: UpdateDataRangeRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiPlantStatusDataRangeAll>>,
  TError,
  { data: UpdateDataRangeRequestDto },
  TContext
> => {
  const mutationKey = ['putApiPlantStatusDataRangeAll'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiPlantStatusDataRangeAll>>,
    { data: UpdateDataRangeRequestDto }
  > = props => {
    const { data } = props ?? {};

    return putApiPlantStatusDataRangeAll(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiPlantStatusDataRangeAllMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiPlantStatusDataRangeAll>>
>;
export type PutApiPlantStatusDataRangeAllMutationBody =
  UpdateDataRangeRequestDto;
export type PutApiPlantStatusDataRangeAllMutationError = unknown;

export const usePutApiPlantStatusDataRangeAll = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiPlantStatusDataRangeAll>>,
    TError,
    { data: UpdateDataRangeRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiPlantStatusDataRangeAll>>,
  TError,
  { data: UpdateDataRangeRequestDto },
  TContext
> => {
  const mutationOptions =
    getPutApiPlantStatusDataRangeAllMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiRole = (
  createRoleDto: CreateRoleDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Role`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createRoleDto,
      signal,
    },
    options
  );
};

export const getPostApiRoleMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiRole>>,
    TError,
    { data: CreateRoleDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiRole>>,
  TError,
  { data: CreateRoleDto },
  TContext
> => {
  const mutationKey = ['postApiRole'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiRole>>,
    { data: CreateRoleDto }
  > = props => {
    const { data } = props ?? {};

    return postApiRole(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiRole>>
>;
export type PostApiRoleMutationBody = CreateRoleDto;
export type PostApiRoleMutationError = unknown;

export const usePostApiRole = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiRole>>,
    TError,
    { data: CreateRoleDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiRole>>,
  TError,
  { data: CreateRoleDto },
  TContext
> => {
  const mutationOptions = getPostApiRoleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiRole = (
  params?: GetApiRoleParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Role`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiRoleQueryKey = (params?: GetApiRoleParams) => {
  return [`/api/Role`, ...(params ? [params] : [])] as const;
};

export const getGetApiRoleQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiRole>>,
  TError = unknown,
>(
  params?: GetApiRoleParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiRole>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiRoleQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiRole>>> = ({
    signal,
  }) => getApiRole(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiRole>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiRoleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiRole>>
>;
export type GetApiRoleQueryError = unknown;

export function useGetApiRole<
  TData = Awaited<ReturnType<typeof getApiRole>>,
  TError = unknown,
>(
  params?: GetApiRoleParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiRole>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiRoleQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteApiRoleId = (
  id: string,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/Role/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiRoleIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiRoleId>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiRoleId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteApiRoleId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiRoleId>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteApiRoleId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiRoleIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiRoleId>>
>;

export type DeleteApiRoleIdMutationError = unknown;

export const useDeleteApiRoleId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiRoleId>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiRoleId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteApiRoleIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiRoleId = (
  id: string,
  roleDto: RoleDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/Role/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: roleDto,
    },
    options
  );
};

export const getPutApiRoleIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiRoleId>>,
    TError,
    { id: string; data: RoleDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiRoleId>>,
  TError,
  { id: string; data: RoleDto },
  TContext
> => {
  const mutationKey = ['putApiRoleId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiRoleId>>,
    { id: string; data: RoleDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiRoleId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiRoleIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiRoleId>>
>;
export type PutApiRoleIdMutationBody = RoleDto;
export type PutApiRoleIdMutationError = unknown;

export const usePutApiRoleId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiRoleId>>,
    TError,
    { id: string; data: RoleDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiRoleId>>,
  TError,
  { id: string; data: RoleDto },
  TContext
> => {
  const mutationOptions = getPutApiRoleIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiRoleId = (
  id: string,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Role/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiRoleIdQueryKey = (id?: string) => {
  return [`/api/Role/${id}`] as const;
};

export const getGetApiRoleIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiRoleId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiRoleId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiRoleIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiRoleId>>> = ({
    signal,
  }) => getApiRoleId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiRoleId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiRoleIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiRoleId>>
>;
export type GetApiRoleIdQueryError = unknown;

export function useGetApiRoleId<
  TData = Awaited<ReturnType<typeof getApiRoleId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiRoleId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiRoleIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiRolePermissions = (
  createRolePermissionDto: CreateRolePermissionDto[],
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Role/permissions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createRolePermissionDto,
      signal,
    },
    options
  );
};

export const getPostApiRolePermissionsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiRolePermissions>>,
    TError,
    { data: CreateRolePermissionDto[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiRolePermissions>>,
  TError,
  { data: CreateRolePermissionDto[] },
  TContext
> => {
  const mutationKey = ['postApiRolePermissions'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiRolePermissions>>,
    { data: CreateRolePermissionDto[] }
  > = props => {
    const { data } = props ?? {};

    return postApiRolePermissions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiRolePermissionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiRolePermissions>>
>;
export type PostApiRolePermissionsMutationBody = CreateRolePermissionDto[];
export type PostApiRolePermissionsMutationError = unknown;

export const usePostApiRolePermissions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiRolePermissions>>,
    TError,
    { data: CreateRolePermissionDto[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiRolePermissions>>,
  TError,
  { data: CreateRolePermissionDto[] },
  TContext
> => {
  const mutationOptions = getPostApiRolePermissionsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiRolePermissions = (
  rolePermissionDto: RolePermissionDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/Role/permissions`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: rolePermissionDto,
    },
    options
  );
};

export const getPutApiRolePermissionsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiRolePermissions>>,
    TError,
    { data: RolePermissionDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiRolePermissions>>,
  TError,
  { data: RolePermissionDto },
  TContext
> => {
  const mutationKey = ['putApiRolePermissions'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiRolePermissions>>,
    { data: RolePermissionDto }
  > = props => {
    const { data } = props ?? {};

    return putApiRolePermissions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiRolePermissionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiRolePermissions>>
>;
export type PutApiRolePermissionsMutationBody = RolePermissionDto;
export type PutApiRolePermissionsMutationError = unknown;

export const usePutApiRolePermissions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiRolePermissions>>,
    TError,
    { data: RolePermissionDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiRolePermissions>>,
  TError,
  { data: RolePermissionDto },
  TContext
> => {
  const mutationOptions = getPutApiRolePermissionsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiRolePermissions = (
  params?: GetApiRolePermissionsParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Role/permissions`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiRolePermissionsQueryKey = (
  params?: GetApiRolePermissionsParams
) => {
  return [`/api/Role/permissions`, ...(params ? [params] : [])] as const;
};

export const getGetApiRolePermissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiRolePermissions>>,
  TError = unknown,
>(
  params?: GetApiRolePermissionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiRolePermissions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiRolePermissionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiRolePermissions>>
  > = ({ signal }) => getApiRolePermissions(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiRolePermissions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiRolePermissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiRolePermissions>>
>;
export type GetApiRolePermissionsQueryError = unknown;

export function useGetApiRolePermissions<
  TData = Awaited<ReturnType<typeof getApiRolePermissions>>,
  TError = unknown,
>(
  params?: GetApiRolePermissionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiRolePermissions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiRolePermissionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteApiRolePermissionsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/Role/permissions/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiRolePermissionsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiRolePermissionsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiRolePermissionsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiRolePermissionsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiRolePermissionsId>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiRolePermissionsId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiRolePermissionsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiRolePermissionsId>>
>;

export type DeleteApiRolePermissionsIdMutationError = unknown;

export const useDeleteApiRolePermissionsId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiRolePermissionsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiRolePermissionsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteApiRolePermissionsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiRolePermissionsId = (
  id: number,
  params?: GetApiRolePermissionsIdParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Role/permissions/${id}`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiRolePermissionsIdQueryKey = (
  id?: number,
  params?: GetApiRolePermissionsIdParams
) => {
  return [`/api/Role/permissions/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetApiRolePermissionsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiRolePermissionsId>>,
  TError = unknown,
>(
  id: number,
  params?: GetApiRolePermissionsIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiRolePermissionsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiRolePermissionsIdQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiRolePermissionsId>>
  > = ({ signal }) =>
    getApiRolePermissionsId(id, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiRolePermissionsId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiRolePermissionsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiRolePermissionsId>>
>;
export type GetApiRolePermissionsIdQueryError = unknown;

export function useGetApiRolePermissionsId<
  TData = Awaited<ReturnType<typeof getApiRolePermissionsId>>,
  TError = unknown,
>(
  id: number,
  params?: GetApiRolePermissionsIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiRolePermissionsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiRolePermissionsIdQueryOptions(
    id,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiRolePermissionsByRoleRoleId = (
  roleId: string,
  params?: GetApiRolePermissionsByRoleRoleIdParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Role/permissions/byRole/${roleId}`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetApiRolePermissionsByRoleRoleIdQueryKey = (
  roleId?: string,
  params?: GetApiRolePermissionsByRoleRoleIdParams
) => {
  return [
    `/api/Role/permissions/byRole/${roleId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiRolePermissionsByRoleRoleIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiRolePermissionsByRoleRoleId>>,
  TError = unknown,
>(
  roleId: string,
  params?: GetApiRolePermissionsByRoleRoleIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiRolePermissionsByRoleRoleId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiRolePermissionsByRoleRoleIdQueryKey(roleId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiRolePermissionsByRoleRoleId>>
  > = ({ signal }) =>
    getApiRolePermissionsByRoleRoleId(roleId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!roleId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiRolePermissionsByRoleRoleId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiRolePermissionsByRoleRoleIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiRolePermissionsByRoleRoleId>>
>;
export type GetApiRolePermissionsByRoleRoleIdQueryError = unknown;

export function useGetApiRolePermissionsByRoleRoleId<
  TData = Awaited<ReturnType<typeof getApiRolePermissionsByRoleRoleId>>,
  TError = unknown,
>(
  roleId: string,
  params?: GetApiRolePermissionsByRoleRoleIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiRolePermissionsByRoleRoleId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiRolePermissionsByRoleRoleIdQueryOptions(
    roleId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiRolePermissionsByEntity = (
  params?: GetApiRolePermissionsByEntityParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Role/permissions/byEntity`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiRolePermissionsByEntityQueryKey = (
  params?: GetApiRolePermissionsByEntityParams
) => {
  return [
    `/api/Role/permissions/byEntity`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiRolePermissionsByEntityQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiRolePermissionsByEntity>>,
  TError = unknown,
>(
  params?: GetApiRolePermissionsByEntityParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiRolePermissionsByEntity>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiRolePermissionsByEntityQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiRolePermissionsByEntity>>
  > = ({ signal }) =>
    getApiRolePermissionsByEntity(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiRolePermissionsByEntity>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiRolePermissionsByEntityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiRolePermissionsByEntity>>
>;
export type GetApiRolePermissionsByEntityQueryError = unknown;

export function useGetApiRolePermissionsByEntity<
  TData = Awaited<ReturnType<typeof getApiRolePermissionsByEntity>>,
  TError = unknown,
>(
  params?: GetApiRolePermissionsByEntityParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiRolePermissionsByEntity>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiRolePermissionsByEntityQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiRolePermissionsFiltered = (
  params?: GetApiRolePermissionsFilteredParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Role/permissions/filtered`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiRolePermissionsFilteredQueryKey = (
  params?: GetApiRolePermissionsFilteredParams
) => {
  return [
    `/api/Role/permissions/filtered`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiRolePermissionsFilteredQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiRolePermissionsFiltered>>,
  TError = unknown,
>(
  params?: GetApiRolePermissionsFilteredParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiRolePermissionsFiltered>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiRolePermissionsFilteredQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiRolePermissionsFiltered>>
  > = ({ signal }) =>
    getApiRolePermissionsFiltered(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiRolePermissionsFiltered>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiRolePermissionsFilteredQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiRolePermissionsFiltered>>
>;
export type GetApiRolePermissionsFilteredQueryError = unknown;

export function useGetApiRolePermissionsFiltered<
  TData = Awaited<ReturnType<typeof getApiRolePermissionsFiltered>>,
  TError = unknown,
>(
  params?: GetApiRolePermissionsFilteredParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiRolePermissionsFiltered>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiRolePermissionsFilteredQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiStatisticsGeneral = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<StatisticsResponseDto>(
    { url: `/api/Statistics/general`, method: 'GET', signal },
    options
  );
};

export const getGetApiStatisticsGeneralQueryKey = () => {
  return [`/api/Statistics/general`] as const;
};

export const getGetApiStatisticsGeneralQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiStatisticsGeneral>>,
  TError = ProblemDetails | void,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiStatisticsGeneral>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiStatisticsGeneralQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiStatisticsGeneral>>
  > = ({ signal }) => getApiStatisticsGeneral(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiStatisticsGeneral>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiStatisticsGeneralQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiStatisticsGeneral>>
>;
export type GetApiStatisticsGeneralQueryError = ProblemDetails | void;

export function useGetApiStatisticsGeneral<
  TData = Awaited<ReturnType<typeof getApiStatisticsGeneral>>,
  TError = ProblemDetails | void,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiStatisticsGeneral>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiStatisticsGeneralQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiStatisticsByClient = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<ClientStatisticsResponseDto[]>(
    { url: `/api/Statistics/by-client`, method: 'GET', signal },
    options
  );
};

export const getGetApiStatisticsByClientQueryKey = () => {
  return [`/api/Statistics/by-client`] as const;
};

export const getGetApiStatisticsByClientQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiStatisticsByClient>>,
  TError = ProblemDetails | void,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiStatisticsByClient>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiStatisticsByClientQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiStatisticsByClient>>
  > = ({ signal }) => getApiStatisticsByClient(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiStatisticsByClient>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiStatisticsByClientQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiStatisticsByClient>>
>;
export type GetApiStatisticsByClientQueryError = ProblemDetails | void;

export function useGetApiStatisticsByClient<
  TData = Awaited<ReturnType<typeof getApiStatisticsByClient>>,
  TError = ProblemDetails | void,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiStatisticsByClient>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiStatisticsByClientQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSubscriptionSources = (
  params?: GetApiSubscriptionSourcesParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/SubscriptionSources`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiSubscriptionSourcesQueryKey = (
  params?: GetApiSubscriptionSourcesParams
) => {
  return [`/api/SubscriptionSources`, ...(params ? [params] : [])] as const;
};

export const getGetApiSubscriptionSourcesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSubscriptionSources>>,
  TError = unknown,
>(
  params?: GetApiSubscriptionSourcesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiSubscriptionSources>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiSubscriptionSourcesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSubscriptionSources>>
  > = ({ signal }) => getApiSubscriptionSources(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSubscriptionSources>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiSubscriptionSourcesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSubscriptionSources>>
>;
export type GetApiSubscriptionSourcesQueryError = unknown;

export function useGetApiSubscriptionSources<
  TData = Awaited<ReturnType<typeof getApiSubscriptionSources>>,
  TError = unknown,
>(
  params?: GetApiSubscriptionSourcesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiSubscriptionSources>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiSubscriptionSourcesQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiSubscriptionSources = (
  createSubscriptionSourceDto: CreateSubscriptionSourceDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/SubscriptionSources`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createSubscriptionSourceDto,
      signal,
    },
    options
  );
};

export const getPostApiSubscriptionSourcesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiSubscriptionSources>>,
    TError,
    { data: CreateSubscriptionSourceDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiSubscriptionSources>>,
  TError,
  { data: CreateSubscriptionSourceDto },
  TContext
> => {
  const mutationKey = ['postApiSubscriptionSources'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiSubscriptionSources>>,
    { data: CreateSubscriptionSourceDto }
  > = props => {
    const { data } = props ?? {};

    return postApiSubscriptionSources(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiSubscriptionSourcesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiSubscriptionSources>>
>;
export type PostApiSubscriptionSourcesMutationBody =
  CreateSubscriptionSourceDto;
export type PostApiSubscriptionSourcesMutationError = unknown;

export const usePostApiSubscriptionSources = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiSubscriptionSources>>,
    TError,
    { data: CreateSubscriptionSourceDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiSubscriptionSources>>,
  TError,
  { data: CreateSubscriptionSourceDto },
  TContext
> => {
  const mutationOptions = getPostApiSubscriptionSourcesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiSubscriptionSourcesId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/SubscriptionSources/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiSubscriptionSourcesIdQueryKey = (id?: number) => {
  return [`/api/SubscriptionSources/${id}`] as const;
};

export const getGetApiSubscriptionSourcesIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSubscriptionSourcesId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiSubscriptionSourcesId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiSubscriptionSourcesIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSubscriptionSourcesId>>
  > = ({ signal }) => getApiSubscriptionSourcesId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSubscriptionSourcesId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiSubscriptionSourcesIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSubscriptionSourcesId>>
>;
export type GetApiSubscriptionSourcesIdQueryError = unknown;

export function useGetApiSubscriptionSourcesId<
  TData = Awaited<ReturnType<typeof getApiSubscriptionSourcesId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiSubscriptionSourcesId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiSubscriptionSourcesIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiSubscriptionSourcesId = (
  id: number,
  updateSubscriptionSourceDto: UpdateSubscriptionSourceDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/SubscriptionSources/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateSubscriptionSourceDto,
    },
    options
  );
};

export const getPutApiSubscriptionSourcesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSubscriptionSourcesId>>,
    TError,
    { id: number; data: UpdateSubscriptionSourceDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSubscriptionSourcesId>>,
  TError,
  { id: number; data: UpdateSubscriptionSourceDto },
  TContext
> => {
  const mutationKey = ['putApiSubscriptionSourcesId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSubscriptionSourcesId>>,
    { id: number; data: UpdateSubscriptionSourceDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiSubscriptionSourcesId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSubscriptionSourcesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiSubscriptionSourcesId>>
>;
export type PutApiSubscriptionSourcesIdMutationBody =
  UpdateSubscriptionSourceDto;
export type PutApiSubscriptionSourcesIdMutationError = unknown;

export const usePutApiSubscriptionSourcesId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSubscriptionSourcesId>>,
    TError,
    { id: number; data: UpdateSubscriptionSourceDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiSubscriptionSourcesId>>,
  TError,
  { id: number; data: UpdateSubscriptionSourceDto },
  TContext
> => {
  const mutationOptions =
    getPutApiSubscriptionSourcesIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiSubscriptionSourcesId = (
  id: number,
  params?: DeleteApiSubscriptionSourcesIdParams,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/SubscriptionSources/${id}`, method: 'DELETE', params },
    options
  );
};

export const getDeleteApiSubscriptionSourcesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiSubscriptionSourcesId>>,
    TError,
    { id: number; params?: DeleteApiSubscriptionSourcesIdParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiSubscriptionSourcesId>>,
  TError,
  { id: number; params?: DeleteApiSubscriptionSourcesIdParams },
  TContext
> => {
  const mutationKey = ['deleteApiSubscriptionSourcesId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiSubscriptionSourcesId>>,
    { id: number; params?: DeleteApiSubscriptionSourcesIdParams }
  > = props => {
    const { id, params } = props ?? {};

    return deleteApiSubscriptionSourcesId(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiSubscriptionSourcesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiSubscriptionSourcesId>>
>;

export type DeleteApiSubscriptionSourcesIdMutationError = unknown;

export const useDeleteApiSubscriptionSourcesId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiSubscriptionSourcesId>>,
    TError,
    { id: number; params?: DeleteApiSubscriptionSourcesIdParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiSubscriptionSourcesId>>,
  TError,
  { id: number; params?: DeleteApiSubscriptionSourcesIdParams },
  TContext
> => {
  const mutationOptions =
    getDeleteApiSubscriptionSourcesIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiSubscriptionSourcesBatch = (
  createSubscriptionSourceDto: CreateSubscriptionSourceDto[],
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/SubscriptionSources/batch`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createSubscriptionSourceDto,
      signal,
    },
    options
  );
};

export const getPostApiSubscriptionSourcesBatchMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiSubscriptionSourcesBatch>>,
    TError,
    { data: CreateSubscriptionSourceDto[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiSubscriptionSourcesBatch>>,
  TError,
  { data: CreateSubscriptionSourceDto[] },
  TContext
> => {
  const mutationKey = ['postApiSubscriptionSourcesBatch'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiSubscriptionSourcesBatch>>,
    { data: CreateSubscriptionSourceDto[] }
  > = props => {
    const { data } = props ?? {};

    return postApiSubscriptionSourcesBatch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiSubscriptionSourcesBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiSubscriptionSourcesBatch>>
>;
export type PostApiSubscriptionSourcesBatchMutationBody =
  CreateSubscriptionSourceDto[];
export type PostApiSubscriptionSourcesBatchMutationError = unknown;

export const usePostApiSubscriptionSourcesBatch = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiSubscriptionSourcesBatch>>,
    TError,
    { data: CreateSubscriptionSourceDto[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiSubscriptionSourcesBatch>>,
  TError,
  { data: CreateSubscriptionSourceDto[] },
  TContext
> => {
  const mutationOptions =
    getPostApiSubscriptionSourcesBatchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiSubscriptionSourcesReloadMappings = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/SubscriptionSources/reload-mappings`, method: 'POST', signal },
    options
  );
};

export const getPostApiSubscriptionSourcesReloadMappingsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiSubscriptionSourcesReloadMappings>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiSubscriptionSourcesReloadMappings>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postApiSubscriptionSourcesReloadMappings'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiSubscriptionSourcesReloadMappings>>,
    void
  > = () => {
    return postApiSubscriptionSourcesReloadMappings(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiSubscriptionSourcesReloadMappingsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiSubscriptionSourcesReloadMappings>>
  >;

export type PostApiSubscriptionSourcesReloadMappingsMutationError = unknown;

export const usePostApiSubscriptionSourcesReloadMappings = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiSubscriptionSourcesReloadMappings>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiSubscriptionSourcesReloadMappings>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getPostApiSubscriptionSourcesReloadMappingsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiSubscriptionSourcesInitialValuesPlantId = (
  plantId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/SubscriptionSources/initial-values/${plantId}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetApiSubscriptionSourcesInitialValuesPlantIdQueryKey = (
  plantId?: number
) => {
  return [`/api/SubscriptionSources/initial-values/${plantId}`] as const;
};

export const getGetApiSubscriptionSourcesInitialValuesPlantIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiSubscriptionSourcesInitialValuesPlantId>
  >,
  TError = unknown,
>(
  plantId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiSubscriptionSourcesInitialValuesPlantId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiSubscriptionSourcesInitialValuesPlantIdQueryKey(plantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSubscriptionSourcesInitialValuesPlantId>>
  > = ({ signal }) =>
    getApiSubscriptionSourcesInitialValuesPlantId(
      plantId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!plantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSubscriptionSourcesInitialValuesPlantId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiSubscriptionSourcesInitialValuesPlantIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiSubscriptionSourcesInitialValuesPlantId>>
  >;
export type GetApiSubscriptionSourcesInitialValuesPlantIdQueryError = unknown;

export function useGetApiSubscriptionSourcesInitialValuesPlantId<
  TData = Awaited<
    ReturnType<typeof getApiSubscriptionSourcesInitialValuesPlantId>
  >,
  TError = unknown,
>(
  plantId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiSubscriptionSourcesInitialValuesPlantId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getGetApiSubscriptionSourcesInitialValuesPlantIdQueryOptions(
      plantId,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTables = (
  params?: GetApiTablesParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Tables`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiTablesQueryKey = (params?: GetApiTablesParams) => {
  return [`/api/Tables`, ...(params ? [params] : [])] as const;
};

export const getGetApiTablesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTables>>,
  TError = unknown,
>(
  params?: GetApiTablesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTables>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTablesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTables>>> = ({
    signal,
  }) => getApiTables(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTables>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTablesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTables>>
>;
export type GetApiTablesQueryError = unknown;

export function useGetApiTables<
  TData = Awaited<ReturnType<typeof getApiTables>>,
  TError = unknown,
>(
  params?: GetApiTablesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTables>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTablesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiTables = (
  createTableDto: CreateTableDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CreateResponseDto>(
    {
      url: `/api/Tables`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createTableDto,
      signal,
    },
    options
  );
};

export const getPostApiTablesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTables>>,
    TError,
    { data: CreateTableDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTables>>,
  TError,
  { data: CreateTableDto },
  TContext
> => {
  const mutationKey = ['postApiTables'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTables>>,
    { data: CreateTableDto }
  > = props => {
    const { data } = props ?? {};

    return postApiTables(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTablesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTables>>
>;
export type PostApiTablesMutationBody = CreateTableDto;
export type PostApiTablesMutationError = unknown;

export const usePostApiTables = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTables>>,
    TError,
    { data: CreateTableDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiTables>>,
  TError,
  { data: CreateTableDto },
  TContext
> => {
  const mutationOptions = getPostApiTablesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiTablesAdvance = (
  params?: GetApiTablesAdvanceParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Tables/Advance`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiTablesAdvanceQueryKey = (
  params?: GetApiTablesAdvanceParams
) => {
  return [`/api/Tables/Advance`, ...(params ? [params] : [])] as const;
};

export const getGetApiTablesAdvanceQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTablesAdvance>>,
  TError = unknown,
>(
  params?: GetApiTablesAdvanceParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTablesAdvance>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTablesAdvanceQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTablesAdvance>>
  > = ({ signal }) => getApiTablesAdvance(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTablesAdvance>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTablesAdvanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTablesAdvance>>
>;
export type GetApiTablesAdvanceQueryError = unknown;

export function useGetApiTablesAdvance<
  TData = Awaited<ReturnType<typeof getApiTablesAdvance>>,
  TError = unknown,
>(
  params?: GetApiTablesAdvanceParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTablesAdvance>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTablesAdvanceQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiTablesAdvance = (
  createTableAdvanceDto: CreateTableAdvanceDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CreateResponseDto>(
    {
      url: `/api/Tables/Advance`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createTableAdvanceDto,
      signal,
    },
    options
  );
};

export const getPostApiTablesAdvanceMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTablesAdvance>>,
    TError,
    { data: CreateTableAdvanceDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTablesAdvance>>,
  TError,
  { data: CreateTableAdvanceDto },
  TContext
> => {
  const mutationKey = ['postApiTablesAdvance'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTablesAdvance>>,
    { data: CreateTableAdvanceDto }
  > = props => {
    const { data } = props ?? {};

    return postApiTablesAdvance(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTablesAdvanceMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTablesAdvance>>
>;
export type PostApiTablesAdvanceMutationBody = CreateTableAdvanceDto;
export type PostApiTablesAdvanceMutationError = unknown;

export const usePostApiTablesAdvance = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTablesAdvance>>,
    TError,
    { data: CreateTableAdvanceDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiTablesAdvance>>,
  TError,
  { data: CreateTableAdvanceDto },
  TContext
> => {
  const mutationOptions = getPostApiTablesAdvanceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiTablesId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Tables/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiTablesIdQueryKey = (id?: number) => {
  return [`/api/Tables/${id}`] as const;
};

export const getGetApiTablesIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTablesId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTablesId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTablesIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTablesId>>> = ({
    signal,
  }) => getApiTablesId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTablesId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTablesIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTablesId>>
>;
export type GetApiTablesIdQueryError = unknown;

export function useGetApiTablesId<
  TData = Awaited<ReturnType<typeof getApiTablesId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTablesId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTablesIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiTablesId = (
  id: number,
  tableDto: TableDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    {
      url: `/api/Tables/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: tableDto,
    },
    options
  );
};

export const getPutApiTablesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiTablesId>>,
    TError,
    { id: number; data: TableDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiTablesId>>,
  TError,
  { id: number; data: TableDto },
  TContext
> => {
  const mutationKey = ['putApiTablesId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiTablesId>>,
    { id: number; data: TableDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiTablesId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiTablesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiTablesId>>
>;
export type PutApiTablesIdMutationBody = TableDto;
export type PutApiTablesIdMutationError = unknown;

export const usePutApiTablesId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiTablesId>>,
    TError,
    { id: number; data: TableDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiTablesId>>,
  TError,
  { id: number; data: TableDto },
  TContext
> => {
  const mutationOptions = getPutApiTablesIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiTablesId = (
  id: number,
  params?: DeleteApiTablesIdParams,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    { url: `/api/Tables/${id}`, method: 'DELETE', params },
    options
  );
};

export const getDeleteApiTablesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiTablesId>>,
    TError,
    { id: number; params?: DeleteApiTablesIdParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiTablesId>>,
  TError,
  { id: number; params?: DeleteApiTablesIdParams },
  TContext
> => {
  const mutationKey = ['deleteApiTablesId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiTablesId>>,
    { id: number; params?: DeleteApiTablesIdParams }
  > = props => {
    const { id, params } = props ?? {};

    return deleteApiTablesId(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiTablesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiTablesId>>
>;

export type DeleteApiTablesIdMutationError = unknown;

export const useDeleteApiTablesId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiTablesId>>,
    TError,
    { id: number; params?: DeleteApiTablesIdParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiTablesId>>,
  TError,
  { id: number; params?: DeleteApiTablesIdParams },
  TContext
> => {
  const mutationOptions = getDeleteApiTablesIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiTablesAdvanceId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Tables/Advance/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiTablesAdvanceIdQueryKey = (id?: number) => {
  return [`/api/Tables/Advance/${id}`] as const;
};

export const getGetApiTablesAdvanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTablesAdvanceId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTablesAdvanceId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTablesAdvanceIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTablesAdvanceId>>
  > = ({ signal }) => getApiTablesAdvanceId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTablesAdvanceId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTablesAdvanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTablesAdvanceId>>
>;
export type GetApiTablesAdvanceIdQueryError = unknown;

export function useGetApiTablesAdvanceId<
  TData = Awaited<ReturnType<typeof getApiTablesAdvanceId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTablesAdvanceId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTablesAdvanceIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiTablesAdvanceId = (
  id: number,
  tableAdvanceDto: TableAdvanceDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    {
      url: `/api/Tables/Advance/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: tableAdvanceDto,
    },
    options
  );
};

export const getPutApiTablesAdvanceIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiTablesAdvanceId>>,
    TError,
    { id: number; data: TableAdvanceDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiTablesAdvanceId>>,
  TError,
  { id: number; data: TableAdvanceDto },
  TContext
> => {
  const mutationKey = ['putApiTablesAdvanceId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiTablesAdvanceId>>,
    { id: number; data: TableAdvanceDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiTablesAdvanceId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiTablesAdvanceIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiTablesAdvanceId>>
>;
export type PutApiTablesAdvanceIdMutationBody = TableAdvanceDto;
export type PutApiTablesAdvanceIdMutationError = unknown;

export const usePutApiTablesAdvanceId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiTablesAdvanceId>>,
    TError,
    { id: number; data: TableAdvanceDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiTablesAdvanceId>>,
  TError,
  { id: number; data: TableAdvanceDto },
  TContext
> => {
  const mutationOptions = getPutApiTablesAdvanceIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiTablesByZoneZoneId = (
  zoneId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Tables/ByZone/${zoneId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiTablesByZoneZoneIdQueryKey = (zoneId?: number) => {
  return [`/api/Tables/ByZone/${zoneId}`] as const;
};

export const getGetApiTablesByZoneZoneIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTablesByZoneZoneId>>,
  TError = unknown,
>(
  zoneId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTablesByZoneZoneId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTablesByZoneZoneIdQueryKey(zoneId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTablesByZoneZoneId>>
  > = ({ signal }) => getApiTablesByZoneZoneId(zoneId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!zoneId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTablesByZoneZoneId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTablesByZoneZoneIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTablesByZoneZoneId>>
>;
export type GetApiTablesByZoneZoneIdQueryError = unknown;

export function useGetApiTablesByZoneZoneId<
  TData = Awaited<ReturnType<typeof getApiTablesByZoneZoneId>>,
  TError = unknown,
>(
  zoneId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTablesByZoneZoneId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTablesByZoneZoneIdQueryOptions(zoneId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTablesAdvanceByZoneZoneId = (
  zoneId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Tables/Advance/ByZone/${zoneId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiTablesAdvanceByZoneZoneIdQueryKey = (zoneId?: number) => {
  return [`/api/Tables/Advance/ByZone/${zoneId}`] as const;
};

export const getGetApiTablesAdvanceByZoneZoneIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTablesAdvanceByZoneZoneId>>,
  TError = unknown,
>(
  zoneId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTablesAdvanceByZoneZoneId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiTablesAdvanceByZoneZoneIdQueryKey(zoneId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTablesAdvanceByZoneZoneId>>
  > = ({ signal }) =>
    getApiTablesAdvanceByZoneZoneId(zoneId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!zoneId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTablesAdvanceByZoneZoneId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTablesAdvanceByZoneZoneIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTablesAdvanceByZoneZoneId>>
>;
export type GetApiTablesAdvanceByZoneZoneIdQueryError = unknown;

export function useGetApiTablesAdvanceByZoneZoneId<
  TData = Awaited<ReturnType<typeof getApiTablesAdvanceByZoneZoneId>>,
  TError = unknown,
>(
  zoneId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTablesAdvanceByZoneZoneId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTablesAdvanceByZoneZoneIdQueryOptions(
    zoneId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTablesByZoneZoneIdAndNameTableName = (
  zoneId: number,
  tableName: string,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Tables/byZone/${zoneId}/andName/${tableName}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetApiTablesByZoneZoneIdAndNameTableNameQueryKey = (
  zoneId?: number,
  tableName?: string
) => {
  return [`/api/Tables/byZone/${zoneId}/andName/${tableName}`] as const;
};

export const getGetApiTablesByZoneZoneIdAndNameTableNameQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTablesByZoneZoneIdAndNameTableName>>,
  TError = unknown,
>(
  zoneId: number,
  tableName: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTablesByZoneZoneIdAndNameTableName>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiTablesByZoneZoneIdAndNameTableNameQueryKey(zoneId, tableName);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTablesByZoneZoneIdAndNameTableName>>
  > = ({ signal }) =>
    getApiTablesByZoneZoneIdAndNameTableName(
      zoneId,
      tableName,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(zoneId && tableName),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTablesByZoneZoneIdAndNameTableName>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTablesByZoneZoneIdAndNameTableNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTablesByZoneZoneIdAndNameTableName>>
>;
export type GetApiTablesByZoneZoneIdAndNameTableNameQueryError = unknown;

export function useGetApiTablesByZoneZoneIdAndNameTableName<
  TData = Awaited<ReturnType<typeof getApiTablesByZoneZoneIdAndNameTableName>>,
  TError = unknown,
>(
  zoneId: number,
  tableName: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTablesByZoneZoneIdAndNameTableName>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTablesByZoneZoneIdAndNameTableNameQueryOptions(
    zoneId,
    tableName,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTasks = (
  params?: GetApiTasksParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Tasks`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiTasksQueryKey = (params?: GetApiTasksParams) => {
  return [`/api/Tasks`, ...(params ? [params] : [])] as const;
};

export const getGetApiTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTasks>>,
  TError = unknown,
>(
  params?: GetApiTasksParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTasks>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTasksQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTasks>>> = ({
    signal,
  }) => getApiTasks(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTasks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTasks>>
>;
export type GetApiTasksQueryError = unknown;

export function useGetApiTasks<
  TData = Awaited<ReturnType<typeof getApiTasks>>,
  TError = unknown,
>(
  params?: GetApiTasksParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTasks>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTasksQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTasksSimple = (
  params?: GetApiTasksSimpleParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Tasks/Simple`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiTasksSimpleQueryKey = (
  params?: GetApiTasksSimpleParams
) => {
  return [`/api/Tasks/Simple`, ...(params ? [params] : [])] as const;
};

export const getGetApiTasksSimpleQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTasksSimple>>,
  TError = unknown,
>(
  params?: GetApiTasksSimpleParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTasksSimple>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTasksSimpleQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTasksSimple>>
  > = ({ signal }) => getApiTasksSimple(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTasksSimple>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTasksSimpleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTasksSimple>>
>;
export type GetApiTasksSimpleQueryError = unknown;

export function useGetApiTasksSimple<
  TData = Awaited<ReturnType<typeof getApiTasksSimple>>,
  TError = unknown,
>(
  params?: GetApiTasksSimpleParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTasksSimple>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTasksSimpleQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiTasksSimple = (
  createTaskSimpleDto: CreateTaskSimpleDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Tasks/Simple`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createTaskSimpleDto,
      signal,
    },
    options
  );
};

export const getPostApiTasksSimpleMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTasksSimple>>,
    TError,
    { data: CreateTaskSimpleDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTasksSimple>>,
  TError,
  { data: CreateTaskSimpleDto },
  TContext
> => {
  const mutationKey = ['postApiTasksSimple'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTasksSimple>>,
    { data: CreateTaskSimpleDto }
  > = props => {
    const { data } = props ?? {};

    return postApiTasksSimple(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTasksSimpleMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTasksSimple>>
>;
export type PostApiTasksSimpleMutationBody = CreateTaskSimpleDto;
export type PostApiTasksSimpleMutationError = unknown;

export const usePostApiTasksSimple = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTasksSimple>>,
    TError,
    { data: CreateTaskSimpleDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiTasksSimple>>,
  TError,
  { data: CreateTaskSimpleDto },
  TContext
> => {
  const mutationOptions = getPostApiTasksSimpleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiTasksSimpleId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Tasks/Simple/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiTasksSimpleIdQueryKey = (id?: number) => {
  return [`/api/Tasks/Simple/${id}`] as const;
};

export const getGetApiTasksSimpleIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTasksSimpleId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTasksSimpleId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTasksSimpleIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTasksSimpleId>>
  > = ({ signal }) => getApiTasksSimpleId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTasksSimpleId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTasksSimpleIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTasksSimpleId>>
>;
export type GetApiTasksSimpleIdQueryError = unknown;

export function useGetApiTasksSimpleId<
  TData = Awaited<ReturnType<typeof getApiTasksSimpleId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTasksSimpleId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTasksSimpleIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiTasksSimpleId = (
  id: number,
  updateTaskSimpleRequestDto: UpdateTaskSimpleRequestDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/Tasks/Simple/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateTaskSimpleRequestDto,
    },
    options
  );
};

export const getPutApiTasksSimpleIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiTasksSimpleId>>,
    TError,
    { id: number; data: UpdateTaskSimpleRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiTasksSimpleId>>,
  TError,
  { id: number; data: UpdateTaskSimpleRequestDto },
  TContext
> => {
  const mutationKey = ['putApiTasksSimpleId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiTasksSimpleId>>,
    { id: number; data: UpdateTaskSimpleRequestDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiTasksSimpleId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiTasksSimpleIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiTasksSimpleId>>
>;
export type PutApiTasksSimpleIdMutationBody = UpdateTaskSimpleRequestDto;
export type PutApiTasksSimpleIdMutationError = unknown;

export const usePutApiTasksSimpleId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiTasksSimpleId>>,
    TError,
    { id: number; data: UpdateTaskSimpleRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiTasksSimpleId>>,
  TError,
  { id: number; data: UpdateTaskSimpleRequestDto },
  TContext
> => {
  const mutationOptions = getPutApiTasksSimpleIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiTasksSimpleId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/Tasks/Simple/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiTasksSimpleIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiTasksSimpleId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiTasksSimpleId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiTasksSimpleId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiTasksSimpleId>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiTasksSimpleId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiTasksSimpleIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiTasksSimpleId>>
>;

export type DeleteApiTasksSimpleIdMutationError = unknown;

export const useDeleteApiTasksSimpleId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiTasksSimpleId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiTasksSimpleId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteApiTasksSimpleIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiTasksFormula = (
  params?: GetApiTasksFormulaParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Tasks/Formula`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiTasksFormulaQueryKey = (
  params?: GetApiTasksFormulaParams
) => {
  return [`/api/Tasks/Formula`, ...(params ? [params] : [])] as const;
};

export const getGetApiTasksFormulaQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTasksFormula>>,
  TError = unknown,
>(
  params?: GetApiTasksFormulaParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTasksFormula>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTasksFormulaQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTasksFormula>>
  > = ({ signal }) => getApiTasksFormula(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTasksFormula>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTasksFormulaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTasksFormula>>
>;
export type GetApiTasksFormulaQueryError = unknown;

export function useGetApiTasksFormula<
  TData = Awaited<ReturnType<typeof getApiTasksFormula>>,
  TError = unknown,
>(
  params?: GetApiTasksFormulaParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTasksFormula>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTasksFormulaQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiTasksFormula = (
  createTaskFormulaDto: CreateTaskFormulaDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Tasks/Formula`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createTaskFormulaDto,
      signal,
    },
    options
  );
};

export const getPostApiTasksFormulaMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTasksFormula>>,
    TError,
    { data: CreateTaskFormulaDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTasksFormula>>,
  TError,
  { data: CreateTaskFormulaDto },
  TContext
> => {
  const mutationKey = ['postApiTasksFormula'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTasksFormula>>,
    { data: CreateTaskFormulaDto }
  > = props => {
    const { data } = props ?? {};

    return postApiTasksFormula(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTasksFormulaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTasksFormula>>
>;
export type PostApiTasksFormulaMutationBody = CreateTaskFormulaDto;
export type PostApiTasksFormulaMutationError = unknown;

export const usePostApiTasksFormula = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTasksFormula>>,
    TError,
    { data: CreateTaskFormulaDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiTasksFormula>>,
  TError,
  { data: CreateTaskFormulaDto },
  TContext
> => {
  const mutationOptions = getPostApiTasksFormulaMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiTasksFormulaId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Tasks/Formula/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiTasksFormulaIdQueryKey = (id?: number) => {
  return [`/api/Tasks/Formula/${id}`] as const;
};

export const getGetApiTasksFormulaIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTasksFormulaId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTasksFormulaId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTasksFormulaIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTasksFormulaId>>
  > = ({ signal }) => getApiTasksFormulaId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTasksFormulaId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTasksFormulaIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTasksFormulaId>>
>;
export type GetApiTasksFormulaIdQueryError = unknown;

export function useGetApiTasksFormulaId<
  TData = Awaited<ReturnType<typeof getApiTasksFormulaId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTasksFormulaId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTasksFormulaIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiTasksFormulaId = (
  id: number,
  updateTaskFormulaRequestDto: UpdateTaskFormulaRequestDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/Tasks/Formula/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateTaskFormulaRequestDto,
    },
    options
  );
};

export const getPutApiTasksFormulaIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiTasksFormulaId>>,
    TError,
    { id: number; data: UpdateTaskFormulaRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiTasksFormulaId>>,
  TError,
  { id: number; data: UpdateTaskFormulaRequestDto },
  TContext
> => {
  const mutationKey = ['putApiTasksFormulaId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiTasksFormulaId>>,
    { id: number; data: UpdateTaskFormulaRequestDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiTasksFormulaId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiTasksFormulaIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiTasksFormulaId>>
>;
export type PutApiTasksFormulaIdMutationBody = UpdateTaskFormulaRequestDto;
export type PutApiTasksFormulaIdMutationError = unknown;

export const usePutApiTasksFormulaId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiTasksFormulaId>>,
    TError,
    { id: number; data: UpdateTaskFormulaRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiTasksFormulaId>>,
  TError,
  { id: number; data: UpdateTaskFormulaRequestDto },
  TContext
> => {
  const mutationOptions = getPutApiTasksFormulaIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiTasksFormulaId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/Tasks/Formula/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiTasksFormulaIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiTasksFormulaId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiTasksFormulaId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiTasksFormulaId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiTasksFormulaId>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiTasksFormulaId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiTasksFormulaIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiTasksFormulaId>>
>;

export type DeleteApiTasksFormulaIdMutationError = unknown;

export const useDeleteApiTasksFormulaId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiTasksFormulaId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiTasksFormulaId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteApiTasksFormulaIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiTasksTree = (
  params?: GetApiTasksTreeParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Tasks/tree`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiTasksTreeQueryKey = (params?: GetApiTasksTreeParams) => {
  return [`/api/Tasks/tree`, ...(params ? [params] : [])] as const;
};

export const getGetApiTasksTreeQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTasksTree>>,
  TError = unknown,
>(
  params?: GetApiTasksTreeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTasksTree>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTasksTreeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTasksTree>>> = ({
    signal,
  }) => getApiTasksTree(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTasksTree>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTasksTreeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTasksTree>>
>;
export type GetApiTasksTreeQueryError = unknown;

export function useGetApiTasksTree<
  TData = Awaited<ReturnType<typeof getApiTasksTree>>,
  TError = unknown,
>(
  params?: GetApiTasksTreeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTasksTree>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTasksTreeQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTasksGetLastDataFromDiagramIdDiagramId = (
  diagramId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Tasks/GetLastDataFromDiagramId/${diagramId}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetApiTasksGetLastDataFromDiagramIdDiagramIdQueryKey = (
  diagramId?: number
) => {
  return [`/api/Tasks/GetLastDataFromDiagramId/${diagramId}`] as const;
};

export const getGetApiTasksGetLastDataFromDiagramIdDiagramIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiTasksGetLastDataFromDiagramIdDiagramId>
  >,
  TError = unknown,
>(
  diagramId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTasksGetLastDataFromDiagramIdDiagramId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiTasksGetLastDataFromDiagramIdDiagramIdQueryKey(diagramId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTasksGetLastDataFromDiagramIdDiagramId>>
  > = ({ signal }) =>
    getApiTasksGetLastDataFromDiagramIdDiagramId(
      diagramId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!diagramId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTasksGetLastDataFromDiagramIdDiagramId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTasksGetLastDataFromDiagramIdDiagramIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiTasksGetLastDataFromDiagramIdDiagramId>>
  >;
export type GetApiTasksGetLastDataFromDiagramIdDiagramIdQueryError = unknown;

export function useGetApiTasksGetLastDataFromDiagramIdDiagramId<
  TData = Awaited<
    ReturnType<typeof getApiTasksGetLastDataFromDiagramIdDiagramId>
  >,
  TError = unknown,
>(
  diagramId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTasksGetLastDataFromDiagramIdDiagramId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getGetApiTasksGetLastDataFromDiagramIdDiagramIdQueryOptions(
      diagramId,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiTasksMigrateOldTasks = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Tasks/MigrateOldTasks`, method: 'POST', signal },
    options
  );
};

export const getPostApiTasksMigrateOldTasksMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTasksMigrateOldTasks>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTasksMigrateOldTasks>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postApiTasksMigrateOldTasks'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTasksMigrateOldTasks>>,
    void
  > = () => {
    return postApiTasksMigrateOldTasks(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTasksMigrateOldTasksMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTasksMigrateOldTasks>>
>;

export type PostApiTasksMigrateOldTasksMutationError = unknown;

export const usePostApiTasksMigrateOldTasks = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTasksMigrateOldTasks>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiTasksMigrateOldTasks>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getPostApiTasksMigrateOldTasksMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiTasksCheck = (
  checkTaskRequestDto: CheckTaskRequestDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Tasks/check`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: checkTaskRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiTasksCheckMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTasksCheck>>,
    TError,
    { data: CheckTaskRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTasksCheck>>,
  TError,
  { data: CheckTaskRequestDto },
  TContext
> => {
  const mutationKey = ['postApiTasksCheck'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTasksCheck>>,
    { data: CheckTaskRequestDto }
  > = props => {
    const { data } = props ?? {};

    return postApiTasksCheck(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTasksCheckMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTasksCheck>>
>;
export type PostApiTasksCheckMutationBody = CheckTaskRequestDto;
export type PostApiTasksCheckMutationError = unknown;

export const usePostApiTasksCheck = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTasksCheck>>,
    TError,
    { data: CheckTaskRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiTasksCheck>>,
  TError,
  { data: CheckTaskRequestDto },
  TContext
> => {
  const mutationOptions = getPostApiTasksCheckMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiTasksTest = (
  testTaskRequestDto: TestTaskRequestDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Tasks/test`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: testTaskRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiTasksTestMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTasksTest>>,
    TError,
    { data: TestTaskRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTasksTest>>,
  TError,
  { data: TestTaskRequestDto },
  TContext
> => {
  const mutationKey = ['postApiTasksTest'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTasksTest>>,
    { data: TestTaskRequestDto }
  > = props => {
    const { data } = props ?? {};

    return postApiTasksTest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTasksTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTasksTest>>
>;
export type PostApiTasksTestMutationBody = TestTaskRequestDto;
export type PostApiTasksTestMutationError = unknown;

export const usePostApiTasksTest = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTasksTest>>,
    TError,
    { data: TestTaskRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiTasksTest>>,
  TError,
  { data: TestTaskRequestDto },
  TContext
> => {
  const mutationOptions = getPostApiTasksTestMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiTasksExecutionResultsExecutionId = (
  executionId: string,
  params?: GetApiTasksExecutionResultsExecutionIdParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Tasks/execution-results/${executionId}`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetApiTasksExecutionResultsExecutionIdQueryKey = (
  executionId?: string,
  params?: GetApiTasksExecutionResultsExecutionIdParams
) => {
  return [
    `/api/Tasks/execution-results/${executionId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiTasksExecutionResultsExecutionIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTasksExecutionResultsExecutionId>>,
  TError = unknown,
>(
  executionId: string,
  params?: GetApiTasksExecutionResultsExecutionIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTasksExecutionResultsExecutionId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiTasksExecutionResultsExecutionIdQueryKey(executionId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTasksExecutionResultsExecutionId>>
  > = ({ signal }) =>
    getApiTasksExecutionResultsExecutionId(
      executionId,
      params,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!executionId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTasksExecutionResultsExecutionId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTasksExecutionResultsExecutionIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTasksExecutionResultsExecutionId>>
>;
export type GetApiTasksExecutionResultsExecutionIdQueryError = unknown;

export function useGetApiTasksExecutionResultsExecutionId<
  TData = Awaited<ReturnType<typeof getApiTasksExecutionResultsExecutionId>>,
  TError = unknown,
>(
  executionId: string,
  params?: GetApiTasksExecutionResultsExecutionIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTasksExecutionResultsExecutionId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTasksExecutionResultsExecutionIdQueryOptions(
    executionId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiTasksSaveExecutionResultsExecutionId = (
  executionId: string,
  params?: PostApiTasksSaveExecutionResultsExecutionIdParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Tasks/save-execution-results/${executionId}`,
      method: 'POST',
      params,
      signal,
    },
    options
  );
};

export const getPostApiTasksSaveExecutionResultsExecutionIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTasksSaveExecutionResultsExecutionId>>,
    TError,
    {
      executionId: string;
      params?: PostApiTasksSaveExecutionResultsExecutionIdParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTasksSaveExecutionResultsExecutionId>>,
  TError,
  {
    executionId: string;
    params?: PostApiTasksSaveExecutionResultsExecutionIdParams;
  },
  TContext
> => {
  const mutationKey = ['postApiTasksSaveExecutionResultsExecutionId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTasksSaveExecutionResultsExecutionId>>,
    {
      executionId: string;
      params?: PostApiTasksSaveExecutionResultsExecutionIdParams;
    }
  > = props => {
    const { executionId, params } = props ?? {};

    return postApiTasksSaveExecutionResultsExecutionId(
      executionId,
      params,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTasksSaveExecutionResultsExecutionIdMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiTasksSaveExecutionResultsExecutionId>>
  >;

export type PostApiTasksSaveExecutionResultsExecutionIdMutationError = unknown;

export const usePostApiTasksSaveExecutionResultsExecutionId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTasksSaveExecutionResultsExecutionId>>,
    TError,
    {
      executionId: string;
      params?: PostApiTasksSaveExecutionResultsExecutionIdParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiTasksSaveExecutionResultsExecutionId>>,
  TError,
  {
    executionId: string;
    params?: PostApiTasksSaveExecutionResultsExecutionIdParams;
  },
  TContext
> => {
  const mutationOptions =
    getPostApiTasksSaveExecutionResultsExecutionIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiTasksTaskIdMetrics = (
  taskId: number,
  params?: DeleteApiTasksTaskIdMetricsParams,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/Tasks/${taskId}/metrics`, method: 'DELETE', params },
    options
  );
};

export const getDeleteApiTasksTaskIdMetricsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiTasksTaskIdMetrics>>,
    TError,
    { taskId: number; params?: DeleteApiTasksTaskIdMetricsParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiTasksTaskIdMetrics>>,
  TError,
  { taskId: number; params?: DeleteApiTasksTaskIdMetricsParams },
  TContext
> => {
  const mutationKey = ['deleteApiTasksTaskIdMetrics'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiTasksTaskIdMetrics>>,
    { taskId: number; params?: DeleteApiTasksTaskIdMetricsParams }
  > = props => {
    const { taskId, params } = props ?? {};

    return deleteApiTasksTaskIdMetrics(taskId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiTasksTaskIdMetricsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiTasksTaskIdMetrics>>
>;

export type DeleteApiTasksTaskIdMetricsMutationError = unknown;

export const useDeleteApiTasksTaskIdMetrics = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiTasksTaskIdMetrics>>,
    TError,
    { taskId: number; params?: DeleteApiTasksTaskIdMetricsParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiTasksTaskIdMetrics>>,
  TError,
  { taskId: number; params?: DeleteApiTasksTaskIdMetricsParams },
  TContext
> => {
  const mutationOptions =
    getDeleteApiTasksTaskIdMetricsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiTelegramEnviarAlerta = (
  enviarAlertaRequest: EnviarAlertaRequest,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Telegram/enviar-alerta`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: enviarAlertaRequest,
      signal,
    },
    options
  );
};

export const getPostApiTelegramEnviarAlertaMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTelegramEnviarAlerta>>,
    TError,
    { data: EnviarAlertaRequest },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTelegramEnviarAlerta>>,
  TError,
  { data: EnviarAlertaRequest },
  TContext
> => {
  const mutationKey = ['postApiTelegramEnviarAlerta'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTelegramEnviarAlerta>>,
    { data: EnviarAlertaRequest }
  > = props => {
    const { data } = props ?? {};

    return postApiTelegramEnviarAlerta(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTelegramEnviarAlertaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTelegramEnviarAlerta>>
>;
export type PostApiTelegramEnviarAlertaMutationBody = EnviarAlertaRequest;
export type PostApiTelegramEnviarAlertaMutationError = unknown;

export const usePostApiTelegramEnviarAlerta = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTelegramEnviarAlerta>>,
    TError,
    { data: EnviarAlertaRequest },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiTelegramEnviarAlerta>>,
  TError,
  { data: EnviarAlertaRequest },
  TContext
> => {
  const mutationOptions =
    getPostApiTelegramEnviarAlertaMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiTelegramClientLoginRequest = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/TelegramClient/login/request`, method: 'POST', signal },
    options
  );
};

export const getPostApiTelegramClientLoginRequestMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTelegramClientLoginRequest>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTelegramClientLoginRequest>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postApiTelegramClientLoginRequest'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTelegramClientLoginRequest>>,
    void
  > = () => {
    return postApiTelegramClientLoginRequest(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTelegramClientLoginRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTelegramClientLoginRequest>>
>;

export type PostApiTelegramClientLoginRequestMutationError = unknown;

export const usePostApiTelegramClientLoginRequest = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTelegramClientLoginRequest>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiTelegramClientLoginRequest>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getPostApiTelegramClientLoginRequestMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiTelegramClientLoginVerify = (
  postApiTelegramClientLoginVerifyBody: string,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/TelegramClient/login/verify`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postApiTelegramClientLoginVerifyBody,
      signal,
    },
    options
  );
};

export const getPostApiTelegramClientLoginVerifyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTelegramClientLoginVerify>>,
    TError,
    { data: string },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTelegramClientLoginVerify>>,
  TError,
  { data: string },
  TContext
> => {
  const mutationKey = ['postApiTelegramClientLoginVerify'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTelegramClientLoginVerify>>,
    { data: string }
  > = props => {
    const { data } = props ?? {};

    return postApiTelegramClientLoginVerify(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTelegramClientLoginVerifyMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTelegramClientLoginVerify>>
>;
export type PostApiTelegramClientLoginVerifyMutationBody = string;
export type PostApiTelegramClientLoginVerifyMutationError = unknown;

export const usePostApiTelegramClientLoginVerify = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTelegramClientLoginVerify>>,
    TError,
    { data: string },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiTelegramClientLoginVerify>>,
  TError,
  { data: string },
  TContext
> => {
  const mutationOptions =
    getPostApiTelegramClientLoginVerifyMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiTelegramClientCreateGroup = (
  createTelegramGroupDto: CreateTelegramGroupDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/TelegramClient/CreateGroup`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createTelegramGroupDto,
      signal,
    },
    options
  );
};

export const getPostApiTelegramClientCreateGroupMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTelegramClientCreateGroup>>,
    TError,
    { data: CreateTelegramGroupDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTelegramClientCreateGroup>>,
  TError,
  { data: CreateTelegramGroupDto },
  TContext
> => {
  const mutationKey = ['postApiTelegramClientCreateGroup'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTelegramClientCreateGroup>>,
    { data: CreateTelegramGroupDto }
  > = props => {
    const { data } = props ?? {};

    return postApiTelegramClientCreateGroup(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTelegramClientCreateGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTelegramClientCreateGroup>>
>;
export type PostApiTelegramClientCreateGroupMutationBody =
  CreateTelegramGroupDto;
export type PostApiTelegramClientCreateGroupMutationError = unknown;

export const usePostApiTelegramClientCreateGroup = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTelegramClientCreateGroup>>,
    TError,
    { data: CreateTelegramGroupDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiTelegramClientCreateGroup>>,
  TError,
  { data: CreateTelegramGroupDto },
  TContext
> => {
  const mutationOptions =
    getPostApiTelegramClientCreateGroupMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiTelegramClientRemoveGroup = (
  params?: DeleteApiTelegramClientRemoveGroupParams,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/TelegramClient/RemoveGroup`, method: 'DELETE', params },
    options
  );
};

export const getDeleteApiTelegramClientRemoveGroupMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiTelegramClientRemoveGroup>>,
    TError,
    { params?: DeleteApiTelegramClientRemoveGroupParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiTelegramClientRemoveGroup>>,
  TError,
  { params?: DeleteApiTelegramClientRemoveGroupParams },
  TContext
> => {
  const mutationKey = ['deleteApiTelegramClientRemoveGroup'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiTelegramClientRemoveGroup>>,
    { params?: DeleteApiTelegramClientRemoveGroupParams }
  > = props => {
    const { params } = props ?? {};

    return deleteApiTelegramClientRemoveGroup(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiTelegramClientRemoveGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiTelegramClientRemoveGroup>>
>;

export type DeleteApiTelegramClientRemoveGroupMutationError = unknown;

export const useDeleteApiTelegramClientRemoveGroup = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiTelegramClientRemoveGroup>>,
    TError,
    { params?: DeleteApiTelegramClientRemoveGroupParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiTelegramClientRemoveGroup>>,
  TError,
  { params?: DeleteApiTelegramClientRemoveGroupParams },
  TContext
> => {
  const mutationOptions =
    getDeleteApiTelegramClientRemoveGroupMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiTelegramClientRoleIdRemove = (
  roleId: string,
  postApiTelegramClientRoleIdRemoveBody: string,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/TelegramClient/${roleId}/remove`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postApiTelegramClientRoleIdRemoveBody,
      signal,
    },
    options
  );
};

export const getPostApiTelegramClientRoleIdRemoveMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTelegramClientRoleIdRemove>>,
    TError,
    { roleId: string; data: string },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTelegramClientRoleIdRemove>>,
  TError,
  { roleId: string; data: string },
  TContext
> => {
  const mutationKey = ['postApiTelegramClientRoleIdRemove'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTelegramClientRoleIdRemove>>,
    { roleId: string; data: string }
  > = props => {
    const { roleId, data } = props ?? {};

    return postApiTelegramClientRoleIdRemove(roleId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTelegramClientRoleIdRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTelegramClientRoleIdRemove>>
>;
export type PostApiTelegramClientRoleIdRemoveMutationBody = string;
export type PostApiTelegramClientRoleIdRemoveMutationError = unknown;

export const usePostApiTelegramClientRoleIdRemove = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTelegramClientRoleIdRemove>>,
    TError,
    { roleId: string; data: string },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiTelegramClientRoleIdRemove>>,
  TError,
  { roleId: string; data: string },
  TContext
> => {
  const mutationOptions =
    getPostApiTelegramClientRoleIdRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiTelegramClientRoleIdMessage = (
  roleId: string,
  postApiTelegramClientRoleIdMessageBody: string,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/TelegramClient/${roleId}/message`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postApiTelegramClientRoleIdMessageBody,
      signal,
    },
    options
  );
};

export const getPostApiTelegramClientRoleIdMessageMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTelegramClientRoleIdMessage>>,
    TError,
    { roleId: string; data: string },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTelegramClientRoleIdMessage>>,
  TError,
  { roleId: string; data: string },
  TContext
> => {
  const mutationKey = ['postApiTelegramClientRoleIdMessage'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTelegramClientRoleIdMessage>>,
    { roleId: string; data: string }
  > = props => {
    const { roleId, data } = props ?? {};

    return postApiTelegramClientRoleIdMessage(roleId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTelegramClientRoleIdMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTelegramClientRoleIdMessage>>
>;
export type PostApiTelegramClientRoleIdMessageMutationBody = string;
export type PostApiTelegramClientRoleIdMessageMutationError = unknown;

export const usePostApiTelegramClientRoleIdMessage = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTelegramClientRoleIdMessage>>,
    TError,
    { roleId: string; data: string },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiTelegramClientRoleIdMessage>>,
  TError,
  { roleId: string; data: string },
  TContext
> => {
  const mutationOptions =
    getPostApiTelegramClientRoleIdMessageMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiTemplateExportSchedule = (
  createTemplateExportScheduleDto: CreateTemplateExportScheduleDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/TemplateExportSchedule`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createTemplateExportScheduleDto,
      signal,
    },
    options
  );
};

export const getPostApiTemplateExportScheduleMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTemplateExportSchedule>>,
    TError,
    { data: CreateTemplateExportScheduleDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTemplateExportSchedule>>,
  TError,
  { data: CreateTemplateExportScheduleDto },
  TContext
> => {
  const mutationKey = ['postApiTemplateExportSchedule'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTemplateExportSchedule>>,
    { data: CreateTemplateExportScheduleDto }
  > = props => {
    const { data } = props ?? {};

    return postApiTemplateExportSchedule(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTemplateExportScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTemplateExportSchedule>>
>;
export type PostApiTemplateExportScheduleMutationBody =
  CreateTemplateExportScheduleDto;
export type PostApiTemplateExportScheduleMutationError = unknown;

export const usePostApiTemplateExportSchedule = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTemplateExportSchedule>>,
    TError,
    { data: CreateTemplateExportScheduleDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiTemplateExportSchedule>>,
  TError,
  { data: CreateTemplateExportScheduleDto },
  TContext
> => {
  const mutationOptions =
    getPostApiTemplateExportScheduleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiTemplateExportSchedule = (
  updateTemplateExportScheduleRequestDto: UpdateTemplateExportScheduleRequestDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/TemplateExportSchedule`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateTemplateExportScheduleRequestDto,
    },
    options
  );
};

export const getPutApiTemplateExportScheduleMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiTemplateExportSchedule>>,
    TError,
    { data: UpdateTemplateExportScheduleRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiTemplateExportSchedule>>,
  TError,
  { data: UpdateTemplateExportScheduleRequestDto },
  TContext
> => {
  const mutationKey = ['putApiTemplateExportSchedule'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiTemplateExportSchedule>>,
    { data: UpdateTemplateExportScheduleRequestDto }
  > = props => {
    const { data } = props ?? {};

    return putApiTemplateExportSchedule(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiTemplateExportScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiTemplateExportSchedule>>
>;
export type PutApiTemplateExportScheduleMutationBody =
  UpdateTemplateExportScheduleRequestDto;
export type PutApiTemplateExportScheduleMutationError = unknown;

export const usePutApiTemplateExportSchedule = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiTemplateExportSchedule>>,
    TError,
    { data: UpdateTemplateExportScheduleRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiTemplateExportSchedule>>,
  TError,
  { data: UpdateTemplateExportScheduleRequestDto },
  TContext
> => {
  const mutationOptions =
    getPutApiTemplateExportScheduleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiTemplateExportSchedule = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/TemplateExportSchedule`, method: 'GET', signal },
    options
  );
};

export const getGetApiTemplateExportScheduleQueryKey = () => {
  return [`/api/TemplateExportSchedule`] as const;
};

export const getGetApiTemplateExportScheduleQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTemplateExportSchedule>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiTemplateExportSchedule>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTemplateExportScheduleQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTemplateExportSchedule>>
  > = ({ signal }) => getApiTemplateExportSchedule(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTemplateExportSchedule>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTemplateExportScheduleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTemplateExportSchedule>>
>;
export type GetApiTemplateExportScheduleQueryError = unknown;

export function useGetApiTemplateExportSchedule<
  TData = Awaited<ReturnType<typeof getApiTemplateExportSchedule>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiTemplateExportSchedule>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTemplateExportScheduleQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteApiTemplateExportScheduleId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/TemplateExportSchedule/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiTemplateExportScheduleIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiTemplateExportScheduleId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiTemplateExportScheduleId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiTemplateExportScheduleId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiTemplateExportScheduleId>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiTemplateExportScheduleId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiTemplateExportScheduleIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiTemplateExportScheduleId>>
>;

export type DeleteApiTemplateExportScheduleIdMutationError = unknown;

export const useDeleteApiTemplateExportScheduleId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiTemplateExportScheduleId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiTemplateExportScheduleId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getDeleteApiTemplateExportScheduleIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiTemplateExportScheduleId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/TemplateExportSchedule/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiTemplateExportScheduleIdQueryKey = (id?: number) => {
  return [`/api/TemplateExportSchedule/${id}`] as const;
};

export const getGetApiTemplateExportScheduleIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTemplateExportScheduleId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTemplateExportScheduleId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTemplateExportScheduleIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTemplateExportScheduleId>>
  > = ({ signal }) =>
    getApiTemplateExportScheduleId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTemplateExportScheduleId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTemplateExportScheduleIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTemplateExportScheduleId>>
>;
export type GetApiTemplateExportScheduleIdQueryError = unknown;

export function useGetApiTemplateExportScheduleId<
  TData = Awaited<ReturnType<typeof getApiTemplateExportScheduleId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTemplateExportScheduleId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTemplateExportScheduleIdQueryOptions(
    id,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiTemplateExportScheduleIdTrigger = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/TemplateExportSchedule/${id}/trigger`,
      method: 'POST',
      signal,
    },
    options
  );
};

export const getPostApiTemplateExportScheduleIdTriggerMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTemplateExportScheduleIdTrigger>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTemplateExportScheduleIdTrigger>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['postApiTemplateExportScheduleIdTrigger'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTemplateExportScheduleIdTrigger>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return postApiTemplateExportScheduleIdTrigger(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTemplateExportScheduleIdTriggerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTemplateExportScheduleIdTrigger>>
>;

export type PostApiTemplateExportScheduleIdTriggerMutationError = unknown;

export const usePostApiTemplateExportScheduleIdTrigger = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTemplateExportScheduleIdTrigger>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiTemplateExportScheduleIdTrigger>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getPostApiTemplateExportScheduleIdTriggerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiTemplateExportScheduleSend = (
  sendTemplateExportRequestDto: SendTemplateExportRequestDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/TemplateExportSchedule/send`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sendTemplateExportRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiTemplateExportScheduleSendMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTemplateExportScheduleSend>>,
    TError,
    { data: SendTemplateExportRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTemplateExportScheduleSend>>,
  TError,
  { data: SendTemplateExportRequestDto },
  TContext
> => {
  const mutationKey = ['postApiTemplateExportScheduleSend'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTemplateExportScheduleSend>>,
    { data: SendTemplateExportRequestDto }
  > = props => {
    const { data } = props ?? {};

    return postApiTemplateExportScheduleSend(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTemplateExportScheduleSendMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTemplateExportScheduleSend>>
>;
export type PostApiTemplateExportScheduleSendMutationBody =
  SendTemplateExportRequestDto;
export type PostApiTemplateExportScheduleSendMutationError = unknown;

export const usePostApiTemplateExportScheduleSend = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTemplateExportScheduleSend>>,
    TError,
    { data: SendTemplateExportRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiTemplateExportScheduleSend>>,
  TError,
  { data: SendTemplateExportRequestDto },
  TContext
> => {
  const mutationOptions =
    getPostApiTemplateExportScheduleSendMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiTickets = (
  params?: GetApiTicketsParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Tickets`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiTicketsQueryKey = (params?: GetApiTicketsParams) => {
  return [`/api/Tickets`, ...(params ? [params] : [])] as const;
};

export const getGetApiTicketsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTickets>>,
  TError = unknown,
>(
  params?: GetApiTicketsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTickets>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTicketsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTickets>>> = ({
    signal,
  }) => getApiTickets(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTickets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTicketsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTickets>>
>;
export type GetApiTicketsQueryError = unknown;

export function useGetApiTickets<
  TData = Awaited<ReturnType<typeof getApiTickets>>,
  TError = unknown,
>(
  params?: GetApiTicketsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTickets>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTicketsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiTickets = (
  createTicketDto: CreateTicketDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Tickets`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createTicketDto,
      signal,
    },
    options
  );
};

export const getPostApiTicketsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTickets>>,
    TError,
    { data: CreateTicketDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTickets>>,
  TError,
  { data: CreateTicketDto },
  TContext
> => {
  const mutationKey = ['postApiTickets'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTickets>>,
    { data: CreateTicketDto }
  > = props => {
    const { data } = props ?? {};

    return postApiTickets(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTicketsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTickets>>
>;
export type PostApiTicketsMutationBody = CreateTicketDto;
export type PostApiTicketsMutationError = unknown;

export const usePostApiTickets = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTickets>>,
    TError,
    { data: CreateTicketDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiTickets>>,
  TError,
  { data: CreateTicketDto },
  TContext
> => {
  const mutationOptions = getPostApiTicketsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiTicketsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Tickets/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiTicketsIdQueryKey = (id?: number) => {
  return [`/api/Tickets/${id}`] as const;
};

export const getGetApiTicketsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTicketsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTicketsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTicketsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTicketsId>>> = ({
    signal,
  }) => getApiTicketsId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTicketsId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTicketsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTicketsId>>
>;
export type GetApiTicketsIdQueryError = unknown;

export function useGetApiTicketsId<
  TData = Awaited<ReturnType<typeof getApiTicketsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTicketsId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTicketsIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiTicketsId = (
  id: number,
  createTicketDto: CreateTicketDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/Tickets/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: createTicketDto,
    },
    options
  );
};

export const getPutApiTicketsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiTicketsId>>,
    TError,
    { id: number; data: CreateTicketDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiTicketsId>>,
  TError,
  { id: number; data: CreateTicketDto },
  TContext
> => {
  const mutationKey = ['putApiTicketsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiTicketsId>>,
    { id: number; data: CreateTicketDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiTicketsId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiTicketsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiTicketsId>>
>;
export type PutApiTicketsIdMutationBody = CreateTicketDto;
export type PutApiTicketsIdMutationError = unknown;

export const usePutApiTicketsId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiTicketsId>>,
    TError,
    { id: number; data: CreateTicketDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiTicketsId>>,
  TError,
  { id: number; data: CreateTicketDto },
  TContext
> => {
  const mutationOptions = getPutApiTicketsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiTicketsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/Tickets/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiTicketsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiTicketsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiTicketsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiTicketsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiTicketsId>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteApiTicketsId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiTicketsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiTicketsId>>
>;

export type DeleteApiTicketsIdMutationError = unknown;

export const useDeleteApiTicketsId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiTicketsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiTicketsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteApiTicketsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiTicketsAdmin = (
  params?: GetApiTicketsAdminParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Tickets/admin`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiTicketsAdminQueryKey = (
  params?: GetApiTicketsAdminParams
) => {
  return [`/api/Tickets/admin`, ...(params ? [params] : [])] as const;
};

export const getGetApiTicketsAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTicketsAdmin>>,
  TError = unknown,
>(
  params?: GetApiTicketsAdminParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTicketsAdmin>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTicketsAdminQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTicketsAdmin>>
  > = ({ signal }) => getApiTicketsAdmin(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTicketsAdmin>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTicketsAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTicketsAdmin>>
>;
export type GetApiTicketsAdminQueryError = unknown;

export function useGetApiTicketsAdmin<
  TData = Awaited<ReturnType<typeof getApiTicketsAdmin>>,
  TError = unknown,
>(
  params?: GetApiTicketsAdminParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTicketsAdmin>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTicketsAdminQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiTicketsIdStatus = (
  id: number,
  updateTicketStatusRequestDto: UpdateTicketStatusRequestDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/Tickets/${id}/status`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateTicketStatusRequestDto,
    },
    options
  );
};

export const getPutApiTicketsIdStatusMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiTicketsIdStatus>>,
    TError,
    { id: number; data: UpdateTicketStatusRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiTicketsIdStatus>>,
  TError,
  { id: number; data: UpdateTicketStatusRequestDto },
  TContext
> => {
  const mutationKey = ['putApiTicketsIdStatus'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiTicketsIdStatus>>,
    { id: number; data: UpdateTicketStatusRequestDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiTicketsIdStatus(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiTicketsIdStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiTicketsIdStatus>>
>;
export type PutApiTicketsIdStatusMutationBody = UpdateTicketStatusRequestDto;
export type PutApiTicketsIdStatusMutationError = unknown;

export const usePutApiTicketsIdStatus = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiTicketsIdStatus>>,
    TError,
    { id: number; data: UpdateTicketStatusRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiTicketsIdStatus>>,
  TError,
  { id: number; data: UpdateTicketStatusRequestDto },
  TContext
> => {
  const mutationOptions = getPutApiTicketsIdStatusMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiTicketsAdminStatistics = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Tickets/admin/statistics`, method: 'GET', signal },
    options
  );
};

export const getGetApiTicketsAdminStatisticsQueryKey = () => {
  return [`/api/Tickets/admin/statistics`] as const;
};

export const getGetApiTicketsAdminStatisticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTicketsAdminStatistics>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiTicketsAdminStatistics>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTicketsAdminStatisticsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTicketsAdminStatistics>>
  > = ({ signal }) => getApiTicketsAdminStatistics(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTicketsAdminStatistics>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTicketsAdminStatisticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTicketsAdminStatistics>>
>;
export type GetApiTicketsAdminStatisticsQueryError = unknown;

export function useGetApiTicketsAdminStatistics<
  TData = Awaited<ReturnType<typeof getApiTicketsAdminStatistics>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiTicketsAdminStatistics>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTicketsAdminStatisticsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiTicketsIdAssign = (
  id: number,
  assignTicketRequestDto: AssignTicketRequestDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/Tickets/${id}/assign`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: assignTicketRequestDto,
    },
    options
  );
};

export const getPutApiTicketsIdAssignMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiTicketsIdAssign>>,
    TError,
    { id: number; data: AssignTicketRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiTicketsIdAssign>>,
  TError,
  { id: number; data: AssignTicketRequestDto },
  TContext
> => {
  const mutationKey = ['putApiTicketsIdAssign'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiTicketsIdAssign>>,
    { id: number; data: AssignTicketRequestDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiTicketsIdAssign(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiTicketsIdAssignMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiTicketsIdAssign>>
>;
export type PutApiTicketsIdAssignMutationBody = AssignTicketRequestDto;
export type PutApiTicketsIdAssignMutationError = unknown;

export const usePutApiTicketsIdAssign = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiTicketsIdAssign>>,
    TError,
    { id: number; data: AssignTicketRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiTicketsIdAssign>>,
  TError,
  { id: number; data: AssignTicketRequestDto },
  TContext
> => {
  const mutationOptions = getPutApiTicketsIdAssignMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiUsers = (
  params?: GetApiUsersParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Users`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiUsersQueryKey = (params?: GetApiUsersParams) => {
  return [`/api/Users`, ...(params ? [params] : [])] as const;
};

export const getGetApiUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUsers>>,
  TError = unknown,
>(
  params?: GetApiUsersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiUsers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsers>>> = ({
    signal,
  }) => getApiUsers(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUsers>>
>;
export type GetApiUsersQueryError = unknown;

export function useGetApiUsers<
  TData = Awaited<ReturnType<typeof getApiUsers>>,
  TError = unknown,
>(
  params?: GetApiUsersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiUsers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiUsersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiUsers = (
  createUserDto: CreateUserDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CreateResponseDto>(
    {
      url: `/api/Users`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createUserDto,
      signal,
    },
    options
  );
};

export const getPostApiUsersMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUsers>>,
    TError,
    { data: CreateUserDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUsers>>,
  TError,
  { data: CreateUserDto },
  TContext
> => {
  const mutationKey = ['postApiUsers'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUsers>>,
    { data: CreateUserDto }
  > = props => {
    const { data } = props ?? {};

    return postApiUsers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUsersMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUsers>>
>;
export type PostApiUsersMutationBody = CreateUserDto;
export type PostApiUsersMutationError = unknown;

export const usePostApiUsers = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUsers>>,
    TError,
    { data: CreateUserDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiUsers>>,
  TError,
  { data: CreateUserDto },
  TContext
> => {
  const mutationOptions = getPostApiUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiUsersId = (
  id: string,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Users/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiUsersIdQueryKey = (id?: string) => {
  return [`/api/Users/${id}`] as const;
};

export const getGetApiUsersIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUsersId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiUsersId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersId>>> = ({
    signal,
  }) => getApiUsersId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUsersId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiUsersIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUsersId>>
>;
export type GetApiUsersIdQueryError = unknown;

export function useGetApiUsersId<
  TData = Awaited<ReturnType<typeof getApiUsersId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiUsersId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiUsersIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteApiUsersId = (
  id: string,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    { url: `/api/Users/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiUsersIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiUsersId>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiUsersId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteApiUsersId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiUsersId>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteApiUsersId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiUsersIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiUsersId>>
>;

export type DeleteApiUsersIdMutationError = unknown;

export const useDeleteApiUsersId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiUsersId>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiUsersId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteApiUsersIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiUsersLogin = (
  loginRequestDto: LoginRequestDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Users/login`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: loginRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiUsersLoginMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUsersLogin>>,
    TError,
    { data: LoginRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUsersLogin>>,
  TError,
  { data: LoginRequestDto },
  TContext
> => {
  const mutationKey = ['postApiUsersLogin'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUsersLogin>>,
    { data: LoginRequestDto }
  > = props => {
    const { data } = props ?? {};

    return postApiUsersLogin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUsersLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUsersLogin>>
>;
export type PostApiUsersLoginMutationBody = LoginRequestDto;
export type PostApiUsersLoginMutationError = unknown;

export const usePostApiUsersLogin = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUsersLogin>>,
    TError,
    { data: LoginRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiUsersLogin>>,
  TError,
  { data: LoginRequestDto },
  TContext
> => {
  const mutationOptions = getPostApiUsersLoginMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiUsersRefresh = (
  refreshTokenRequestDto: RefreshTokenRequestDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Users/refresh`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: refreshTokenRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiUsersRefreshMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUsersRefresh>>,
    TError,
    { data: RefreshTokenRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUsersRefresh>>,
  TError,
  { data: RefreshTokenRequestDto },
  TContext
> => {
  const mutationKey = ['postApiUsersRefresh'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUsersRefresh>>,
    { data: RefreshTokenRequestDto }
  > = props => {
    const { data } = props ?? {};

    return postApiUsersRefresh(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUsersRefreshMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUsersRefresh>>
>;
export type PostApiUsersRefreshMutationBody = RefreshTokenRequestDto;
export type PostApiUsersRefreshMutationError = unknown;

export const usePostApiUsersRefresh = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUsersRefresh>>,
    TError,
    { data: RefreshTokenRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiUsersRefresh>>,
  TError,
  { data: RefreshTokenRequestDto },
  TContext
> => {
  const mutationOptions = getPostApiUsersRefreshMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiUsersLogged = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Users/logged`, method: 'GET', signal },
    options
  );
};

export const getGetApiUsersLoggedQueryKey = () => {
  return [`/api/Users/logged`] as const;
};

export const getGetApiUsersLoggedQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUsersLogged>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiUsersLogged>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersLoggedQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiUsersLogged>>
  > = ({ signal }) => getApiUsersLogged(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUsersLogged>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiUsersLoggedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUsersLogged>>
>;
export type GetApiUsersLoggedQueryError = unknown;

export function useGetApiUsersLogged<
  TData = Awaited<ReturnType<typeof getApiUsersLogged>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiUsersLogged>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiUsersLoggedQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiUsersRoles = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Users/roles`, method: 'GET', signal },
    options
  );
};

export const getGetApiUsersRolesQueryKey = () => {
  return [`/api/Users/roles`] as const;
};

export const getGetApiUsersRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUsersRoles>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiUsersRoles>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersRolesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiUsersRoles>>
  > = ({ signal }) => getApiUsersRoles(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUsersRoles>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiUsersRolesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUsersRoles>>
>;
export type GetApiUsersRolesQueryError = unknown;

export function useGetApiUsersRoles<
  TData = Awaited<ReturnType<typeof getApiUsersRoles>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiUsersRoles>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiUsersRolesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiUsersRolebyuseridUserId = (
  userId: string,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Users/rolebyuserid/${userId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiUsersRolebyuseridUserIdQueryKey = (userId?: string) => {
  return [`/api/Users/rolebyuserid/${userId}`] as const;
};

export const getGetApiUsersRolebyuseridUserIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUsersRolebyuseridUserId>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiUsersRolebyuseridUserId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiUsersRolebyuseridUserIdQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiUsersRolebyuseridUserId>>
  > = ({ signal }) =>
    getApiUsersRolebyuseridUserId(userId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUsersRolebyuseridUserId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiUsersRolebyuseridUserIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUsersRolebyuseridUserId>>
>;
export type GetApiUsersRolebyuseridUserIdQueryError = unknown;

export function useGetApiUsersRolebyuseridUserId<
  TData = Awaited<ReturnType<typeof getApiUsersRolebyuseridUserId>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiUsersRolebyuseridUserId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiUsersRolebyuseridUserIdQueryOptions(
    userId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiUsersUserId = (
  userId: string,
  createUserDto: CreateUserDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/Users/${userId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: createUserDto,
    },
    options
  );
};

export const getPutApiUsersUserIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiUsersUserId>>,
    TError,
    { userId: string; data: CreateUserDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiUsersUserId>>,
  TError,
  { userId: string; data: CreateUserDto },
  TContext
> => {
  const mutationKey = ['putApiUsersUserId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiUsersUserId>>,
    { userId: string; data: CreateUserDto }
  > = props => {
    const { userId, data } = props ?? {};

    return putApiUsersUserId(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiUsersUserIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiUsersUserId>>
>;
export type PutApiUsersUserIdMutationBody = CreateUserDto;
export type PutApiUsersUserIdMutationError = unknown;

export const usePutApiUsersUserId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiUsersUserId>>,
    TError,
    { userId: string; data: CreateUserDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiUsersUserId>>,
  TError,
  { userId: string; data: CreateUserDto },
  TContext
> => {
  const mutationOptions = getPutApiUsersUserIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiUsersSendemail = (
  sendMailRequestDto: SendMailRequestDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Users/sendemail`,
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      signal,
    },
    options
  );
};

export const getGetApiUsersSendemailQueryKey = (
  sendMailRequestDto?: SendMailRequestDto
) => {
  return [`/api/Users/sendemail`, sendMailRequestDto] as const;
};

export const getGetApiUsersSendemailQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUsersSendemail>>,
  TError = unknown,
>(
  sendMailRequestDto: SendMailRequestDto,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiUsersSendemail>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiUsersSendemailQueryKey(sendMailRequestDto);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiUsersSendemail>>
  > = ({ signal }) =>
    getApiUsersSendemail(sendMailRequestDto, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUsersSendemail>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiUsersSendemailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUsersSendemail>>
>;
export type GetApiUsersSendemailQueryError = unknown;

export function useGetApiUsersSendemail<
  TData = Awaited<ReturnType<typeof getApiUsersSendemail>>,
  TError = unknown,
>(
  sendMailRequestDto: SendMailRequestDto,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiUsersSendemail>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiUsersSendemailQueryOptions(
    sendMailRequestDto,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiUsersSendtemplatedemail = (
  sendTemplatedMailRequestDto: SendTemplatedMailRequestDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Users/sendtemplatedemail`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sendTemplatedMailRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiUsersSendtemplatedemailMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUsersSendtemplatedemail>>,
    TError,
    { data: SendTemplatedMailRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUsersSendtemplatedemail>>,
  TError,
  { data: SendTemplatedMailRequestDto },
  TContext
> => {
  const mutationKey = ['postApiUsersSendtemplatedemail'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUsersSendtemplatedemail>>,
    { data: SendTemplatedMailRequestDto }
  > = props => {
    const { data } = props ?? {};

    return postApiUsersSendtemplatedemail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUsersSendtemplatedemailMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUsersSendtemplatedemail>>
>;
export type PostApiUsersSendtemplatedemailMutationBody =
  SendTemplatedMailRequestDto;
export type PostApiUsersSendtemplatedemailMutationError = unknown;

export const usePostApiUsersSendtemplatedemail = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUsersSendtemplatedemail>>,
    TError,
    { data: SendTemplatedMailRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiUsersSendtemplatedemail>>,
  TError,
  { data: SendTemplatedMailRequestDto },
  TContext
> => {
  const mutationOptions =
    getPostApiUsersSendtemplatedemailMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiUsersForgotpassword = (
  forgotPasswordRequestDto: ForgotPasswordRequestDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Users/forgotpassword`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: forgotPasswordRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiUsersForgotpasswordMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUsersForgotpassword>>,
    TError,
    { data: ForgotPasswordRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUsersForgotpassword>>,
  TError,
  { data: ForgotPasswordRequestDto },
  TContext
> => {
  const mutationKey = ['postApiUsersForgotpassword'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUsersForgotpassword>>,
    { data: ForgotPasswordRequestDto }
  > = props => {
    const { data } = props ?? {};

    return postApiUsersForgotpassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUsersForgotpasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUsersForgotpassword>>
>;
export type PostApiUsersForgotpasswordMutationBody = ForgotPasswordRequestDto;
export type PostApiUsersForgotpasswordMutationError = unknown;

export const usePostApiUsersForgotpassword = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUsersForgotpassword>>,
    TError,
    { data: ForgotPasswordRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiUsersForgotpassword>>,
  TError,
  { data: ForgotPasswordRequestDto },
  TContext
> => {
  const mutationOptions = getPostApiUsersForgotpasswordMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiUsersResetpassword = (
  resetPasswordRequestDto: ResetPasswordRequestDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Users/resetpassword`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: resetPasswordRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiUsersResetpasswordMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUsersResetpassword>>,
    TError,
    { data: ResetPasswordRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUsersResetpassword>>,
  TError,
  { data: ResetPasswordRequestDto },
  TContext
> => {
  const mutationKey = ['postApiUsersResetpassword'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUsersResetpassword>>,
    { data: ResetPasswordRequestDto }
  > = props => {
    const { data } = props ?? {};

    return postApiUsersResetpassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUsersResetpasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUsersResetpassword>>
>;
export type PostApiUsersResetpasswordMutationBody = ResetPasswordRequestDto;
export type PostApiUsersResetpasswordMutationError = unknown;

export const usePostApiUsersResetpassword = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUsersResetpassword>>,
    TError,
    { data: ResetPasswordRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiUsersResetpassword>>,
  TError,
  { data: ResetPasswordRequestDto },
  TContext
> => {
  const mutationOptions = getPostApiUsersResetpasswordMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiUsersSuperadminCheck = (
  params?: PostApiUsersSuperadminCheckParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Users/superadmin/check`, method: 'POST', params, signal },
    options
  );
};

export const getPostApiUsersSuperadminCheckMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUsersSuperadminCheck>>,
    TError,
    { params?: PostApiUsersSuperadminCheckParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUsersSuperadminCheck>>,
  TError,
  { params?: PostApiUsersSuperadminCheckParams },
  TContext
> => {
  const mutationKey = ['postApiUsersSuperadminCheck'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUsersSuperadminCheck>>,
    { params?: PostApiUsersSuperadminCheckParams }
  > = props => {
    const { params } = props ?? {};

    return postApiUsersSuperadminCheck(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUsersSuperadminCheckMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUsersSuperadminCheck>>
>;

export type PostApiUsersSuperadminCheckMutationError = unknown;

export const usePostApiUsersSuperadminCheck = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUsersSuperadminCheck>>,
    TError,
    { params?: PostApiUsersSuperadminCheckParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiUsersSuperadminCheck>>,
  TError,
  { params?: PostApiUsersSuperadminCheckParams },
  TContext
> => {
  const mutationOptions =
    getPostApiUsersSuperadminCheckMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiVariablesIngest = (
  metric: Metric[],
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/ingest`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: metric,
      signal,
    },
    options
  );
};

export const getPostApiVariablesIngestMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVariablesIngest>>,
    TError,
    { data: Metric[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiVariablesIngest>>,
  TError,
  { data: Metric[] },
  TContext
> => {
  const mutationKey = ['postApiVariablesIngest'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiVariablesIngest>>,
    { data: Metric[] }
  > = props => {
    const { data } = props ?? {};

    return postApiVariablesIngest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiVariablesIngestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiVariablesIngest>>
>;
export type PostApiVariablesIngestMutationBody = Metric[];
export type PostApiVariablesIngestMutationError = unknown;

export const usePostApiVariablesIngest = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVariablesIngest>>,
    TError,
    { data: Metric[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiVariablesIngest>>,
  TError,
  { data: Metric[] },
  TContext
> => {
  const mutationOptions = getPostApiVariablesIngestMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiVariablesGetTaskFormulaVariableValues = (
  params?: GetApiVariablesGetTaskFormulaVariableValuesParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/GetTaskFormulaVariableValues`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetApiVariablesGetTaskFormulaVariableValuesQueryKey = (
  params?: GetApiVariablesGetTaskFormulaVariableValuesParams
) => {
  return [
    `/api/Variables/GetTaskFormulaVariableValues`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiVariablesGetTaskFormulaVariableValuesQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiVariablesGetTaskFormulaVariableValues>
  >,
  TError = unknown,
>(
  params?: GetApiVariablesGetTaskFormulaVariableValuesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesGetTaskFormulaVariableValues>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiVariablesGetTaskFormulaVariableValuesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesGetTaskFormulaVariableValues>>
  > = ({ signal }) =>
    getApiVariablesGetTaskFormulaVariableValues(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesGetTaskFormulaVariableValues>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesGetTaskFormulaVariableValuesQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiVariablesGetTaskFormulaVariableValues>>
  >;
export type GetApiVariablesGetTaskFormulaVariableValuesQueryError = unknown;

export function useGetApiVariablesGetTaskFormulaVariableValues<
  TData = Awaited<
    ReturnType<typeof getApiVariablesGetTaskFormulaVariableValues>
  >,
  TError = unknown,
>(
  params?: GetApiVariablesGetTaskFormulaVariableValuesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesGetTaskFormulaVariableValues>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getGetApiVariablesGetTaskFormulaVariableValuesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiVariablesTask = (
  createVariableTaskDto: CreateVariableTaskDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/task`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createVariableTaskDto,
      signal,
    },
    options
  );
};

export const getPostApiVariablesTaskMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVariablesTask>>,
    TError,
    { data: CreateVariableTaskDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiVariablesTask>>,
  TError,
  { data: CreateVariableTaskDto },
  TContext
> => {
  const mutationKey = ['postApiVariablesTask'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiVariablesTask>>,
    { data: CreateVariableTaskDto }
  > = props => {
    const { data } = props ?? {};

    return postApiVariablesTask(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiVariablesTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiVariablesTask>>
>;
export type PostApiVariablesTaskMutationBody = CreateVariableTaskDto;
export type PostApiVariablesTaskMutationError = unknown;

export const usePostApiVariablesTask = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVariablesTask>>,
    TError,
    { data: CreateVariableTaskDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiVariablesTask>>,
  TError,
  { data: CreateVariableTaskDto },
  TContext
> => {
  const mutationOptions = getPostApiVariablesTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiVariablesTask = (
  variableTaskDto: VariableTaskDto,
  params?: PutApiVariablesTaskParams,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/task`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: variableTaskDto,
      params,
    },
    options
  );
};

export const getPutApiVariablesTaskMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiVariablesTask>>,
    TError,
    { data: VariableTaskDto; params?: PutApiVariablesTaskParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiVariablesTask>>,
  TError,
  { data: VariableTaskDto; params?: PutApiVariablesTaskParams },
  TContext
> => {
  const mutationKey = ['putApiVariablesTask'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiVariablesTask>>,
    { data: VariableTaskDto; params?: PutApiVariablesTaskParams }
  > = props => {
    const { data, params } = props ?? {};

    return putApiVariablesTask(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiVariablesTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiVariablesTask>>
>;
export type PutApiVariablesTaskMutationBody = VariableTaskDto;
export type PutApiVariablesTaskMutationError = unknown;

export const usePutApiVariablesTask = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiVariablesTask>>,
    TError,
    { data: VariableTaskDto; params?: PutApiVariablesTaskParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiVariablesTask>>,
  TError,
  { data: VariableTaskDto; params?: PutApiVariablesTaskParams },
  TContext
> => {
  const mutationOptions = getPutApiVariablesTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiVariablesGetDataFromVariableId = (
  id: number,
  params?: GetApiVariablesGetDataFromVariableIdParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/GetDataFromVariable/${id}`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetApiVariablesGetDataFromVariableIdQueryKey = (
  id?: number,
  params?: GetApiVariablesGetDataFromVariableIdParams
) => {
  return [
    `/api/Variables/GetDataFromVariable/${id}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiVariablesGetDataFromVariableIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariablesGetDataFromVariableId>>,
  TError = unknown,
>(
  id: number,
  params?: GetApiVariablesGetDataFromVariableIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesGetDataFromVariableId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiVariablesGetDataFromVariableIdQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesGetDataFromVariableId>>
  > = ({ signal }) =>
    getApiVariablesGetDataFromVariableId(id, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesGetDataFromVariableId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesGetDataFromVariableIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesGetDataFromVariableId>>
>;
export type GetApiVariablesGetDataFromVariableIdQueryError = unknown;

export function useGetApiVariablesGetDataFromVariableId<
  TData = Awaited<ReturnType<typeof getApiVariablesGetDataFromVariableId>>,
  TError = unknown,
>(
  id: number,
  params?: GetApiVariablesGetDataFromVariableIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesGetDataFromVariableId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesGetDataFromVariableIdQueryOptions(
    id,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariablesExportData = (
  params?: GetApiVariablesExportDataParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Variables/ExportData`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiVariablesExportDataQueryKey = (
  params?: GetApiVariablesExportDataParams
) => {
  return [`/api/Variables/ExportData`, ...(params ? [params] : [])] as const;
};

export const getGetApiVariablesExportDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariablesExportData>>,
  TError = ProblemDetails | ProblemDetails,
>(
  params?: GetApiVariablesExportDataParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesExportData>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiVariablesExportDataQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesExportData>>
  > = ({ signal }) => getApiVariablesExportData(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesExportData>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesExportDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesExportData>>
>;
export type GetApiVariablesExportDataQueryError =
  | ProblemDetails
  | ProblemDetails;

export function useGetApiVariablesExportData<
  TData = Awaited<ReturnType<typeof getApiVariablesExportData>>,
  TError = ProblemDetails | ProblemDetails,
>(
  params?: GetApiVariablesExportDataParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesExportData>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesExportDataQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariablesGetLastDataByDashboardIdDashboardId = (
  dashboardId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/GetLastDataByDashboardId/${dashboardId}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetApiVariablesGetLastDataByDashboardIdDashboardIdQueryKey = (
  dashboardId?: number
) => {
  return [`/api/Variables/GetLastDataByDashboardId/${dashboardId}`] as const;
};

export const getGetApiVariablesGetLastDataByDashboardIdDashboardIdQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getApiVariablesGetLastDataByDashboardIdDashboardId>
    >,
    TError = unknown,
  >(
    dashboardId: number,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiVariablesGetLastDataByDashboardIdDashboardId>
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof axiosInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApiVariablesGetLastDataByDashboardIdDashboardIdQueryKey(
        dashboardId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getApiVariablesGetLastDataByDashboardIdDashboardId>
      >
    > = ({ signal }) =>
      getApiVariablesGetLastDataByDashboardIdDashboardId(
        dashboardId,
        requestOptions,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!dashboardId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiVariablesGetLastDataByDashboardIdDashboardId>
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type GetApiVariablesGetLastDataByDashboardIdDashboardIdQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getApiVariablesGetLastDataByDashboardIdDashboardId>
    >
  >;
export type GetApiVariablesGetLastDataByDashboardIdDashboardIdQueryError =
  unknown;

export function useGetApiVariablesGetLastDataByDashboardIdDashboardId<
  TData = Awaited<
    ReturnType<typeof getApiVariablesGetLastDataByDashboardIdDashboardId>
  >,
  TError = unknown,
>(
  dashboardId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiVariablesGetLastDataByDashboardIdDashboardId>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getGetApiVariablesGetLastDataByDashboardIdDashboardIdQueryOptions(
      dashboardId,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariablesGetLastDataFromDiagramIdDiagramId = (
  diagramId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/GetLastDataFromDiagramId/${diagramId}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetApiVariablesGetLastDataFromDiagramIdDiagramIdQueryKey = (
  diagramId?: number
) => {
  return [`/api/Variables/GetLastDataFromDiagramId/${diagramId}`] as const;
};

export const getGetApiVariablesGetLastDataFromDiagramIdDiagramIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiVariablesGetLastDataFromDiagramIdDiagramId>
  >,
  TError = unknown,
>(
  diagramId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiVariablesGetLastDataFromDiagramIdDiagramId>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiVariablesGetLastDataFromDiagramIdDiagramIdQueryKey(diagramId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesGetLastDataFromDiagramIdDiagramId>>
  > = ({ signal }) =>
    getApiVariablesGetLastDataFromDiagramIdDiagramId(
      diagramId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!diagramId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getApiVariablesGetLastDataFromDiagramIdDiagramId>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesGetLastDataFromDiagramIdDiagramIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiVariablesGetLastDataFromDiagramIdDiagramId>>
  >;
export type GetApiVariablesGetLastDataFromDiagramIdDiagramIdQueryError =
  unknown;

export function useGetApiVariablesGetLastDataFromDiagramIdDiagramId<
  TData = Awaited<
    ReturnType<typeof getApiVariablesGetLastDataFromDiagramIdDiagramId>
  >,
  TError = unknown,
>(
  diagramId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiVariablesGetLastDataFromDiagramIdDiagramId>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getGetApiVariablesGetLastDataFromDiagramIdDiagramIdQueryOptions(
      diagramId,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariables = (
  params?: GetApiVariablesParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Variables`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiVariablesQueryKey = (params?: GetApiVariablesParams) => {
  return [`/api/Variables`, ...(params ? [params] : [])] as const;
};

export const getGetApiVariablesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariables>>,
  TError = unknown,
>(
  params?: GetApiVariablesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariables>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiVariablesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiVariables>>> = ({
    signal,
  }) => getApiVariables(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariables>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariables>>
>;
export type GetApiVariablesQueryError = unknown;

export function useGetApiVariables<
  TData = Awaited<ReturnType<typeof getApiVariables>>,
  TError = unknown,
>(
  params?: GetApiVariablesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariables>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteApiVariables = (
  params?: DeleteApiVariablesParams,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/Variables`, method: 'DELETE', params },
    options
  );
};

export const getDeleteApiVariablesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiVariables>>,
    TError,
    { params?: DeleteApiVariablesParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiVariables>>,
  TError,
  { params?: DeleteApiVariablesParams },
  TContext
> => {
  const mutationKey = ['deleteApiVariables'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiVariables>>,
    { params?: DeleteApiVariablesParams }
  > = props => {
    const { params } = props ?? {};

    return deleteApiVariables(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiVariablesMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiVariables>>
>;

export type DeleteApiVariablesMutationError = unknown;

export const useDeleteApiVariables = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiVariables>>,
    TError,
    { params?: DeleteApiVariablesParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiVariables>>,
  TError,
  { params?: DeleteApiVariablesParams },
  TContext
> => {
  const mutationOptions = getDeleteApiVariablesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiVariablesScada = (
  params?: GetApiVariablesScadaParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Variables/Scada`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiVariablesScadaQueryKey = (
  params?: GetApiVariablesScadaParams
) => {
  return [`/api/Variables/Scada`, ...(params ? [params] : [])] as const;
};

export const getGetApiVariablesScadaQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariablesScada>>,
  TError = unknown,
>(
  params?: GetApiVariablesScadaParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesScada>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiVariablesScadaQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesScada>>
  > = ({ signal }) => getApiVariablesScada(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesScada>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesScadaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesScada>>
>;
export type GetApiVariablesScadaQueryError = unknown;

export function useGetApiVariablesScada<
  TData = Awaited<ReturnType<typeof getApiVariablesScada>>,
  TError = unknown,
>(
  params?: GetApiVariablesScadaParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesScada>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesScadaQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariablesTasks = (
  params?: GetApiVariablesTasksParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Variables/Tasks`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiVariablesTasksQueryKey = (
  params?: GetApiVariablesTasksParams
) => {
  return [`/api/Variables/Tasks`, ...(params ? [params] : [])] as const;
};

export const getGetApiVariablesTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariablesTasks>>,
  TError = unknown,
>(
  params?: GetApiVariablesTasksParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesTasks>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiVariablesTasksQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesTasks>>
  > = ({ signal }) => getApiVariablesTasks(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesTasks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesTasks>>
>;
export type GetApiVariablesTasksQueryError = unknown;

export function useGetApiVariablesTasks<
  TData = Awaited<ReturnType<typeof getApiVariablesTasks>>,
  TError = unknown,
>(
  params?: GetApiVariablesTasksParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesTasks>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesTasksQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariablesInputs = (
  params?: GetApiVariablesInputsParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Variables/Inputs`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiVariablesInputsQueryKey = (
  params?: GetApiVariablesInputsParams
) => {
  return [`/api/Variables/Inputs`, ...(params ? [params] : [])] as const;
};

export const getGetApiVariablesInputsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariablesInputs>>,
  TError = unknown,
>(
  params?: GetApiVariablesInputsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesInputs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiVariablesInputsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesInputs>>
  > = ({ signal }) => getApiVariablesInputs(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesInputs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesInputsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesInputs>>
>;
export type GetApiVariablesInputsQueryError = unknown;

export function useGetApiVariablesInputs<
  TData = Awaited<ReturnType<typeof getApiVariablesInputs>>,
  TError = unknown,
>(
  params?: GetApiVariablesInputsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesInputs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesInputsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariablesDevices = (
  params?: GetApiVariablesDevicesParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Variables/Devices`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiVariablesDevicesQueryKey = (
  params?: GetApiVariablesDevicesParams
) => {
  return [`/api/Variables/Devices`, ...(params ? [params] : [])] as const;
};

export const getGetApiVariablesDevicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariablesDevices>>,
  TError = unknown,
>(
  params?: GetApiVariablesDevicesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesDevices>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiVariablesDevicesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesDevices>>
  > = ({ signal }) => getApiVariablesDevices(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesDevices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesDevicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesDevices>>
>;
export type GetApiVariablesDevicesQueryError = unknown;

export function useGetApiVariablesDevices<
  TData = Awaited<ReturnType<typeof getApiVariablesDevices>>,
  TError = unknown,
>(
  params?: GetApiVariablesDevicesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesDevices>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesDevicesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariablesId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Variables/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiVariablesIdQueryKey = (id?: number) => {
  return [`/api/Variables/${id}`] as const;
};

export const getGetApiVariablesIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariablesId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiVariablesIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesId>>
  > = ({ signal }) => getApiVariablesId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesId>>
>;
export type GetApiVariablesIdQueryError = unknown;

export function useGetApiVariablesId<
  TData = Awaited<ReturnType<typeof getApiVariablesId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariablesInputId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Variables/Input/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiVariablesInputIdQueryKey = (id?: number) => {
  return [`/api/Variables/Input/${id}`] as const;
};

export const getGetApiVariablesInputIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariablesInputId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesInputId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiVariablesInputIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesInputId>>
  > = ({ signal }) => getApiVariablesInputId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesInputId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesInputIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesInputId>>
>;
export type GetApiVariablesInputIdQueryError = unknown;

export function useGetApiVariablesInputId<
  TData = Awaited<ReturnType<typeof getApiVariablesInputId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesInputId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesInputIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariablesDeviceId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Variables/Device/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiVariablesDeviceIdQueryKey = (id?: number) => {
  return [`/api/Variables/Device/${id}`] as const;
};

export const getGetApiVariablesDeviceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariablesDeviceId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesDeviceId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiVariablesDeviceIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesDeviceId>>
  > = ({ signal }) => getApiVariablesDeviceId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesDeviceId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesDeviceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesDeviceId>>
>;
export type GetApiVariablesDeviceIdQueryError = unknown;

export function useGetApiVariablesDeviceId<
  TData = Awaited<ReturnType<typeof getApiVariablesDeviceId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesDeviceId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesDeviceIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiVariablesInput = (
  createVariableDto: CreateVariableDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/Input`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createVariableDto,
      signal,
    },
    options
  );
};

export const getPostApiVariablesInputMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVariablesInput>>,
    TError,
    { data: CreateVariableDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiVariablesInput>>,
  TError,
  { data: CreateVariableDto },
  TContext
> => {
  const mutationKey = ['postApiVariablesInput'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiVariablesInput>>,
    { data: CreateVariableDto }
  > = props => {
    const { data } = props ?? {};

    return postApiVariablesInput(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiVariablesInputMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiVariablesInput>>
>;
export type PostApiVariablesInputMutationBody = CreateVariableDto;
export type PostApiVariablesInputMutationError = unknown;

export const usePostApiVariablesInput = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVariablesInput>>,
    TError,
    { data: CreateVariableDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiVariablesInput>>,
  TError,
  { data: CreateVariableDto },
  TContext
> => {
  const mutationOptions = getPostApiVariablesInputMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiVariablesInput = (
  variableDto: VariableDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/Input`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: variableDto,
    },
    options
  );
};

export const getPutApiVariablesInputMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiVariablesInput>>,
    TError,
    { data: VariableDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiVariablesInput>>,
  TError,
  { data: VariableDto },
  TContext
> => {
  const mutationKey = ['putApiVariablesInput'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiVariablesInput>>,
    { data: VariableDto }
  > = props => {
    const { data } = props ?? {};

    return putApiVariablesInput(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiVariablesInputMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiVariablesInput>>
>;
export type PutApiVariablesInputMutationBody = VariableDto;
export type PutApiVariablesInputMutationError = unknown;

export const usePutApiVariablesInput = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiVariablesInput>>,
    TError,
    { data: VariableDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiVariablesInput>>,
  TError,
  { data: VariableDto },
  TContext
> => {
  const mutationOptions = getPutApiVariablesInputMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiVariablesDevice = (
  createDeviceDto: CreateDeviceDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/Device`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createDeviceDto,
      signal,
    },
    options
  );
};

export const getPostApiVariablesDeviceMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVariablesDevice>>,
    TError,
    { data: CreateDeviceDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiVariablesDevice>>,
  TError,
  { data: CreateDeviceDto },
  TContext
> => {
  const mutationKey = ['postApiVariablesDevice'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiVariablesDevice>>,
    { data: CreateDeviceDto }
  > = props => {
    const { data } = props ?? {};

    return postApiVariablesDevice(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiVariablesDeviceMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiVariablesDevice>>
>;
export type PostApiVariablesDeviceMutationBody = CreateDeviceDto;
export type PostApiVariablesDeviceMutationError = unknown;

export const usePostApiVariablesDevice = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVariablesDevice>>,
    TError,
    { data: CreateDeviceDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiVariablesDevice>>,
  TError,
  { data: CreateDeviceDto },
  TContext
> => {
  const mutationOptions = getPostApiVariablesDeviceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiVariablesDevice = (
  createDeviceDto: CreateDeviceDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/Device`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: createDeviceDto,
    },
    options
  );
};

export const getPutApiVariablesDeviceMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiVariablesDevice>>,
    TError,
    { data: CreateDeviceDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiVariablesDevice>>,
  TError,
  { data: CreateDeviceDto },
  TContext
> => {
  const mutationKey = ['putApiVariablesDevice'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiVariablesDevice>>,
    { data: CreateDeviceDto }
  > = props => {
    const { data } = props ?? {};

    return putApiVariablesDevice(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiVariablesDeviceMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiVariablesDevice>>
>;
export type PutApiVariablesDeviceMutationBody = CreateDeviceDto;
export type PutApiVariablesDeviceMutationError = unknown;

export const usePutApiVariablesDevice = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiVariablesDevice>>,
    TError,
    { data: CreateDeviceDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiVariablesDevice>>,
  TError,
  { data: CreateDeviceDto },
  TContext
> => {
  const mutationOptions = getPutApiVariablesDeviceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiVariablesDevice = (
  params?: DeleteApiVariablesDeviceParams,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    { url: `/api/Variables/Device`, method: 'DELETE', params },
    options
  );
};

export const getDeleteApiVariablesDeviceMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiVariablesDevice>>,
    TError,
    { params?: DeleteApiVariablesDeviceParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiVariablesDevice>>,
  TError,
  { params?: DeleteApiVariablesDeviceParams },
  TContext
> => {
  const mutationKey = ['deleteApiVariablesDevice'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiVariablesDevice>>,
    { params?: DeleteApiVariablesDeviceParams }
  > = props => {
    const { params } = props ?? {};

    return deleteApiVariablesDevice(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiVariablesDeviceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiVariablesDevice>>
>;

export type DeleteApiVariablesDeviceMutationError = unknown;

export const useDeleteApiVariablesDevice = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiVariablesDevice>>,
    TError,
    { params?: DeleteApiVariablesDeviceParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiVariablesDevice>>,
  TError,
  { params?: DeleteApiVariablesDeviceParams },
  TContext
> => {
  const mutationOptions = getDeleteApiVariablesDeviceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiVariablesScada = (
  createVariableScadaDto: CreateVariableScadaDto,
  params?: PostApiVariablesScadaParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/scada`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createVariableScadaDto,
      params,
      signal,
    },
    options
  );
};

export const getPostApiVariablesScadaMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVariablesScada>>,
    TError,
    { data: CreateVariableScadaDto; params?: PostApiVariablesScadaParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiVariablesScada>>,
  TError,
  { data: CreateVariableScadaDto; params?: PostApiVariablesScadaParams },
  TContext
> => {
  const mutationKey = ['postApiVariablesScada'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiVariablesScada>>,
    { data: CreateVariableScadaDto; params?: PostApiVariablesScadaParams }
  > = props => {
    const { data, params } = props ?? {};

    return postApiVariablesScada(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiVariablesScadaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiVariablesScada>>
>;
export type PostApiVariablesScadaMutationBody = CreateVariableScadaDto;
export type PostApiVariablesScadaMutationError = unknown;

export const usePostApiVariablesScada = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVariablesScada>>,
    TError,
    { data: CreateVariableScadaDto; params?: PostApiVariablesScadaParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiVariablesScada>>,
  TError,
  { data: CreateVariableScadaDto; params?: PostApiVariablesScadaParams },
  TContext
> => {
  const mutationOptions = getPostApiVariablesScadaMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiVariablesScada = (
  variableScadaDto: VariableScadaDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/scada`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: variableScadaDto,
    },
    options
  );
};

export const getPutApiVariablesScadaMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiVariablesScada>>,
    TError,
    { data: VariableScadaDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiVariablesScada>>,
  TError,
  { data: VariableScadaDto },
  TContext
> => {
  const mutationKey = ['putApiVariablesScada'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiVariablesScada>>,
    { data: VariableScadaDto }
  > = props => {
    const { data } = props ?? {};

    return putApiVariablesScada(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiVariablesScadaMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiVariablesScada>>
>;
export type PutApiVariablesScadaMutationBody = VariableScadaDto;
export type PutApiVariablesScadaMutationError = unknown;

export const usePutApiVariablesScada = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiVariablesScada>>,
    TError,
    { data: VariableScadaDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiVariablesScada>>,
  TError,
  { data: VariableScadaDto },
  TContext
> => {
  const mutationOptions = getPutApiVariablesScadaMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiVariablesScadaId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Variables/scada/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiVariablesScadaIdQueryKey = (id?: number) => {
  return [`/api/Variables/scada/${id}`] as const;
};

export const getGetApiVariablesScadaIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariablesScadaId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesScadaId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiVariablesScadaIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesScadaId>>
  > = ({ signal }) => getApiVariablesScadaId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesScadaId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesScadaIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesScadaId>>
>;
export type GetApiVariablesScadaIdQueryError = unknown;

export function useGetApiVariablesScadaId<
  TData = Awaited<ReturnType<typeof getApiVariablesScadaId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesScadaId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesScadaIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariablesScadaByPlantId = (
  id: number,
  params?: GetApiVariablesScadaByPlantIdParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/scada/by-plant/${id}`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetApiVariablesScadaByPlantIdQueryKey = (
  id?: number,
  params?: GetApiVariablesScadaByPlantIdParams
) => {
  return [
    `/api/Variables/scada/by-plant/${id}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiVariablesScadaByPlantIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariablesScadaByPlantId>>,
  TError = unknown,
>(
  id: number,
  params?: GetApiVariablesScadaByPlantIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesScadaByPlantId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiVariablesScadaByPlantIdQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesScadaByPlantId>>
  > = ({ signal }) =>
    getApiVariablesScadaByPlantId(id, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesScadaByPlantId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesScadaByPlantIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesScadaByPlantId>>
>;
export type GetApiVariablesScadaByPlantIdQueryError = unknown;

export function useGetApiVariablesScadaByPlantId<
  TData = Awaited<ReturnType<typeof getApiVariablesScadaByPlantId>>,
  TError = unknown,
>(
  id: number,
  params?: GetApiVariablesScadaByPlantIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesScadaByPlantId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesScadaByPlantIdQueryOptions(
    id,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariablesScadaByZoneId = (
  id: number,
  params?: GetApiVariablesScadaByZoneIdParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/scada/by-zone/${id}`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetApiVariablesScadaByZoneIdQueryKey = (
  id?: number,
  params?: GetApiVariablesScadaByZoneIdParams
) => {
  return [
    `/api/Variables/scada/by-zone/${id}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiVariablesScadaByZoneIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariablesScadaByZoneId>>,
  TError = unknown,
>(
  id: number,
  params?: GetApiVariablesScadaByZoneIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesScadaByZoneId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiVariablesScadaByZoneIdQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesScadaByZoneId>>
  > = ({ signal }) =>
    getApiVariablesScadaByZoneId(id, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesScadaByZoneId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesScadaByZoneIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesScadaByZoneId>>
>;
export type GetApiVariablesScadaByZoneIdQueryError = unknown;

export function useGetApiVariablesScadaByZoneId<
  TData = Awaited<ReturnType<typeof getApiVariablesScadaByZoneId>>,
  TError = unknown,
>(
  id: number,
  params?: GetApiVariablesScadaByZoneIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesScadaByZoneId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesScadaByZoneIdQueryOptions(
    id,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariablesTaskByPlantId = (
  id: number,
  params?: GetApiVariablesTaskByPlantIdParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/task/by-plant/${id}`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetApiVariablesTaskByPlantIdQueryKey = (
  id?: number,
  params?: GetApiVariablesTaskByPlantIdParams
) => {
  return [
    `/api/Variables/task/by-plant/${id}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiVariablesTaskByPlantIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariablesTaskByPlantId>>,
  TError = unknown,
>(
  id: number,
  params?: GetApiVariablesTaskByPlantIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesTaskByPlantId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiVariablesTaskByPlantIdQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesTaskByPlantId>>
  > = ({ signal }) =>
    getApiVariablesTaskByPlantId(id, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesTaskByPlantId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesTaskByPlantIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesTaskByPlantId>>
>;
export type GetApiVariablesTaskByPlantIdQueryError = unknown;

export function useGetApiVariablesTaskByPlantId<
  TData = Awaited<ReturnType<typeof getApiVariablesTaskByPlantId>>,
  TError = unknown,
>(
  id: number,
  params?: GetApiVariablesTaskByPlantIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesTaskByPlantId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesTaskByPlantIdQueryOptions(
    id,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariablesTaskByZoneId = (
  id: number,
  params?: GetApiVariablesTaskByZoneIdParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Variables/task/by-zone/${id}`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiVariablesTaskByZoneIdQueryKey = (
  id?: number,
  params?: GetApiVariablesTaskByZoneIdParams
) => {
  return [
    `/api/Variables/task/by-zone/${id}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiVariablesTaskByZoneIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariablesTaskByZoneId>>,
  TError = unknown,
>(
  id: number,
  params?: GetApiVariablesTaskByZoneIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesTaskByZoneId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiVariablesTaskByZoneIdQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesTaskByZoneId>>
  > = ({ signal }) =>
    getApiVariablesTaskByZoneId(id, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesTaskByZoneId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesTaskByZoneIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesTaskByZoneId>>
>;
export type GetApiVariablesTaskByZoneIdQueryError = unknown;

export function useGetApiVariablesTaskByZoneId<
  TData = Awaited<ReturnType<typeof getApiVariablesTaskByZoneId>>,
  TError = unknown,
>(
  id: number,
  params?: GetApiVariablesTaskByZoneIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesTaskByZoneId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesTaskByZoneIdQueryOptions(
    id,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariablesScadaByTableId = (
  id: number,
  params?: GetApiVariablesScadaByTableIdParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/scada/by-table/${id}`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetApiVariablesScadaByTableIdQueryKey = (
  id?: number,
  params?: GetApiVariablesScadaByTableIdParams
) => {
  return [
    `/api/Variables/scada/by-table/${id}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiVariablesScadaByTableIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariablesScadaByTableId>>,
  TError = unknown,
>(
  id: number,
  params?: GetApiVariablesScadaByTableIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesScadaByTableId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiVariablesScadaByTableIdQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesScadaByTableId>>
  > = ({ signal }) =>
    getApiVariablesScadaByTableId(id, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesScadaByTableId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesScadaByTableIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesScadaByTableId>>
>;
export type GetApiVariablesScadaByTableIdQueryError = unknown;

export function useGetApiVariablesScadaByTableId<
  TData = Awaited<ReturnType<typeof getApiVariablesScadaByTableId>>,
  TError = unknown,
>(
  id: number,
  params?: GetApiVariablesScadaByTableIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesScadaByTableId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesScadaByTableIdQueryOptions(
    id,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariablesTaskId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Variables/task/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiVariablesTaskIdQueryKey = (id?: number) => {
  return [`/api/Variables/task/${id}`] as const;
};

export const getGetApiVariablesTaskIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariablesTaskId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesTaskId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiVariablesTaskIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesTaskId>>
  > = ({ signal }) => getApiVariablesTaskId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesTaskId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesTaskIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesTaskId>>
>;
export type GetApiVariablesTaskIdQueryError = unknown;

export function useGetApiVariablesTaskId<
  TData = Awaited<ReturnType<typeof getApiVariablesTaskId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesTaskId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesTaskIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariablesTaskByTableId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Variables/task/by-table/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiVariablesTaskByTableIdQueryKey = (id?: number) => {
  return [`/api/Variables/task/by-table/${id}`] as const;
};

export const getGetApiVariablesTaskByTableIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariablesTaskByTableId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesTaskByTableId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiVariablesTaskByTableIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesTaskByTableId>>
  > = ({ signal }) => getApiVariablesTaskByTableId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesTaskByTableId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesTaskByTableIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesTaskByTableId>>
>;
export type GetApiVariablesTaskByTableIdQueryError = unknown;

export function useGetApiVariablesTaskByTableId<
  TData = Awaited<ReturnType<typeof getApiVariablesTaskByTableId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesTaskByTableId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesTaskByTableIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariablesInputByTableId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Variables/input/by-table/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiVariablesInputByTableIdQueryKey = (id?: number) => {
  return [`/api/Variables/input/by-table/${id}`] as const;
};

export const getGetApiVariablesInputByTableIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariablesInputByTableId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesInputByTableId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiVariablesInputByTableIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesInputByTableId>>
  > = ({ signal }) => getApiVariablesInputByTableId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesInputByTableId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesInputByTableIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesInputByTableId>>
>;
export type GetApiVariablesInputByTableIdQueryError = unknown;

export function useGetApiVariablesInputByTableId<
  TData = Awaited<ReturnType<typeof getApiVariablesInputByTableId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesInputByTableId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesInputByTableIdQueryOptions(
    id,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariablesByTableTableIdAndNameVariableName = (
  tableId: number,
  variableName: string,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/byTable/${tableId}/andName/${variableName}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetApiVariablesByTableTableIdAndNameVariableNameQueryKey = (
  tableId?: number,
  variableName?: string
) => {
  return [`/api/Variables/byTable/${tableId}/andName/${variableName}`] as const;
};

export const getGetApiVariablesByTableTableIdAndNameVariableNameQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiVariablesByTableTableIdAndNameVariableName>
  >,
  TError = unknown,
>(
  tableId: number,
  variableName: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiVariablesByTableTableIdAndNameVariableName>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiVariablesByTableTableIdAndNameVariableNameQueryKey(
      tableId,
      variableName
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesByTableTableIdAndNameVariableName>>
  > = ({ signal }) =>
    getApiVariablesByTableTableIdAndNameVariableName(
      tableId,
      variableName,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(tableId && variableName),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getApiVariablesByTableTableIdAndNameVariableName>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesByTableTableIdAndNameVariableNameQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiVariablesByTableTableIdAndNameVariableName>>
  >;
export type GetApiVariablesByTableTableIdAndNameVariableNameQueryError =
  unknown;

export function useGetApiVariablesByTableTableIdAndNameVariableName<
  TData = Awaited<
    ReturnType<typeof getApiVariablesByTableTableIdAndNameVariableName>
  >,
  TError = unknown,
>(
  tableId: number,
  variableName: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiVariablesByTableTableIdAndNameVariableName>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getGetApiVariablesByTableTableIdAndNameVariableNameQueryOptions(
      tableId,
      variableName,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariablesDeviceByPlantPlantId = (
  plantId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Variables/Device/ByPlant/${plantId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiVariablesDeviceByPlantPlantIdQueryKey = (
  plantId?: number
) => {
  return [`/api/Variables/Device/ByPlant/${plantId}`] as const;
};

export const getGetApiVariablesDeviceByPlantPlantIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariablesDeviceByPlantPlantId>>,
  TError = unknown,
>(
  plantId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesDeviceByPlantPlantId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiVariablesDeviceByPlantPlantIdQueryKey(plantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesDeviceByPlantPlantId>>
  > = ({ signal }) =>
    getApiVariablesDeviceByPlantPlantId(plantId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!plantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesDeviceByPlantPlantId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesDeviceByPlantPlantIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesDeviceByPlantPlantId>>
>;
export type GetApiVariablesDeviceByPlantPlantIdQueryError = unknown;

export function useGetApiVariablesDeviceByPlantPlantId<
  TData = Awaited<ReturnType<typeof getApiVariablesDeviceByPlantPlantId>>,
  TError = unknown,
>(
  plantId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesDeviceByPlantPlantId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesDeviceByPlantPlantIdQueryOptions(
    plantId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVariablesTaskTree = (
  params?: GetApiVariablesTaskTreeParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Variables/task/tree`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiVariablesTaskTreeQueryKey = (
  params?: GetApiVariablesTaskTreeParams
) => {
  return [`/api/Variables/task/tree`, ...(params ? [params] : [])] as const;
};

export const getGetApiVariablesTaskTreeQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVariablesTaskTree>>,
  TError = unknown,
>(
  params?: GetApiVariablesTaskTreeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesTaskTree>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiVariablesTaskTreeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesTaskTree>>
  > = ({ signal }) => getApiVariablesTaskTree(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesTaskTree>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesTaskTreeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesTaskTree>>
>;
export type GetApiVariablesTaskTreeQueryError = unknown;

export function useGetApiVariablesTaskTree<
  TData = Awaited<ReturnType<typeof getApiVariablesTaskTree>>,
  TError = unknown,
>(
  params?: GetApiVariablesTaskTreeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesTaskTree>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiVariablesTaskTreeQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiVariablesMetrics = (
  metric: Metric[],
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/metrics`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: metric,
      signal,
    },
    options
  );
};

export const getPostApiVariablesMetricsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVariablesMetrics>>,
    TError,
    { data: Metric[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiVariablesMetrics>>,
  TError,
  { data: Metric[] },
  TContext
> => {
  const mutationKey = ['postApiVariablesMetrics'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiVariablesMetrics>>,
    { data: Metric[] }
  > = props => {
    const { data } = props ?? {};

    return postApiVariablesMetrics(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiVariablesMetricsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiVariablesMetrics>>
>;
export type PostApiVariablesMetricsMutationBody = Metric[];
export type PostApiVariablesMetricsMutationError = unknown;

export const usePostApiVariablesMetrics = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVariablesMetrics>>,
    TError,
    { data: Metric[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiVariablesMetrics>>,
  TError,
  { data: Metric[] },
  TContext
> => {
  const mutationOptions = getPostApiVariablesMetricsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putApiVariablesVariableIdName = (
  variableId: number,
  putApiVariablesVariableIdNameBody: string,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/${variableId}/name`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: putApiVariablesVariableIdNameBody,
    },
    options
  );
};

export const getPutApiVariablesVariableIdNameMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiVariablesVariableIdName>>,
    TError,
    { variableId: number; data: string },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiVariablesVariableIdName>>,
  TError,
  { variableId: number; data: string },
  TContext
> => {
  const mutationKey = ['putApiVariablesVariableIdName'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiVariablesVariableIdName>>,
    { variableId: number; data: string }
  > = props => {
    const { variableId, data } = props ?? {};

    return putApiVariablesVariableIdName(variableId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiVariablesVariableIdNameMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiVariablesVariableIdName>>
>;
export type PutApiVariablesVariableIdNameMutationBody = string;
export type PutApiVariablesVariableIdNameMutationError = unknown;

export const usePutApiVariablesVariableIdName = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiVariablesVariableIdName>>,
    TError,
    { variableId: number; data: string },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiVariablesVariableIdName>>,
  TError,
  { variableId: number; data: string },
  TContext
> => {
  const mutationOptions =
    getPutApiVariablesVariableIdNameMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiVariablesTasksCheckExecutionsInRange = (
  params?: GetApiVariablesTasksCheckExecutionsInRangeParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/tasks/check-executions-in-range`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetApiVariablesTasksCheckExecutionsInRangeQueryKey = (
  params?: GetApiVariablesTasksCheckExecutionsInRangeParams
) => {
  return [
    `/api/Variables/tasks/check-executions-in-range`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiVariablesTasksCheckExecutionsInRangeQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiVariablesTasksCheckExecutionsInRange>
  >,
  TError = unknown,
>(
  params?: GetApiVariablesTasksCheckExecutionsInRangeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesTasksCheckExecutionsInRange>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiVariablesTasksCheckExecutionsInRangeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesTasksCheckExecutionsInRange>>
  > = ({ signal }) =>
    getApiVariablesTasksCheckExecutionsInRange(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesTasksCheckExecutionsInRange>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesTasksCheckExecutionsInRangeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVariablesTasksCheckExecutionsInRange>>
>;
export type GetApiVariablesTasksCheckExecutionsInRangeQueryError = unknown;

export function useGetApiVariablesTasksCheckExecutionsInRange<
  TData = Awaited<
    ReturnType<typeof getApiVariablesTasksCheckExecutionsInRange>
  >,
  TError = unknown,
>(
  params?: GetApiVariablesTasksCheckExecutionsInRangeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiVariablesTasksCheckExecutionsInRange>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getGetApiVariablesTasksCheckExecutionsInRangeQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiVariablesTasksExecuteInRange = (
  executeTasksInRangeRequestDto: ExecuteTasksInRangeRequestDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/tasks/execute-in-range`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: executeTasksInRangeRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiVariablesTasksExecuteInRangeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVariablesTasksExecuteInRange>>,
    TError,
    { data: ExecuteTasksInRangeRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiVariablesTasksExecuteInRange>>,
  TError,
  { data: ExecuteTasksInRangeRequestDto },
  TContext
> => {
  const mutationKey = ['postApiVariablesTasksExecuteInRange'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiVariablesTasksExecuteInRange>>,
    { data: ExecuteTasksInRangeRequestDto }
  > = props => {
    const { data } = props ?? {};

    return postApiVariablesTasksExecuteInRange(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiVariablesTasksExecuteInRangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiVariablesTasksExecuteInRange>>
>;
export type PostApiVariablesTasksExecuteInRangeMutationBody =
  ExecuteTasksInRangeRequestDto;
export type PostApiVariablesTasksExecuteInRangeMutationError = unknown;

export const usePostApiVariablesTasksExecuteInRange = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVariablesTasksExecuteInRange>>,
    TError,
    { data: ExecuteTasksInRangeRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiVariablesTasksExecuteInRange>>,
  TError,
  { data: ExecuteTasksInRangeRequestDto },
  TContext
> => {
  const mutationOptions =
    getPostApiVariablesTasksExecuteInRangeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiVariablesTasksSaveExecutionResultsExecutionId = (
  executionId: string,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/tasks/save-execution-results/${executionId}`,
      method: 'POST',
      signal,
    },
    options
  );
};

export const getPostApiVariablesTasksSaveExecutionResultsExecutionIdMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiVariablesTasksSaveExecutionResultsExecutionId>
      >,
      TError,
      { executionId: string },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiVariablesTasksSaveExecutionResultsExecutionId>
    >,
    TError,
    { executionId: string },
    TContext
  > => {
    const mutationKey = [
      'postApiVariablesTasksSaveExecutionResultsExecutionId',
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiVariablesTasksSaveExecutionResultsExecutionId>
      >,
      { executionId: string }
    > = props => {
      const { executionId } = props ?? {};

      return postApiVariablesTasksSaveExecutionResultsExecutionId(
        executionId,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiVariablesTasksSaveExecutionResultsExecutionIdMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiVariablesTasksSaveExecutionResultsExecutionId>
    >
  >;

export type PostApiVariablesTasksSaveExecutionResultsExecutionIdMutationError =
  unknown;

export const usePostApiVariablesTasksSaveExecutionResultsExecutionId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiVariablesTasksSaveExecutionResultsExecutionId>
    >,
    TError,
    { executionId: string },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiVariablesTasksSaveExecutionResultsExecutionId>
  >,
  TError,
  { executionId: string },
  TContext
> => {
  const mutationOptions =
    getPostApiVariablesTasksSaveExecutionResultsExecutionIdMutationOptions(
      options
    );

  return useMutation(mutationOptions);
};

export const postApiVariablesTasksCheckVariableTask = (
  checkVariableTaskRequestDto: CheckVariableTaskRequestDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/tasks/check-variable-task`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: checkVariableTaskRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiVariablesTasksCheckVariableTaskMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVariablesTasksCheckVariableTask>>,
    TError,
    { data: CheckVariableTaskRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiVariablesTasksCheckVariableTask>>,
  TError,
  { data: CheckVariableTaskRequestDto },
  TContext
> => {
  const mutationKey = ['postApiVariablesTasksCheckVariableTask'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiVariablesTasksCheckVariableTask>>,
    { data: CheckVariableTaskRequestDto }
  > = props => {
    const { data } = props ?? {};

    return postApiVariablesTasksCheckVariableTask(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiVariablesTasksCheckVariableTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiVariablesTasksCheckVariableTask>>
>;
export type PostApiVariablesTasksCheckVariableTaskMutationBody =
  CheckVariableTaskRequestDto;
export type PostApiVariablesTasksCheckVariableTaskMutationError = unknown;

export const usePostApiVariablesTasksCheckVariableTask = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVariablesTasksCheckVariableTask>>,
    TError,
    { data: CheckVariableTaskRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiVariablesTasksCheckVariableTask>>,
  TError,
  { data: CheckVariableTaskRequestDto },
  TContext
> => {
  const mutationOptions =
    getPostApiVariablesTasksCheckVariableTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postApiVariablesTasksTestVariableTask = (
  testVariableTaskRequestDto: TestVariableTaskRequestDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/tasks/test-variable-task`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: testVariableTaskRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiVariablesTasksTestVariableTaskMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVariablesTasksTestVariableTask>>,
    TError,
    { data: TestVariableTaskRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiVariablesTasksTestVariableTask>>,
  TError,
  { data: TestVariableTaskRequestDto },
  TContext
> => {
  const mutationKey = ['postApiVariablesTasksTestVariableTask'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiVariablesTasksTestVariableTask>>,
    { data: TestVariableTaskRequestDto }
  > = props => {
    const { data } = props ?? {};

    return postApiVariablesTasksTestVariableTask(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiVariablesTasksTestVariableTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiVariablesTasksTestVariableTask>>
>;
export type PostApiVariablesTasksTestVariableTaskMutationBody =
  TestVariableTaskRequestDto;
export type PostApiVariablesTasksTestVariableTaskMutationError = unknown;

export const usePostApiVariablesTasksTestVariableTask = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVariablesTasksTestVariableTask>>,
    TError,
    { data: TestVariableTaskRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiVariablesTasksTestVariableTask>>,
  TError,
  { data: TestVariableTaskRequestDto },
  TContext
> => {
  const mutationOptions =
    getPostApiVariablesTasksTestVariableTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiVariablesTasksExecutionResultsExecutionId = (
  executionId: string,
  params?: GetApiVariablesTasksExecutionResultsExecutionIdParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Variables/tasks/execution-results/${executionId}`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetApiVariablesTasksExecutionResultsExecutionIdQueryKey = (
  executionId?: string,
  params?: GetApiVariablesTasksExecutionResultsExecutionIdParams
) => {
  return [
    `/api/Variables/tasks/execution-results/${executionId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiVariablesTasksExecutionResultsExecutionIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiVariablesTasksExecutionResultsExecutionId>
  >,
  TError = unknown,
>(
  executionId: string,
  params?: GetApiVariablesTasksExecutionResultsExecutionIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiVariablesTasksExecutionResultsExecutionId>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiVariablesTasksExecutionResultsExecutionIdQueryKey(
      executionId,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiVariablesTasksExecutionResultsExecutionId>>
  > = ({ signal }) =>
    getApiVariablesTasksExecutionResultsExecutionId(
      executionId,
      params,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!executionId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVariablesTasksExecutionResultsExecutionId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiVariablesTasksExecutionResultsExecutionIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiVariablesTasksExecutionResultsExecutionId>>
  >;
export type GetApiVariablesTasksExecutionResultsExecutionIdQueryError = unknown;

export function useGetApiVariablesTasksExecutionResultsExecutionId<
  TData = Awaited<
    ReturnType<typeof getApiVariablesTasksExecutionResultsExecutionId>
  >,
  TError = unknown,
>(
  executionId: string,
  params?: GetApiVariablesTasksExecutionResultsExecutionIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiVariablesTasksExecutionResultsExecutionId>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getGetApiVariablesTasksExecutionResultsExecutionIdQueryOptions(
      executionId,
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiVariablesBulkIdPlanta = (
  idPlanta: number,
  bulkVariableScadaDto: BulkVariableScadaDto[],
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/VariablesBulk/${idPlanta}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: bulkVariableScadaDto,
      signal,
    },
    options
  );
};

export const getPostApiVariablesBulkIdPlantaMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVariablesBulkIdPlanta>>,
    TError,
    { idPlanta: number; data: BulkVariableScadaDto[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiVariablesBulkIdPlanta>>,
  TError,
  { idPlanta: number; data: BulkVariableScadaDto[] },
  TContext
> => {
  const mutationKey = ['postApiVariablesBulkIdPlanta'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiVariablesBulkIdPlanta>>,
    { idPlanta: number; data: BulkVariableScadaDto[] }
  > = props => {
    const { idPlanta, data } = props ?? {};

    return postApiVariablesBulkIdPlanta(idPlanta, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiVariablesBulkIdPlantaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiVariablesBulkIdPlanta>>
>;
export type PostApiVariablesBulkIdPlantaMutationBody = BulkVariableScadaDto[];
export type PostApiVariablesBulkIdPlantaMutationError = unknown;

export const usePostApiVariablesBulkIdPlanta = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVariablesBulkIdPlanta>>,
    TError,
    { idPlanta: number; data: BulkVariableScadaDto[] },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiVariablesBulkIdPlanta>>,
  TError,
  { idPlanta: number; data: BulkVariableScadaDto[] },
  TContext
> => {
  const mutationOptions =
    getPostApiVariablesBulkIdPlantaMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getWsIngest = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/ws/ingest`, method: 'GET', signal },
    options
  );
};

export const getGetWsIngestQueryKey = () => {
  return [`/ws/ingest`] as const;
};

export const getGetWsIngestQueryOptions = <
  TData = Awaited<ReturnType<typeof getWsIngest>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWsIngest>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWsIngestQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWsIngest>>> = ({
    signal,
  }) => getWsIngest(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWsIngest>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWsIngestQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWsIngest>>
>;
export type GetWsIngestQueryError = unknown;

export function useGetWsIngest<
  TData = Awaited<ReturnType<typeof getWsIngest>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWsIngest>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWsIngestQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getWsIngestInfo = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/ws/ingest/info`, method: 'GET', signal },
    options
  );
};

export const getGetWsIngestInfoQueryKey = () => {
  return [`/ws/ingest/info`] as const;
};

export const getGetWsIngestInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getWsIngestInfo>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWsIngestInfo>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWsIngestInfoQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWsIngestInfo>>> = ({
    signal,
  }) => getWsIngestInfo(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWsIngestInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWsIngestInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWsIngestInfo>>
>;
export type GetWsIngestInfoQueryError = unknown;

export function useGetWsIngestInfo<
  TData = Awaited<ReturnType<typeof getWsIngestInfo>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWsIngestInfo>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWsIngestInfoQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getWsStatus = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/ws/status`, method: 'GET', signal },
    options
  );
};

export const getGetWsStatusQueryKey = () => {
  return [`/ws/status`] as const;
};

export const getGetWsStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getWsStatus>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWsStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWsStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWsStatus>>> = ({
    signal,
  }) => getWsStatus(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWsStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWsStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWsStatus>>
>;
export type GetWsStatusQueryError = unknown;

export function useGetWsStatus<
  TData = Awaited<ReturnType<typeof getWsStatus>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWsStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWsStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getWsTestUpgrade = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/ws/test-upgrade`, method: 'GET', signal },
    options
  );
};

export const getGetWsTestUpgradeQueryKey = () => {
  return [`/ws/test-upgrade`] as const;
};

export const getGetWsTestUpgradeQueryOptions = <
  TData = Awaited<ReturnType<typeof getWsTestUpgrade>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWsTestUpgrade>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWsTestUpgradeQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWsTestUpgrade>>
  > = ({ signal }) => getWsTestUpgrade(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWsTestUpgrade>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWsTestUpgradeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWsTestUpgrade>>
>;
export type GetWsTestUpgradeQueryError = unknown;

export function useGetWsTestUpgrade<
  TData = Awaited<ReturnType<typeof getWsTestUpgrade>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWsTestUpgrade>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWsTestUpgradeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiZones = (
  params?: GetApiZonesParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Zones`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiZonesQueryKey = (params?: GetApiZonesParams) => {
  return [`/api/Zones`, ...(params ? [params] : [])] as const;
};

export const getGetApiZonesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiZones>>,
  TError = unknown,
>(
  params?: GetApiZonesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiZones>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiZonesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiZones>>> = ({
    signal,
  }) => getApiZones(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiZones>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiZonesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiZones>>
>;
export type GetApiZonesQueryError = unknown;

export function useGetApiZones<
  TData = Awaited<ReturnType<typeof getApiZones>>,
  TError = unknown,
>(
  params?: GetApiZonesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiZones>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiZonesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiZones = (
  createZoneDto: CreateZoneDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CreateResponseDto>(
    {
      url: `/api/Zones`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createZoneDto,
      signal,
    },
    options
  );
};

export const getPostApiZonesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiZones>>,
    TError,
    { data: CreateZoneDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiZones>>,
  TError,
  { data: CreateZoneDto },
  TContext
> => {
  const mutationKey = ['postApiZones'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiZones>>,
    { data: CreateZoneDto }
  > = props => {
    const { data } = props ?? {};

    return postApiZones(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiZonesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiZones>>
>;
export type PostApiZonesMutationBody = CreateZoneDto;
export type PostApiZonesMutationError = unknown;

export const usePostApiZones = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiZones>>,
    TError,
    { data: CreateZoneDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiZones>>,
  TError,
  { data: CreateZoneDto },
  TContext
> => {
  const mutationOptions = getPostApiZonesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiZonesId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Zones/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiZonesIdQueryKey = (id?: number) => {
  return [`/api/Zones/${id}`] as const;
};

export const getGetApiZonesIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiZonesId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiZonesId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiZonesIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiZonesId>>> = ({
    signal,
  }) => getApiZonesId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiZonesId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiZonesIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiZonesId>>
>;
export type GetApiZonesIdQueryError = unknown;

export function useGetApiZonesId<
  TData = Awaited<ReturnType<typeof getApiZonesId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiZonesId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiZonesIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiZonesId = (
  id: number,
  zoneDto: ZoneDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    {
      url: `/api/Zones/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: zoneDto,
    },
    options
  );
};

export const getPutApiZonesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiZonesId>>,
    TError,
    { id: number; data: ZoneDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiZonesId>>,
  TError,
  { id: number; data: ZoneDto },
  TContext
> => {
  const mutationKey = ['putApiZonesId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiZonesId>>,
    { id: number; data: ZoneDto }
  > = props => {
    const { id, data } = props ?? {};

    return putApiZonesId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiZonesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiZonesId>>
>;
export type PutApiZonesIdMutationBody = ZoneDto;
export type PutApiZonesIdMutationError = unknown;

export const usePutApiZonesId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiZonesId>>,
    TError,
    { id: number; data: ZoneDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiZonesId>>,
  TError,
  { id: number; data: ZoneDto },
  TContext
> => {
  const mutationOptions = getPutApiZonesIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteApiZonesId = (
  id: number,
  params?: DeleteApiZonesIdParams,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CreateEditRemoveResponseDto>(
    { url: `/api/Zones/${id}`, method: 'DELETE', params },
    options
  );
};

export const getDeleteApiZonesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiZonesId>>,
    TError,
    { id: number; params?: DeleteApiZonesIdParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiZonesId>>,
  TError,
  { id: number; params?: DeleteApiZonesIdParams },
  TContext
> => {
  const mutationKey = ['deleteApiZonesId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiZonesId>>,
    { id: number; params?: DeleteApiZonesIdParams }
  > = props => {
    const { id, params } = props ?? {};

    return deleteApiZonesId(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiZonesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiZonesId>>
>;

export type DeleteApiZonesIdMutationError = unknown;

export const useDeleteApiZonesId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiZonesId>>,
    TError,
    { id: number; params?: DeleteApiZonesIdParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiZonesId>>,
  TError,
  { id: number; params?: DeleteApiZonesIdParams },
  TContext
> => {
  const mutationOptions = getDeleteApiZonesIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getApiZonesByPlantId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/Zones/ByPlant/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiZonesByPlantIdQueryKey = (id?: number) => {
  return [`/api/Zones/ByPlant/${id}`] as const;
};

export const getGetApiZonesByPlantIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiZonesByPlantId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiZonesByPlantId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiZonesByPlantIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiZonesByPlantId>>
  > = ({ signal }) => getApiZonesByPlantId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiZonesByPlantId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiZonesByPlantIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiZonesByPlantId>>
>;
export type GetApiZonesByPlantIdQueryError = unknown;

export function useGetApiZonesByPlantId<
  TData = Awaited<ReturnType<typeof getApiZonesByPlantId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiZonesByPlantId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiZonesByPlantIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiZonesExcel = (
  createZoneDto: CreateZoneDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/Zones/Excel`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createZoneDto,
      signal,
    },
    options
  );
};

export const getPostApiZonesExcelMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiZonesExcel>>,
    TError,
    { data: CreateZoneDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiZonesExcel>>,
  TError,
  { data: CreateZoneDto },
  TContext
> => {
  const mutationKey = ['postApiZonesExcel'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiZonesExcel>>,
    { data: CreateZoneDto }
  > = props => {
    const { data } = props ?? {};

    return postApiZonesExcel(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiZonesExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiZonesExcel>>
>;
export type PostApiZonesExcelMutationBody = CreateZoneDto;
export type PostApiZonesExcelMutationError = unknown;

export const usePostApiZonesExcel = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiZonesExcel>>,
    TError,
    { data: CreateZoneDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postApiZonesExcel>>,
  TError,
  { data: CreateZoneDto },
  TContext
> => {
  const mutationOptions = getPostApiZonesExcelMutationOptions(options);

  return useMutation(mutationOptions);
};
